import { Component, OnInit, AfterViewInit, HostListener, Renderer2, ElementRef, TemplateRef, ViewChild, PLATFORM_ID, Inject, OnDestroy, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, ChangeDetectorRef } from '@angular/core';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { CommonModule, isPlatformBrowser, DatePipe, Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import * as Croppie from 'croppie';
import { CroppieDirective } from 'angular-croppie-module';
import { MessageService } from '../../message.service';
import { CroppieService } from '../../services/croppie.service';
import { Experience } from '../../services/experience.service';
import { environment } from '../../../environments/environment';
import { AddExperience } from '../../services/AddExperience.service';
import { Subject, Subscription } from 'rxjs';
import { CartService } from '../../services/cart.service';
import { ExperienceDetailsService } from '../../services/experience-details.service';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ImageCroppedEvent, ImageTransform } from '../../image-cropper/interfaces/index';
import { ExperienceBookingService } from '../../services/ExperienceBooking.service';
import { UserProfileService } from '../../services/Userprofile.service';
import { MainService } from '../../main.service';
import { ExperienceShare } from '../../services/experienceShare.service';
import { RegisterService } from '../../services/Register.service';
import * as globalConstant from '../../global_constant';
import { ExperienceProviderAvailablityService } from '../../services/ExperienceProviderAvailablityService.service';
import html2canvas from 'html2canvas';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ProfileService } from '../../profile-image.service';
import { AuthdataMessageService } from '../../authdata-message.service';
import { FindCouple } from '../../services/findcouple.service';
import { LocationService } from '../../services/location.service';
import { FbService } from '../../services/Fb.service';
import { debounceTime, tap, throttleTime } from 'rxjs/operators';
import { ExperienceProviderPromotionalService } from '../../services/ExperienceProviderPromotionalService.service';
import { VisitorsService } from '../../services/Visitors.service';
import SwiperCore, { Swiper } from 'swiper';
import { SearchCountryField, CountryISO, NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../share/shared.module';
import { EpSubheaderComponent } from '../ep-dashboard/ep-subheader/ep-subheader.component';
import { AdditionalSubheaderComponent } from '../additional-user-after-login/additional-subheader/additional-subheader.component';
import { WeddingCoupleSubheaderComponent } from '../wedding-couple-after-login/wedding-couple-subheader/wedding-couple-subheader.component';
import { IndividualSubheaderComponent } from '../individual-after-login/individual-subheader/individual-subheader.component';
import { CharitySubHeaderComponent } from '../charity-after-login/charity-sub-header/charity-sub-header.component';
import { HomeService } from 'src/app/services/Home.service';
import { ToastrService } from 'src/app/services/toastr.service';
import { TrimPipe } from 'src/app/trim.pipe';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { EncryptionService } from 'src/app/services/encryption.service';

declare var $: any;
declare const fbq;
declare var pintrk: any;

@Component({
	selector: 'vebo-header',
	standalone: true,
	imports: [
		CharitySubHeaderComponent,
		IndividualSubheaderComponent,
		WeddingCoupleSubheaderComponent,
		AdditionalSubheaderComponent,
		EpSubheaderComponent,
		CommonModule,
		SharedModule,
		NgxIntlTelInputModule,
		TrimPipe,
		MatSelectModule,
		MatFormFieldModule,
		FormsModule,
		DropdownModule,
		MultiSelectModule
	],
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css'],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
	host: { ngSkipHydration: 'true' }
})

export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild('dateCalendarElement1') dateCalendarElement1: ElementRef;
	phoneValidation: boolean = true;
	@ViewChild('directive', { static: true })
	public croppieDirective: CroppieDirective;
	@ViewChild('directive1', { static: true })
	public croppieThankYouImageDirective: CroppieDirective;
	@ViewChild('directive2', { static: true })
	public croppieShareImageDirective: CroppieDirective;
	@ViewChild('buymodal', { static: false }) public buymodal: ModalDirective;
	@ViewChild('sharePhotoElement', { static: false }) sharePhotoElement: ElementRef;
	@ViewChild('gratuityModal', { static: false }) public gratuityModal: ModalDirective;
	@ViewChild('thankyouModal', { static: false }) public thankyouModal: ModalDirective;
	@ViewChild('addPhotoVideoModal', { static: false }) public addPhotoVideoModal: ModalDirective;
	@ViewChild('experienceDetailsPopup', { static: false }) public experienceDetailsPopup: ModalDirective;
	@ViewChild('photoShareCroppieModal', { static: false }) public photoShareCroppieModal: ModalDirective;
	@ViewChild('thankYouCroppieModal', { static: false }) public thankYouCroppieModal: ModalDirective;
	@ViewChild('upload_profile', { static: false }) public upload_profile: ModalDirective;
	@ViewChild('large', { static: false }) public large: ModalDirective;
	@ViewChild('upload_cover_profile_image', { static: false }) public upload_cover_profile_image: ModalDirective;
	@ViewChild('largecoverimage', { static: false }) public largecoverimage: ModalDirective;
	@ViewChild('fbAlbumPopup', { static: false }) public fbAlbumPopup: ModalDirective;
	@ViewChild('partialPurchasePopup', { static: false }) public partialPurchasePopup: ModalDirective;
	@ViewChild('congratulationPopup', { static: false }) public congratulationPopup: ModalDirective;
	@ViewChild('timerCouplePopup', { static: false }) public timerCouplePopup: ModalDirective;
	@ViewChild('videoPopupModal', { static: false }) public videoPopupModal: ModalDirective;
	@ViewChild("toggleButton", { static: false }) toggleButton: ElementRef;
	@ViewChild("menu", { static: false }) menu: ElementRef;
	@ViewChild('review_accordion_element') review_accordion_element: ElementRef<HTMLElement>;
	@ViewChild('videoElement', { static: false }) videoElement: ElementRef;
	maxRequireVisitorsDate: {}
	calendarOptions: any = []
	isRenderingDates: any = false
	minimumDate: any = {};
	availableDatesArr: any = []
	isTimeSelected: any = false
	tourcms_component_key: any
	booking_slot_index: any = '';
	buyVoucherPeople = 0
	total_sales_gratuity: any = 0
	voucher_select_data: any = {}
	dropdownRef: BsModalRef;
	getTipSubscription: Subscription
	gratuityAmount: any = ''
	imgFrmeUrlCover: any = '';
	tourcms_channel_id: any
	booking_date_selected: any = ''
	pickupLocationList: any = []
	pickupLocations = {};
	removeImg: any = '';
	swiperCore: any = SwiperCore;
	isBrowser: boolean;
	is_gratuity: any = false
	authCheck: boolean = false;
	showMore: any = false
	authUser: any;
	additionalImagesJoinUs: any = []
	noBeforeYouGoArr: any = []
	expIncludedArr: any = []
	expNotIncludedArr: any = []
	expAvailabilityArr: any = []
	expAvailabilityMonth: any = []
	expAvailabilityDay: any;
	staticFrames: any = []
	countryList: any = []
	blockBookingDates: any = []
	enableBookingDates: any = []
	profile_img_url = '';
	profile_image = '';
	show_refund_button: any = false
	enableBookNowButton = false;
	experienceEasternData = [];
	WEDDING_COUPLE_ROLE_ID = `${environment.WEDDING_COUPLE_ROLE_ID}`;
	EXPERIENCE_PROVIDER_ROLE_ID = `${environment.EXPERIENCE_PROVIDER_ROLE_ID}`;
	CHARITY_USER_ROLE_ID = `${environment.CHARITY_USER_ROLE_ID}`;
	INDIVIDUAL_USER_ROLE_ID = `${environment.INDIVIDUAL_USER_ROLE_ID}`;
	BBB_USER_ROLE_ID = `${environment.BBB_USER_ROLE_ID}`;
	BBB_BABY_USER_ROLE_ID = `${environment.BBB_BABY_USER_ROLE_ID}`;
	CUSTOMER_SUPPORT_ROLE_ID = `${environment.CUSTOMER_SUPPORT_ROLE_ID}`;
	ALTERNATE_EXPERIENCE_PROVIDER_ROLE_ID = `${environment.ALTERNATE_EXPERIENCE_PROVIDER_ROLE_ID}`;
	REGISTERFINDER_ROLE_ID = `${environment.REGISTERFINDER_ROLE_ID}`;
	KNOT_USER_ROLE_ID = `${environment.KNOT_USER_ROLE_ID}`;
	JOY_USER_ROLE_ID = `${environment.JOY_USER_ROLE_ID}`;
	ZOLA_USER_ROLE_ID = `${environment.ZOLA_USER_ROLE_ID}`;
	THNKS_USER_ROLE_ID = `${environment.THNKS_USER_ROLE_ID}`;
	SENDOSO_USER_ROLE_ID = `${environment.SENDOSO_USER_ROLE_ID}`;
	POSTAL_USER_ROLE_ID = `${environment.POSTAL_USER_ROLE_ID}`;
	cart_details: any = []
	map_zoom = 6;
	thankYouUploadedImages: any = []
	want_to_refund_cancel: any = false
	want_to_refund_confirm: any = false
	is_cart_fill: boolean = false;
	close_card: boolean = false;
	albumStep1: boolean = false;
	albumStep2: boolean = false;
	total_sales_tax: any = 0;
	total_cart_amount: any = 0;
	show_card_details: any = false;
	currentURL: any = ''
	currentURL1: any = ''
	cartDetails: any[] = [];
	expWhatsIncluded: any[] = [];
	expWhatsNotIncluded: any[] = [];
	subscription: Subscription;
	experienceDetailSubscription: Subscription;
	FbAlbumSubscription: Subscription;
	modalPopChangeSubscription: Subscription;
	addExpCountSubscription: Subscription;
	walletAmountSubscription: Subscription;
	authDataMessageSubscription: Subscription;
	coupleTimerMessageSubscription: Subscription;
	authDataMessageProfilePicSubscription: Subscription;
	getCartPaymentMsgSubscription: Subscription;
	getCartMessageSubscription: Subscription;
	getLogoutMessageSubscription: Subscription;
	getPhotoVideoSubscription: Subscription;
	getGiftCertificateSubscription: Subscription;
	showDetailsTab: boolean = false;
	joinUsFormSubmitEnable: boolean = false;
	showExchangeTab: boolean = false;
	showGiftedByTab: boolean = false;
	showPhotosVideosTab: boolean = false;
	showSummeryTab: boolean = false;
	showHowToRedeemTab: boolean = false;
	showPartialPurchTab: boolean = false;
	showReviewTab: boolean = false;
	showJoinUsTab: boolean = false;
	showRemoveRegBtn: boolean = false;
	showAddRegBtn: boolean = false;
	showBuyYourSelfBtn: boolean = false;
	showBuyAsGiftBtn: boolean = false;
	showCloseBtn: boolean = false;
	showReviewExpBtn: boolean = false;
	showAddPhotoVideoBtn: boolean = false;
	showSendThankYouBtn: boolean = false;
	showAddPhotoDeviceBtn: boolean = false;
	showAddVideoDeviceBtn: boolean = false;
	showRedeemScheduleBtn: boolean = false;
	showExchangeBtn: boolean = false;
	showViewPrintBtn: boolean = false;
	showScheduleExpBtn: boolean = false;
	showViewAvaibalityExpBtn: boolean = false;
	newBookingRequestBtn: boolean = false;
	showRedeemNowBtn: boolean = false;
	showExcConfirmBtn: boolean = false;
	showExcCancelBtn: boolean = false;
	showCompletePurchBtn: boolean = false;
	showContinueShopBtn: boolean = false;
	showCheckoutBtn: boolean = false;
	showBackBtn: boolean = false;
	showEwalletBalance: boolean = false;
	priceBlock: boolean = true;
	imageSaveMsgShow: boolean = false;
	exchangeBlock: boolean = false;
	exchangedBlock: boolean = false;
	redeemScheduleBlock: boolean = false;
	onlineScheduleBlock: boolean = false;
	onlineBookingMsgBlock: boolean = false;
	onlineBookingRejectBlock: boolean = false;
	reviewRatingBlock: boolean = false;
	redeemedBlock: boolean = false;
	exhangePrice: number = 0;
	showConfirm: boolean = false;
	showCancel: boolean = false;
	shareProcess: boolean = false;
	guestViewPopup: boolean = false;
	showSeasonHeadline: boolean = false;
	group_pricing_exp: boolean;
	tokenkey: any = '';
	slug: any;
	isActiveTab: string = 'summary';
	fbImageType: string = '';
	timerString: string = '';
	experienceDetails: any = [];
	additionalImages: any = [];
	showExperienceDetailsPopup: boolean = false;
	OnlineSchedulingForm: FormGroup;
	minDate: Date;
	bookingDate: string = '';
	bookingStatus: string = '';
	bookingMessage: string = '';
	bookingShortMessage: string = '';
	cropyUserType: any = '';
	showRegChkmark: boolean = false;
	is_guest_view: boolean = false;
	resultOurRegistry: any = [];
	purchaseExpID: any;
	purchaseExpSlug: any;
	purchaseExpTitle: any;
	purchaseExpImage: any;
	purchaseExpType: any;
	purchaseExpPrice: any;
	purchaseExpQuantity: any;
	purchaseExpVerID: any;
	purchaseExpTax: any;
	thankYouStep1: boolean = false;
	thankYouStep2: boolean = false;
	thankYouStep3: boolean = false;
	thankYouStep4: boolean = false;
	thankYouStep5: boolean = false;
	photoVideoStep1: boolean = false;
	ShareVideoStep1: boolean = false;
	photoVideoStep2: boolean = false;
	photoVideoStep3: boolean = false;
	isLoading: boolean = false;
	showAddExpBtns: boolean = false;
	firstNavigationTimer: boolean = false;
	couple_name: string = '';
	transform: ImageTransform = {};
	frameImages: any = []
	images: any = []
	wallet_balance: any = "0.00";
	thankYouImages: any = []
	cover_image_url = '';
	thankyouImage = '';
	experience_video_url: SafeResourceUrl;
	ThankyouProcessForm: FormGroup;
	thank_you_file_path: any = '';
	thank_you_file_url: any = '';
	thankYouEmailReceipents = '';
	shareImages: any = []
	matchingValuesExist: any = false
	choosedSharePhotoUrl: any = '';
	choosedFacebookPhotoUrl: any = '';
	choosedCoverPhotoUrl: any = '';
	slot: any = '';
	facebookAlbums: any = [];
	choosedFacebookAlbums: any = [];
	show_close_button = false;
	fileFormat: any = "";
	yesterday: any = '';
	isLogin: boolean = false;
	addedtocart: boolean = false;
	cart_items: any = ""
	disableCartBtn: boolean = true;
	selectedUnit: any = 0;
	webNavigation: number = 0;
	timerIntervalFunc: any;
	thankYouImageId: any = 0;
	user_data: any = [];
	username: string = '';
	joinUsUnits: any = [];
	purchaseUnit: any = 0;
	remainingUnits: number = 0
	units: any = [];
	guest_user_data: any = {};
	other_page_data = '';
	showRedeemNowConfirm: boolean = false;
	showRedeemNowCancel: boolean = false;
	no_slot_avail_message: any = '';
	end_navigate_stop = false;
	Loading: any = false;
	pop_first_content: any = true;
	pop_second_content: any = false;
	search_string: any = '';
	couple_image_url: any = '';
	show_couple: any = false;
	no_couple_data_found: any = false;
	pop_third_content: any = false;
	data1: any = '';
	selected_couple: any = '';
	amount: number = 0;
	modelChanged: Subject<string> = new Subject<string>();
	amount_required_error: boolean = false;
	page: number = 1;
	certificate_data: any = '';
	timerEndStr: any = '';
	hide_back_button: any = true;
	gift_certificate_couple_full_name: any = "";
	show_congratulation: boolean;
	backfromRedemmeScheduleBtn: any = false;
	names_arr: any = globalConstant.INVAILD_NAME_STR;
	web_cdn_url: String = globalConstant.WEB_CDN_URL;
	thankyou_message_is_blank = false;
	thankYouMessage_error = true;
	locationList: any = [];
	locationAutocompleteList: any = [];
	autocomplete_location_search: string = '';
	enable_rfp_229: any = globalConstant.ENABLE_RFP_229;
	people_data: any = [];
	selected_people: number = 0;
	maximumDate: any = '';
	maximumDOB: any;
	thumbsSwiper: any;
	show_instant_booking: boolean = false;
	booking_price: number = 0;
	booking_price_with_tax: number = 0;
	seasonLabel: boolean = false;
	instant_book_request: number = 0;
	formated_time: string = ''
	book_quantity_options: any = [];
	max_quantity_count: number = 10;
	enableDates: any = [];
	enableDates2: any = [];
	promo_price: number = 0;
	promo_individual_price: number = 0;
	is_exp_purchased: boolean = false;
	selected_hotel: any = 0;
	display_book_number: any = '';
	variant_id: any = '';
	book_number: any = '';
	seat_label: any;
	booking_type: number = 0;
	hornblower_category: string = "";
	product_code: string = '';
	time_options: any;
	urlSubscription: Subscription
	inputJSON = {
		"endtime": "2017-04-13 23:00:00",
		"starttime": "2017-04-13 01:00:00"
	};
	deepUrl: any;
	urlData: any;
	urlParamData: any = {};
	isBannerHidden: any = true;
	priceGroup_id: any;
	selectedLocation: any = '';
	participantTypeAlias: any;
	locationListSubscription: Subscription;
	scrollTop() {
		if (this.isBrowser) {
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		}
	}
	clickCart: any = "";
	congratulationPopupConfig = {
		backdrop: false,
		ignoreBackdropClick: true,
	};
	owladdPhoto: OwlOptions = {
		items: 4,
		dots: false,
		nav: true,
		autoplay: false,
		loop: false,
		margin: 5,
		rewind: true,
		navText: ["<span class='arrowLeft'></span>",
			"<span class='arrowRight'></span>"],

		smartSpeed: 500,
	}
	owlExpDetailJoin: OwlOptions = {
		loop: false,
		mouseDrag: false,
		autoplay: true,
		touchDrag: true,
		pullDrag: false,
		dots: false,
		autoWidth: true,
		navSpeed: 700,
		navText: ['1', '2'],
		nav: false,
		items: 1,
		rewind: true,
		margin: 20

	}
	public croppieShareOptions: Croppie.CroppieOptions = {
		boundary: { width: 500, height: 250 },
		viewport: { width: 500, height: 250 },
		showZoomer: true,
		enableExif: true,
		enableOrientation: true,
	};
	public croppieOptions: Croppie.CroppieOptions = {
		boundary: { width: 300, height: 300 },
		viewport: { width: 128, height: 128 },
		showZoomer: true,
		enableExif: true,
		enableOrientation: true,
	};
	public croppieprofile: Croppie.CroppieOptions = {
		boundary: { width: 300, height: 300 },
		viewport: { width: 250, height: 250, type: 'square' },
		showZoomer: true,
		enableOrientation: true,
	};
	shareType: string = '';
	share_video_path: any;
	choosedShareVideoUrl: any = '';
	PhotoVideoShareForm: FormGroup;
	imageSaveMsg: string = '';
	uploadedPhotoVideoUrl: string = '';
	photoVideoSaveStatus: boolean = false;
	shareFacebookStatus: boolean = false;
	completeSharingProcess: boolean = false;
	showUploadProfileText: boolean = false;
	showCountDownText: boolean = false;
	showCountDownTextPopup: boolean = false;
	timerEndDate: any = "";
	timerStartDate: any = "";
	is_profile_edit: boolean = false;
	is_cover_edit: boolean = false
	img_type = 'profile_image_crop';
	coverimages: any = []
	croppedImage: any = '';
	crop_image_type: string = 'profile_image';
	imageChangedEvent: any = '';
	is_cover_image_edit: any = 0;
	containWithinAspectRatio = false;
	showCoverImageCropper = false;
	canvasRotation = 0;
	rotation = 0;
	scale = 1;
	selected_name: any
	selected_qty: any = 1
	coupleRoleID = globalConstant.WEDDING_COUPLE_ROLE_ID
	facebookSocialLink = globalConstant.FACEBOOK_SOCIAL_LINK
	linkedinSocialLink = globalConstant.LINKEDIN_SOCIAL_LINK
	pinterestSocialLink = globalConstant.PINTEREST_SOCIAL_LINK
	instagramSocialLink = globalConstant.INSTAGRAM_SOCIAL_LINK
	tiktokSocialLink = globalConstant.TIKTOK_SOCIAL_LINK
	androidAppDownloadLink = globalConstant.ANDROID_APP_DOWNLOAD_LINK
	iphoneAppDownloadLink = globalConstant.IOS_APP_DOWNLOAD_LINK
	mobileDeviceName: string = '';
	enable_rfp_226 = globalConstant.ENABLE_RFP_226
	requestedDate: any = '';
	submitted = false;
	request_to_book = true;
	show_fareharbor = false;
	minimum_party_size: any;

	fareharborForm: FormGroup;
	fare_harbor_slot_data: any;
	booking_slot_data: any = '';
	fare_harbor_custom_data: any = [];
	fare_harbor_custom_user_data: any[] = [];
	index: any = '';
	dynamic_option_array: any = [];
	todayDate: any = "";
	lastDate: any = "";
	counter = 0;
	categoryList_for_gift_ideas: any = '';
	categoryList_for_experiece: any = '';
	exp_video: any;
	@ViewChild('suggestedExperiencePopup', { static: false }) public suggestedExperiencePopup: ModalDirective;
	avail_child_exp = false;
	modalRef: BsModalRef;
	main_exp_id: any = '';
	type_identity = '';
	resultExp: any = '';
	suggestionData: any = [];
	data_for_dropdown_in_popup: any = '';
	experienceGroupPricingSubscription: Subscription;
	pricing_popup: boolean;
	date_value: any = '';
	totalAdded: any = 0;
	totalJoinusPrice: number = 0
	totalJoinExp: number = 0
	joinUsSelectedUnit = 0;
	sales_tax = 0;
	joinUsName = ""
	totalAmount: any = 0;
	isMenuOpen = false;
	public text: String;
	autocompleteExpResults: any = [];
	show_user_name_input: boolean = false;
	hotel_data: any = [];
	peek_unit_id: string = "";
	peek_availability_id: string = "";
	ventrata_unit_id: string = "";
	ventrata_availability_id: string = ""
	name_error: boolean = false;
	is_mobile_view: boolean = false;
	show_smart_app_banner: boolean = false;
	showPromoCalendar: boolean = false;
	isBoat: boolean = false;
	wedding_date: string = "";
	requires_visitors_details: any = [];
	isCancellable = false;
	isTiktokShow = false;
	separateDialCode = true;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
	preferredCountries: CountryISO[] = [CountryISO.UnitedStates];
	@ViewChild('dropdownElement') dropdownElement: ElementRef;
	@ViewChild('dropdownElement2') dropdownElement2: ElementRef;
	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (this.eRef.nativeElement.contains(event.target)) {
		} else {
			if (this.isBrowser) {
				var element = document.querySelector("body");
				var htmlelement = document.querySelector("html")
				if (element) {
					element.classList.remove('overflow');
				}
				if (htmlelement) {
					htmlelement.classList.remove('overflow');
				}
			}
		}
	}
	isModalOpen = false;
	isHeaderSticky = false;
	expDetailText: string = '';
	truncatedHtml: string = '';

	@ViewChild('myModal') myModal: ElementRef;
	onScroll(event: Event) {
		const scrollTop = (event.target as HTMLElement).scrollTop;
		this.isHeaderSticky = scrollTop > 50;
	}
	rezdy_fields_data: any = [];
	rezdy_custom_fields: any = [];
	rezdy_custom_user_fields: any = [];
	TitleDataRezdy = [
		{ value: 'MR' },
		{ value: 'MS' },
		{ value: 'MRS' },
		{ value: 'MISS' }
	];

	GenderDataRezdy = [
		{ value: 'MALE' },
		{ value: 'FEMALE' },
	];

	CountryListDataRezdy: any = [];
	demographic_id: any;
	displayRequiredMessageForPeopleCount: boolean = false;
	dateSelectedLoader: boolean = false;
	@ViewChild('mainSwiper') mainSwiperElement: ElementRef;
	mainSwiper: Swiper | null = null;
	firstNameValue: string = '';
	lastNameValue: string = '';
	cachedDates: Map<string, any[]> = new Map();
	hornBlowerDynamicFields: any;
	hornBlowerCustomFields: any;
	emailErrorTiquets: boolean = false;
	emailErrorCustomField: boolean = false;
	selectedCountry: string = 'us';
	dropdownOptions: any;
	linkTwistFields: any;
	linkTwistCustomFields: any;
	cancelReason: string = '';
	selectedReason: string = '';
	otherReason: string = '';
	@ViewChild('cancelModal', { static: false }) public cancelModal: ModalDirective;
	@ViewChild('confirmCancelModal', { static: false }) public confirmCancelModal: ModalDirective;
	cancelReasons = [
		{ value: 'change_of_plans', label: 'Change of plans' },
		{ value: 'personal_emergency', label: 'Unexpected personal emergency' },
		{ value: 'better_alternative', label: 'Found a better alternative' },
		{ value: 'unable_to_travel', label: 'Unable to travel/visit' },
		{ value: 'poor_weather', label: 'Poor weather conditions' },
		{ value: 'mistaken_booking', label: 'Booking made by mistake' },
		{ value: 'cost_concerns', label: 'Cost concerns' },
		{ value: 'other', label: 'Other (Please specify)' }
	];
	selectedOrderToCancelOrReschedule: any = {}; // Define as an object
	bookStartDate: any = '';
	bookEndDate: any = '';
	isPolicyTextTruncated = true;
	bokunFieldsData: any;
	bokunFieldsPerBookingData: any;
	bokunFieldsPerPersonData: any;
	private intervalId: any;
	pickup_location_id: number = 0;
	isInfluencer: boolean = false;
	ventrata_custom_fields: any;
	ventrata_custom_user_data: any[] = [];
	booking_extra = {
		ventrata_vistors: [] as any[]
	};
	bokun_main_contact_fields: any[] = [];
	mainContactDetails: any[] = [];
	goCityUnitId: any;
	goCityAvailabilityId: any;
	goCityOptiontId: any;
	dropOffLocationList: any = [];
	dropoff_location_id: number = 0;
	cartData: any;
	@ViewChild('miniCart') miniCart!: ElementRef;

	constructor(
		private router: Router,
		private toastr: ToastrService,
		private experience: Experience,
		public messageService: MessageService,
		private addexperience: AddExperience,
		private cd: ChangeDetectorRef,
		private cartService: CartService,
		private experienceBookingService: ExperienceBookingService,
		private formBuilder: FormBuilder,
		private ExpDetailService: ExperienceDetailsService,
		private mainService: MainService,
		private userProfileService: UserProfileService,
		public datepipe: DatePipe,
		private registerService: RegisterService,
		private encryptionService: EncryptionService,
		private experienceShareService: ExperienceShare,
		private fbService: FbService,
		private experienceProviderAvailablityService: ExperienceProviderAvailablityService,
		public sanitizer: DomSanitizer,
		private modalService: BsModalService,
		private profileService: ProfileService,
		private authdataMessageService: AuthdataMessageService,
		private eRef: ElementRef,
		public findCoupleService: FindCouple,
		public locationService: LocationService,
		private visitorService: VisitorsService,
		private renderer: Renderer2,
		public _location: Location,
		private PromotionalService: ExperienceProviderPromotionalService,
		private homeService: HomeService,
		private croppieService: CroppieService,
		@Inject(PLATFORM_ID) platformId: Object
	) {

		this.isBrowser = isPlatformBrowser(platformId);
		if (this.isBrowser) {
			window.scrollTo(0, 0);
			this.isBoat = this.isSitePerformanceBoat();

			if (window.innerWidth < 768) {
				this.is_mobile_view = true;
			} else {
				this.is_mobile_view = false;
			}
		}


		this.getMobileDeviceName();
		if (this.isBrowser) {
			if (localStorage.getItem('authUser')) {

				if (localStorage.getItem('login_token')) {
					this.tokenkey = localStorage.getItem('login_token');

					this.getUserAuthDataApi();
				}
			}
		}

		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				if (this.router?.url?.split("/")[1]) {
					if (this.isBrowser) {
						if (this.router?.url?.split("/")[1] != 'reset-password' && localStorage.getItem('login_type')) {
							localStorage.removeItem('login_type')
						}
						if (this.router?.url?.split("/")[2]) {
							if (this.router?.url?.split("/")[3]) {
								this.currentURL1 = this.router?.url?.split("/")[3];
							} else {
								this.currentURL1 = this.router?.url?.split("/")[2];
							}
						} else {
							this.currentURL1 = this.router?.url?.split("/")[1];
						}
					}
				} else {
					this.currentURL1 = "";
				}
			}
		});

		this.subscription = this.cartService.getMessage().subscribe(message => {
			if (this.isBrowser) {
				if (message) {
					this.cart_details = JSON.parse(message);
					this.getCartData(message);
				} else {
					this.cart_details = [];
					this.cartDetails = [];
					this.show_card_details = false;
					this.is_cart_fill = false;
				}
			}

		});

		this.getCartMessageSubscription = this.messageService.getCartMessage().subscribe(message => {
			if (this.isBrowser) {
				if (message !== 'false') {
					this.cartDetails = JSON.parse(message);
				}

			}
		});

		this.experienceDetailSubscription = this.ExpDetailService.getMessage().subscribe(message => {
			let responseMessage = message
			if (message) {
				this.instant_book_request = 0;
				this.calendarOptions = []
				this.showPromoCalendar = false;
				this.showRedeemNowBtn = false;
				this.showRedeemScheduleBtn = false;
				this.backfromRedemmeScheduleBtn = false;
				this.newBookingRequestBtn = false;
				if (this.currentURL != 'registries') {
					this.getWalletAmount();
				}
				this.show_close_button = false;
				this.requestedDate = '';
				this.booking_date_selected = ''
				this.experienceDetails = [];
				this.booking_slot_data = [];
				this.show_refund_button = message?.show_refund_button;
				responseMessage.map_image = { url: responseMessage.image_url, scaledSize: { width: 35, height: 35 } };
				this.experienceDetails = responseMessage;

				this.map_zoom = this.experienceDetails.map_zoom;
				if (this.is_mobile_view === true) {
					this.isModalOpen = true;
				} else {
					this.isModalOpen = false;
				}
				if (new Date(this.experienceDetails?.redeem_date) <= new Date()) {
					this.is_gratuity = true
				}
				if (new Date(this.experienceDetails?.cancellation_deadline) > new Date()) {
					this.isCancellable = true
				} else {
					this.isCancellable = false
				}
				this.requires_visitors_details = [];
				this.blockBookingDates = [];
				this.enableBookingDates = [];
				if (this.isBrowser) {
					if (document.getElementById("main-video11")) {
						var video;
						setTimeout(() => {
							if (document.getElementById('main-video11')) {
								video = document.getElementById('main-video11')

								video.play();
							}
						}, 10)
					}
				}
				this.exp_video = this.experienceDetails.cover_video2;
				this.showRedeemNowConfirm = false;
				this.showRedeemNowCancel = false;
				const detail = this.sanitizeHtml(this.experienceDetails?.detail);
				const decodedText = this.decodeHtmlString(detail);
				if (decodedText) {
					this.expDetailText = decodedText;

					if (this.expDetailText.length > 300) {
						this.truncatedHtml = this.truncateHtml(detail, 300);
						this.showMore = false;
					} else {
						this.truncatedHtml = detail;
						this.showMore = true;
					}
				}
				if (this.experienceDetails.other_page_data) {
					this.other_page_data = this.experienceDetails.other_page_data;

				} else {
					this.other_page_data = '';
				}
				if (this.experienceDetails.experience_status_msg == 'EXCHANGED') {
					this.showEwalletBalance = true;
					this.exchangedBlock = false;
				}
				if (this.experienceDetails.availability != "") {
					this.expAvailabilityArr = JSON.parse(this.experienceDetails.availability);
				}
				if (this.experienceDetails.experience_months_availability != "") {
					this.expAvailabilityMonth = this.experienceDetails.experience_months_availability;
				}
				if (this.experienceDetails.experience_days_availability != "") {
					this.expAvailabilityDay = this.experienceDetails.experience_days_availability;
				}
				if (this.experienceDetails.whats_included) {
					this.expIncludedArr = JSON.parse(this.experienceDetails.whats_included);
				}
				if (this.experienceDetails.whats_not_included) {
					this.expNotIncludedArr = JSON.parse(this.experienceDetails.whats_not_included);
				}
				if (this.experienceDetails.know_before_you_go) {
					this.noBeforeYouGoArr = JSON.parse(this.experienceDetails.know_before_you_go);
				}
				this.additionalImages = this.experienceDetails.additional_images;
				this.main_exp_id = message.id;
				this.data_for_dropdown_in_popup = message;
				this.form_data();
				if (typeof this.authUser != "undefined" && typeof this.authUser != null && typeof this.authUser.email != "undefined" && typeof this.authUser.email != null) {
					if (this.OnlineSchedulingForm != null && this.OnlineSchedulingForm != undefined && this.OnlineSchedulingForm.get('couple_email') != null && this.OnlineSchedulingForm.get('couple_email') != undefined)
						this.OnlineSchedulingForm.get('couple_email').setValue(this.authUser.email);
				}

				if (typeof this.authUser != "undefined" && typeof this.authUser != null && typeof this.authUser.name != "undefined" && typeof this.authUser.name != null) {
					if (this.OnlineSchedulingForm != null && this.OnlineSchedulingForm != undefined &&
						this.OnlineSchedulingForm.get('name') != null && this.OnlineSchedulingForm.get('name') != undefined &&
						this.authUser?.name != null && this.authUser.name?.trim() != "") {
						let name_str = this.authUser.name.toLowerCase();
						let invaild_str = this.names_arr.filter(function (txt) {
							return name_str.includes(txt);
						});
						if (invaild_str == "") {
							this.OnlineSchedulingForm.get('name').setValue(this.authUser?.name);
							this.show_user_name_input = false;
						} else {
							this.show_user_name_input = true;
						}
					} else {
						this.show_user_name_input = true;
					}
				} else {
					this.show_user_name_input = true;
				}
				if (this.experienceDetails.experience_booking_type > 1) {
					if (this.experienceDetails?.is_seasonal) {

						let season_start = this.experienceDetails?.season_start;
						let season_end = this.experienceDetails?.season_end;
						let currentYear = new Date().getUTCFullYear();

						let season_start_date = new Date(`${currentYear}-${season_start}`);
						let season_end_date = new Date(`${currentYear}-${season_end}`);
						if (season_end_date < season_start_date) {
							season_start_date = new Date(`${currentYear - 1}-${season_start}`);
						}

						let currentDate = new Date();
						if (currentDate > season_end_date) {
							season_start_date.setFullYear(season_start_date.getFullYear() + 1);
							season_end_date.setFullYear(season_end_date.getFullYear() + 1);
						}

						if (currentDate > season_start_date) {
							this.minimumDate = this.getDateObject(currentDate);
						} else {
							this.minimumDate = this.getDateObject(season_start_date);
						}
						this.maximumDate = this.getDateObject(season_end_date);
						this.checkMaxAndMinDates();

						if (new Date().getTime() >= season_start_date.getTime() && new Date().getTime() >= season_end_date.getTime()) {
							currentYear += 1;
							season_start_date = this.parseDateToObject(currentYear + "-" + season_start);
							season_end_date = this.parseDateToObject(currentYear + "-" + season_end);
						} else if (new Date().getTime() <= season_start_date.getTime()) {
							if (season_start_date.getTime() >= season_end_date.getTime()) {
								let endYear = currentYear + 1;
								season_end_date = this.parseDateToObject(endYear + "-" + season_end);
							}
						}

						let index = 0;
						let startDate = this.parseDateToObject(currentYear + "-" + season_start);

						while (index < 1) {

							let startDateStr = this.parseDateString(startDate);
							this.enableDates.push(startDate);
							this.enableDates2.push(startDateStr);
							season_start_date.setDate(season_start_date.getDate() + 1);

							startDate = new Date(season_start_date.valueOf());

							if (season_end_date.getTime() <= season_start_date.getTime()) {
								this.enableDates.push(season_end_date);
								let endDateStr = this.parseDateString(season_end_date);
								this.enableDates2.push(endDateStr);
								index = 1;
							}
						}
					} else {
						let dateObj = new Date()

						this.minimumDate = this.getDateObject(dateObj);
						let maxDate = new Date();
						let limitMonth = 60;
						if (this.experienceDetails.limit_3_month_calendar == 1 && this.instant_book_request == 1) {
							limitMonth = 3;
						}
						maxDate.setMonth(maxDate.getMonth() + limitMonth);
						this.maximumDate = this.getDateObject(maxDate);
					}
					this.checkMaxAndMinDates();
					this.getPromotionalDetails();
				} else {
					this.getPromotionalDetails();
					this.instant_book_request = 2;

					if (this.experienceDetails.block_dates && this.experienceDetails.block_dates.length > 0) {
						for (const blockDate of this.experienceDetails.block_dates) {
							let bDate = new Date(Date.parse(blockDate));
							this.blockBookingDates.push(this.convertDateToUTC(bDate));
						}
						this.enableBookingDates = [];
					}
					if (this.experienceDetails?.is_seasonal) {
						let season_start = this.experienceDetails?.season_start;
						let season_end = this.experienceDetails?.season_end;
						let currentYear = new Date().getUTCFullYear();

						let season_start_date = new Date(`${currentYear}-${season_start}`);
						let season_end_date = new Date(`${currentYear}-${season_end}`);
						if (season_end_date < season_start_date) {
							season_start_date = new Date(`${currentYear - 1}-${season_start}`);
						}

						let currentDate = new Date();
						if (currentDate > season_end_date) {
							season_start_date.setFullYear(season_start_date.getFullYear() + 1);
							season_end_date.setFullYear(season_end_date.getFullYear() + 1);
						}

						if (currentDate > season_start_date) {
							this.minimumDate = this.getDateObject(currentDate);
						} else {
							this.minimumDate = this.getDateObject(season_start_date);
						}
						this.maximumDate = this.getDateObject(season_end_date);
						// if (season_end_date < new Date()) {
						// 	season_start_date.setFullYear(season_start_date.getFullYear() + 1);
						// 	season_end_date.setFullYear(season_end_date.getFullYear() + 1);
						// }
						// this.maximumDate = this.getDateObject(season_end_date);
					} else {
						let dateObj = new Date()
						this.minimumDate = this.getDateObject(dateObj);
						let maxDate = new Date();
						let limitMonth = 60;
						if (this.experienceDetails.limit_3_month_calendar == 1 && this.experienceDetails?.instant_book == 1) {
							limitMonth = 3;
						}
						maxDate.setMonth(maxDate.getMonth() + limitMonth);
						this.maximumDate = this.getDateObject(maxDate);
					}
				}

				if (this.isBrowser) {
					var elems = document.querySelectorAll(".exp_tabs.active");
					if (elems.length > 0) {
						for (var i = 0; i < elems.length; i++) {
							elems[i].classList.remove('active');
							elems[i].classList.remove('show');
						}
					}
				}
				if (typeof this.experienceDetails.guest_registry != "undefined" && this.experienceDetails.guest_registry == 1) {
					this.guest_user_data = this.experienceDetails.guest_data;
					this.is_guest_view = true;
					if (this.experienceDetails.experience_type == 3) {
						this.showGiftedByTab = true;
						this.showPhotosVideosTab = true;
						this.showDetailsTab = true;

						this.showReviewTab = false;
						this.showJoinUsTab = false;
					} else {
						this.showDetailsTab = true;
						this.showSummeryTab = true;
						this.showReviewTab = true;
						this.showJoinUsTab = true;
						this.showGiftedByTab = false;
						this.showPhotosVideosTab = false;
					}
					this.priceBlock = true;
					this.guestViewPopup = true;
					this.pricing_popup = false;
				} else if (this.experienceDetails.pricing_option == 1) {
					this.pricing_popup = true;
				} else if (typeof this.experienceDetails.add_experience != "undefined" && this.experienceDetails.add_experience == 1) {
					this.pricing_popup = false;
					this.showDetailsTab = true;
					this.showSummeryTab = true;
					this.showReviewTab = true;
					this.showJoinUsTab = false;
					this.priceBlock = false;
					this.guestViewPopup = false;
					this.showExchangeTab = false;
					this.showGiftedByTab = false;
					this.showPhotosVideosTab = false;
					this.showHowToRedeemTab = false;
					this.showPartialPurchTab = false;
					if (this.experienceDetails.is_registry_status == 0) {
						this.showRemoveRegBtn = false;
						this.showAddRegBtn = true;
					}
					if (this.experienceDetails.is_registry_status == 1) {
						this.showRemoveRegBtn = true;
						this.showAddRegBtn = false;
					}
					this.showBuyYourSelfBtn = true;
					this.showBuyAsGiftBtn = true;
					this.showCloseBtn = false;
					this.showReviewExpBtn = false;
					this.showAddPhotoVideoBtn = false;
					this.showSendThankYouBtn = false;
					this.showAddPhotoDeviceBtn = false;
					this.showAddVideoDeviceBtn = false;
					this.showExchangeBtn = false;
					this.showViewPrintBtn = false;
					this.showScheduleExpBtn = false;
					this.showRedeemNowBtn = false;
					this.showExcConfirmBtn = false;
					this.showExcCancelBtn = false;
					this.showCompletePurchBtn = false;
					this.showBackBtn = false;
					this.showCheckoutBtn = false;
					this.showContinueShopBtn = false;
					this.showEwalletBalance = true;
					this.priceBlock = true;
					this.exchangeBlock = false;
					this.redeemScheduleBlock = false;
					this.onlineScheduleBlock = false;
					this.onlineBookingMsgBlock = false;
					this.onlineBookingRejectBlock = false;
					this.reviewRatingBlock = true;
					this.exchangedBlock = false;
					this.redeemedBlock = false;
					this.show_fareharbor = false;
					this.isActiveTab = 'summary';
					this.show_instant_booking = true;
					this.showRedeemScheduleBtn = true;
				} else {
					this.pricing_popup = false;
					this.guestViewPopup = false;
					this.experience_video_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.experienceDetails.video_update);
					if (this.experienceDetails.experience_status == 0) {
						this.showDetailsTab = true;
						this.showExchangeTab = false;
						this.showGiftedByTab = false;
						this.showPhotosVideosTab = false;
						this.showSummeryTab = true;
						this.showHowToRedeemTab = false;
						this.showPartialPurchTab = false;
						this.showReviewTab = true;
						this.showJoinUsTab = false;
						this.showRemoveRegBtn = false;
						this.showAddRegBtn = true;
						this.showBuyYourSelfBtn = false;
						this.showBuyAsGiftBtn = false;
						this.showCloseBtn = false;
						this.showReviewExpBtn = false;
						this.showAddPhotoVideoBtn = false;
						this.showSendThankYouBtn = false;
						this.showAddPhotoDeviceBtn = false;
						this.showAddVideoDeviceBtn = false;
						this.showRedeemScheduleBtn = true;
						this.showExchangeBtn = false;
						this.showViewPrintBtn = false;
						this.showScheduleExpBtn = false;
						this.showRedeemNowBtn = false;
						this.showExcConfirmBtn = false;
						this.showExcCancelBtn = false;
						this.showCompletePurchBtn = false;
						this.showBackBtn = false;
						this.showCheckoutBtn = false;
						this.showContinueShopBtn = false;
						this.showEwalletBalance = false;
						this.priceBlock = true;
						this.exchangeBlock = false;
						this.redeemScheduleBlock = false;
						this.onlineScheduleBlock = false;
						this.onlineBookingMsgBlock = false;
						this.onlineBookingRejectBlock = false;
						this.reviewRatingBlock = false;
						this.exchangedBlock = false;
						this.redeemedBlock = false;
						this.show_fareharbor = false;
						this.isActiveTab = 'summary';
						this.show_instant_booking = false;
					} else if (this.experienceDetails.experience_status == 1) {
						this.showDetailsTab = true;
						this.showExchangeTab = false;
						this.showGiftedByTab = false;
						this.showPhotosVideosTab = false;
						this.showSummeryTab = true;
						this.showHowToRedeemTab = false;
						this.showPartialPurchTab = false;
						this.showReviewTab = true;
						this.showJoinUsTab = true;
						this.showRemoveRegBtn = true;
						this.showAddRegBtn = false;
						this.showBuyYourSelfBtn = true;
						this.showBuyAsGiftBtn = true;
						this.showCloseBtn = false;
						this.showReviewExpBtn = false;
						this.showAddPhotoVideoBtn = false;
						this.showSendThankYouBtn = false;
						this.showAddPhotoDeviceBtn = false;
						this.showAddVideoDeviceBtn = false;
						this.showRedeemScheduleBtn = true;
						this.showExchangeBtn = false;
						this.showViewPrintBtn = false;
						this.showScheduleExpBtn = false;
						this.showRedeemNowBtn = false;
						this.showExcConfirmBtn = false;
						this.showExcCancelBtn = false;
						this.showCompletePurchBtn = false;
						this.showBackBtn = false;
						this.showCheckoutBtn = false;
						this.showContinueShopBtn = false;
						this.showEwalletBalance = true;
						this.showSeasonHeadline = true;
						this.priceBlock = true;
						this.exchangeBlock = false;
						this.redeemScheduleBlock = false;
						this.onlineScheduleBlock = false;
						this.onlineBookingMsgBlock = false;
						this.onlineBookingRejectBlock = false;
						this.reviewRatingBlock = true;
						this.exchangedBlock = false;
						this.redeemedBlock = false;
						this.show_fareharbor = false;
						this.isActiveTab = 'summary';
						this.show_instant_booking = false;
					} else if (this.experienceDetails.experience_status == 2) {
						this.showDetailsTab = true;
						this.showExchangeTab = false;
						this.showGiftedByTab = true;
						this.showPhotosVideosTab = false;
						this.showSummeryTab = true;
						this.showHowToRedeemTab = true;
						this.showPartialPurchTab = false;
						this.showReviewTab = false;
						this.showJoinUsTab = false;
						this.redeemedBlock = false;
						this.showRemoveRegBtn = false;
						this.showAddRegBtn = false;
						this.showBuyYourSelfBtn = false;
						this.showBuyAsGiftBtn = false;
						this.showCloseBtn = false;
						this.showReviewExpBtn = false;
						this.show_instant_booking = false;
						this.onlineScheduleBlock = false;
						this.showViewPrintBtn = true;
						this.showRedeemScheduleBtn = true;
						this.backfromRedemmeScheduleBtn = false;
						this.priceBlock = true;
						this.exchangeBlock = false;
						this.showSeasonHeadline = true;
						if (this.experienceDetails.experience_type == 3) {
							this.showAddPhotoVideoBtn = true;
							this.showSendThankYouBtn = true;
							this.showGiftedByTab = true;
							this.showPhotosVideosTab = true;
							this.showSummeryTab = false;
							this.showHowToRedeemTab = false;
							this.showExchangeBtn = false;
						} else {
							this.showAddPhotoVideoBtn = false;
							this.showSendThankYouBtn = false;
						}
						if (this.experienceDetails.experience_type == 1) {
							this.showExchangeBtn = true;
						}
						this.showRedeemNowConfirm = false;
						this.showRedeemNowCancel = false;
						this.showAddPhotoDeviceBtn = false;
						this.showAddVideoDeviceBtn = false;
						this.showScheduleExpBtn = false;
						this.showRedeemNowBtn = false;
						this.showExcConfirmBtn = false;
						this.showExcCancelBtn = false;
						this.showCompletePurchBtn = false;
						this.showBackBtn = false;
						this.showCheckoutBtn = false;
						this.showContinueShopBtn = false;
						this.showEwalletBalance = false;
						this.redeemScheduleBlock = false;
						this.onlineBookingMsgBlock = false;
						this.onlineBookingRejectBlock = false;
						this.reviewRatingBlock = false;
						this.exchangedBlock = false;
						this.redeemedBlock = false;
						this.showViewAvaibalityExpBtn = false;
						this.showScheduleExpBtn = false;
						this.isActiveTab = 'how_to_redeem';
						if (this.experienceDetails.booking_request == 1) {
							this.redeemScheduleInfo();
						} else if (this.experienceDetails.exchange_request == 1) {
							this.addExchangeInfo();
						} else if (this.experienceDetails.refund_request == 1) {
							this.refundDetail();
						} else if (this.experienceDetails.redeem_request == 1) {
							this.redeem_confirmation();
						}

						setTimeout(() => {
							this.scrollAndOpenDropdown2();
						}, 1000)
					} else if (this.experienceDetails.experience_status == 3) {
						this.showDetailsTab = true;
						this.showExchangeTab = true;
						this.showGiftedByTab = true;
						this.showPhotosVideosTab = false;
						this.showSummeryTab = false;
						this.showHowToRedeemTab = false;
						this.showPartialPurchTab = false;
						this.showReviewTab = false;
						this.showJoinUsTab = false;
						this.showRemoveRegBtn = false;
						this.showAddRegBtn = false;
						this.showBuyYourSelfBtn = true;
						this.showBuyAsGiftBtn = true;
						this.showCloseBtn = true;
						this.showReviewExpBtn = false;
						this.showAddPhotoVideoBtn = false;
						this.showSendThankYouBtn = false;
						this.showAddPhotoDeviceBtn = false;
						this.showAddVideoDeviceBtn = false;
						this.showRedeemScheduleBtn = false;
						this.showExchangeBtn = false;
						this.showViewPrintBtn = false;
						this.showScheduleExpBtn = false;
						this.showRedeemNowBtn = false;
						this.showExcConfirmBtn = false;
						this.showExcCancelBtn = false;
						this.showCompletePurchBtn = false;
						this.showBackBtn = false;
						this.showCheckoutBtn = false;
						this.showContinueShopBtn = false;
						this.showEwalletBalance = true;
						this.priceBlock = true;
						this.exchangeBlock = false;
						this.redeemScheduleBlock = false;
						this.onlineScheduleBlock = false;
						this.onlineBookingMsgBlock = false;
						this.onlineBookingRejectBlock = false;
						this.reviewRatingBlock = false;
						this.exchangedBlock = false;
						this.redeemedBlock = false;
						this.show_fareharbor = false;
						this.isActiveTab = 'exchange';
						this.showViewAvaibalityExpBtn = false;
						this.showScheduleExpBtn = false;
						this.show_instant_booking = false;
					} else if (this.experienceDetails.experience_status == 4) {
						this.showDetailsTab = true;
						this.showExchangeTab = false;
						this.showGiftedByTab = true;
						this.showPhotosVideosTab = false;
						this.showSummeryTab = false;
						this.showHowToRedeemTab = false;
						this.showPartialPurchTab = true;
						this.showReviewTab = false;
						this.showJoinUsTab = false;
						if (this.experienceDetails.partial_remaining_qty > 0) {
							this.showCompletePurchBtn = true;
						} else {
							this.showCompletePurchBtn = false;
						}
						this.showAddRegBtn = false;
						this.showRemoveRegBtn = false;
						this.showBuyYourSelfBtn = false;
						this.showBuyAsGiftBtn = false;
						this.showCloseBtn = false;
						this.showReviewExpBtn = false;
						this.showAddPhotoVideoBtn = false;
						this.showSendThankYouBtn = false;
						this.showAddPhotoDeviceBtn = false;
						this.showAddVideoDeviceBtn = false;
						this.showRedeemScheduleBtn = false;
						this.showExchangeBtn = true;
						this.showViewPrintBtn = false;
						this.showScheduleExpBtn = false;
						this.showRedeemNowBtn = false;
						this.showExcConfirmBtn = false;
						this.showExcCancelBtn = false;
						this.showBackBtn = false;
						this.showCheckoutBtn = false;
						this.showContinueShopBtn = false;
						this.showViewAvaibalityExpBtn = false;
						this.showScheduleExpBtn = false;
						this.redeemScheduleBlock = false;
						this.onlineScheduleBlock = false;
						this.onlineBookingMsgBlock = false;
						this.onlineBookingRejectBlock = false;
						if (this.experienceDetails.exchange_request == 1) {
							this.addExchangeInfo();
						}
					} else if (this.experienceDetails.experience_status == 5) {
						this.showDetailsTab = true;
						this.showExchangeTab = false;
						this.showGiftedByTab = true;
						this.showPhotosVideosTab = true;
						this.showSummeryTab = false;
						this.showHowToRedeemTab = false;
						this.showPartialPurchTab = false;
						this.showReviewTab = false;
						this.showJoinUsTab = false;
						this.showRemoveRegBtn = false;
						this.showAddRegBtn = false;
						this.showBuyYourSelfBtn = false;
						this.showBuyAsGiftBtn = false;
						this.showCloseBtn = false;
						this.showReviewExpBtn = true;
						this.showAddPhotoVideoBtn = true;
						if (this.experienceDetails.require_thank_you_email == 1) {
							this.showSendThankYouBtn = true;
						} else {
							this.showSendThankYouBtn = false;
						}
						this.showAddPhotoDeviceBtn = false;
						this.showAddVideoDeviceBtn = false;
						this.showRedeemScheduleBtn = false;
						this.showExchangeBtn = false;
						this.showViewPrintBtn = false;
						this.showScheduleExpBtn = false;
						this.showRedeemNowBtn = false;
						this.showExcConfirmBtn = false;
						this.showExcCancelBtn = false;
						this.showCompletePurchBtn = false;
						this.showBackBtn = false;
						this.showCheckoutBtn = false;
						this.showContinueShopBtn = false;
						this.showEwalletBalance = false;
						this.priceBlock = true;
						this.exchangeBlock = false;
						this.redeemScheduleBlock = false;
						this.onlineScheduleBlock = false;
						this.onlineBookingMsgBlock = false;
						this.onlineBookingRejectBlock = false;
						this.reviewRatingBlock = false;
						this.redeemedBlock = true;
						this.exchangedBlock = false;
						this.show_fareharbor = false;
						this.isActiveTab = 'detail';
						this.showViewAvaibalityExpBtn = false;
						this.showScheduleExpBtn = false;
						this.show_instant_booking = false;
					} else if (this.experienceDetails.experience_status == 8) {
						this.showDetailsTab = true;
						this.showExchangeTab = false;
						this.showGiftedByTab = true;
						this.showPhotosVideosTab = false;
						this.showSummeryTab = true;
						this.showHowToRedeemTab = false;
						this.showPartialPurchTab = false;
						this.showReviewTab = false;
						this.showJoinUsTab = false;
						this.showRemoveRegBtn = false;
						this.showAddRegBtn = false;
						this.showBuyYourSelfBtn = false;
						this.showBuyAsGiftBtn = false;
						this.showCloseBtn = false;
						this.showReviewExpBtn = false;
						this.showAddPhotoVideoBtn = false;
						this.showSendThankYouBtn = false;
						this.showAddPhotoDeviceBtn = false;
						this.showAddVideoDeviceBtn = false;
						this.showRedeemScheduleBtn = false;
						this.showExchangeBtn = false;
						this.showViewPrintBtn = false;
						this.showScheduleExpBtn = false;
						this.showRedeemNowBtn = false;
						this.showExcConfirmBtn = false;
						this.showExcCancelBtn = false;
						this.showCompletePurchBtn = false;
						this.showBackBtn = false;
						this.showCheckoutBtn = false;
						this.showContinueShopBtn = false;
						this.showEwalletBalance = false;
						this.priceBlock = true;
						this.exchangeBlock = false;
						this.redeemScheduleBlock = false;
						this.onlineScheduleBlock = false;
						this.onlineBookingMsgBlock = true;
						this.onlineBookingRejectBlock = false;
						this.reviewRatingBlock = false;
						this.redeemedBlock = false;
						this.exchangedBlock = false;
						this.show_fareharbor = false;
						this.isActiveTab = 'detail';
						this.showViewAvaibalityExpBtn = false;
						this.showScheduleExpBtn = false;
						this.show_instant_booking = false;
					} else if (this.experienceDetails.experience_status == 9) {
						this.showDetailsTab = true;
						this.showExchangeTab = false;
						this.showGiftedByTab = true;
						this.showPhotosVideosTab = false;
						this.showSummeryTab = true;
						this.showHowToRedeemTab = false;
						this.showPartialPurchTab = false;
						this.showReviewTab = false;
						this.showJoinUsTab = false;
						this.showRemoveRegBtn = false;
						this.showAddRegBtn = false;
						this.showBuyYourSelfBtn = false;
						this.showBuyAsGiftBtn = false;
						this.showCloseBtn = false;
						this.showReviewExpBtn = false;
						this.showAddPhotoVideoBtn = false;
						this.showSendThankYouBtn = false;
						this.showAddPhotoDeviceBtn = false;
						this.showAddVideoDeviceBtn = false;
						this.showRedeemScheduleBtn = false;
						this.showExchangeBtn = false;
						this.showViewPrintBtn = false;
						this.showScheduleExpBtn = false;
						this.showRedeemNowBtn = false;
						this.showExcConfirmBtn = false;
						this.showExcCancelBtn = false;
						this.showCompletePurchBtn = false;
						this.showBackBtn = false;
						this.showCheckoutBtn = false;
						this.showContinueShopBtn = false;
						this.showEwalletBalance = false;
						this.priceBlock = true;
						this.exchangeBlock = false;
						this.redeemScheduleBlock = false;
						this.onlineScheduleBlock = false;
						this.onlineBookingMsgBlock = true;
						this.onlineBookingRejectBlock = false;
						this.reviewRatingBlock = false;
						this.redeemedBlock = false;
						this.exchangedBlock = false;
						this.show_fareharbor = false;
						this.isActiveTab = 'detail';
						this.showViewAvaibalityExpBtn = false;
						this.showScheduleExpBtn = false;
						this.show_instant_booking = false;
					} else if (this.experienceDetails.experience_status == 10) {
						if (this.experienceDetails.instant_book != 1) {
							this.showDetailsTab = true;
							this.showExchangeTab = false;
							this.showGiftedByTab = true;
							this.showPhotosVideosTab = true;
							this.showSummeryTab = false;
							this.showHowToRedeemTab = false;
							this.showPartialPurchTab = false;
							this.showReviewTab = false;
							this.showJoinUsTab = false;
							if (this.experienceDetails.experience_booking_type > 0) {
								this.newBookingRequestBtn = true;
								this.showRedeemNowBtn = false;
							} else {
								this.newBookingRequestBtn = false;
								this.showRedeemNowBtn = true;
							}
							this.showExchangeBtn = true;
							this.showRemoveRegBtn = false;
							this.showAddRegBtn = false;
							this.showBuyYourSelfBtn = false;
							this.showBuyAsGiftBtn = false;
							this.showCloseBtn = false;
							this.showReviewExpBtn = false;
							this.showAddPhotoVideoBtn = false;
							this.showSendThankYouBtn = false;
							this.showAddPhotoDeviceBtn = false;
							this.showAddVideoDeviceBtn = false;
							this.showViewPrintBtn = false;
							this.showScheduleExpBtn = false;
							this.showExcConfirmBtn = false;
							this.showExcCancelBtn = false;
							this.showCompletePurchBtn = false;
							this.showBackBtn = false;
							this.showCheckoutBtn = false;
							this.showContinueShopBtn = false;
							this.showEwalletBalance = false;
							this.priceBlock = true;
							this.exchangeBlock = false;
							this.redeemScheduleBlock = false;
							this.onlineScheduleBlock = false;
							this.onlineBookingMsgBlock = true;
							this.onlineBookingRejectBlock = true;
							this.reviewRatingBlock = false;
							this.redeemedBlock = false;
							this.exchangedBlock = false;
							this.show_fareharbor = false;
							this.isActiveTab = 'detail';
							this.showViewAvaibalityExpBtn = false;
							this.showScheduleExpBtn = false;
							this.show_instant_booking = false;
						} else {
							if (this.experienceDetails.experience_booking_type > 0) {
								this.showDetailsTab = true;
								this.showExchangeTab = false;
								this.showGiftedByTab = true;
								this.showPhotosVideosTab = false;
								this.showSummeryTab = true;
								this.showHowToRedeemTab = true;
								this.showPartialPurchTab = false;
								this.showReviewTab = false;
								this.showJoinUsTab = false;
								this.redeemedBlock = false;
								this.showRemoveRegBtn = false;
								this.showAddRegBtn = false;
								this.showBuyYourSelfBtn = false;
								this.showBuyAsGiftBtn = false;
								this.showCloseBtn = false;
								this.showReviewExpBtn = false;
								if (this.experienceDetails.experience_booking_type == 1) {
									this.request_to_book = true;
								} else {
									this.request_to_book = false;
								}
								if (this.experienceDetails.experience_type == 3) {
									this.showAddPhotoVideoBtn = true;
									this.showSendThankYouBtn = true;
									this.showGiftedByTab = true;
									this.showPhotosVideosTab = true;
									this.showSummeryTab = false;
									this.showHowToRedeemTab = false;
									this.showExchangeBtn = false;
								} else {
									this.showAddPhotoVideoBtn = false;
									this.showSendThankYouBtn = false;
									this.showExchangeBtn = false;
								}
								this.showAddPhotoDeviceBtn = false;
								this.showAddVideoDeviceBtn = false;
								this.showRedeemScheduleBtn = false;
								this.showViewPrintBtn = false;
								this.showScheduleExpBtn = false;
								this.showRedeemNowBtn = false;
								this.showExcConfirmBtn = false;
								this.showExcCancelBtn = false;
								this.showCompletePurchBtn = false;
								this.showBackBtn = false;
								this.showCheckoutBtn = false;
								this.showContinueShopBtn = false;
								this.showEwalletBalance = false;
								this.priceBlock = false;
								this.exchangeBlock = false;
								this.redeemScheduleBlock = false;
								this.onlineBookingMsgBlock = false;
								this.onlineBookingRejectBlock = false;
								this.reviewRatingBlock = false;
								this.exchangedBlock = false;
								this.redeemedBlock = false;
								this.show_fareharbor = false;
								this.showViewAvaibalityExpBtn = false;
								this.showScheduleExpBtn = false;
								this.show_instant_booking = false;
								this.backfromRedemmeScheduleBtn = true;
								this.onlineScheduleBlock = true;
								this.showSeasonHeadline = true;
								this.isActiveTab = 'how_to_redeem';
							} else {
								this.showDetailsTab = true;
								this.showExchangeTab = false;
								this.showGiftedByTab = true;
								this.showPhotosVideosTab = false;
								this.showSummeryTab = true;
								this.showHowToRedeemTab = true;
								this.showPartialPurchTab = false;
								this.showReviewTab = false;
								this.showJoinUsTab = false;
								this.redeemedBlock = false;
								this.showRemoveRegBtn = false;
								this.showAddRegBtn = false;
								this.showBuyYourSelfBtn = false;
								this.showBuyAsGiftBtn = false;
								this.showCloseBtn = false;
								this.showReviewExpBtn = false;
								this.showAddPhotoVideoBtn = false;
								this.showSendThankYouBtn = false;
								this.showExchangeBtn = false;
								this.showAddPhotoDeviceBtn = false;
								this.showAddVideoDeviceBtn = false;
								this.showRedeemScheduleBtn = false;
								this.showViewPrintBtn = false;
								this.showScheduleExpBtn = false;
								this.showRedeemNowBtn = false;
								this.showExcConfirmBtn = false;
								this.showExcCancelBtn = false;
								this.showCompletePurchBtn = false;
								this.showBackBtn = false;
								this.showCheckoutBtn = false;
								this.showContinueShopBtn = false;
								this.showEwalletBalance = false;
								this.priceBlock = true;
								this.exchangeBlock = false;
								this.redeemScheduleBlock = false;
								this.onlineScheduleBlock = false;
								this.onlineBookingMsgBlock = false;
								this.onlineBookingRejectBlock = false;
								this.reviewRatingBlock = false;
								this.exchangedBlock = false;
								this.redeemedBlock = false;
								this.show_fareharbor = false;
								this.isActiveTab = 'how_to_redeem';
								this.showViewAvaibalityExpBtn = false;
								this.showScheduleExpBtn = false;
								this.show_instant_booking = false;
								this.showRedeemNowConfirm = true;
								this.showRedeemNowCancel = true;
							}
						}
					} else if (this.experienceDetails.experience_status == 13 || this.experienceDetails.experience_status == 14) {
						this.showDetailsTab = true;
						this.showExchangeTab = true;
						this.showGiftedByTab = true;
						this.showPhotosVideosTab = false;
						this.showSummeryTab = false;
						this.showHowToRedeemTab = false;
						this.showPartialPurchTab = false;
						this.showReviewTab = false;
						this.showJoinUsTab = false;
						this.showRemoveRegBtn = false;
						this.showAddRegBtn = false;
						this.showBuyYourSelfBtn = true;
						this.showBuyAsGiftBtn = true;
						this.showCloseBtn = true;
						this.showReviewExpBtn = false;
						this.showAddPhotoVideoBtn = false;
						this.showSendThankYouBtn = false;
						this.showAddPhotoDeviceBtn = false;
						this.showAddVideoDeviceBtn = false;
						this.showRedeemScheduleBtn = false;
						this.showExchangeBtn = false;
						this.showViewPrintBtn = false;
						this.showScheduleExpBtn = false;
						this.showRedeemNowBtn = false;
						this.showExcConfirmBtn = false;
						this.showExcCancelBtn = false;
						this.showCompletePurchBtn = false;
						this.showBackBtn = false;
						this.showCheckoutBtn = false;
						this.showContinueShopBtn = false;
						this.showEwalletBalance = true;
						this.priceBlock = true;
						this.exchangeBlock = false;
						this.redeemScheduleBlock = false;
						this.onlineScheduleBlock = false;
						this.onlineBookingMsgBlock = false;
						this.onlineBookingRejectBlock = false;
						this.reviewRatingBlock = false;
						this.exchangedBlock = false;
						this.redeemedBlock = false;
						this.show_fareharbor = false;
						this.isActiveTab = 'exchange';
						this.showViewAvaibalityExpBtn = false;
						this.showScheduleExpBtn = false;
						this.show_instant_booking = false;
					}

				}
				if (this.experienceDetails.is_purchased == 1) {
					if (this.experienceDetails?.people_count && this.experienceDetails?.people_count > 0) {
						this.selected_people = this.experienceDetails?.people_count;
					} else {
						this.selected_people = 2;
					}
				}
				if (this.experienceDetails.voucher_code != "" && Number(this.experienceDetails.order_id) > 0) {

					this.is_exp_purchased = true;
				} else {
					this.is_exp_purchased = false;
				}

				this.getExpQuantity(this.experienceDetails);
				let phoneObj;
				setTimeout(() => {
					const yotpoScriptElement = this.loadJsScript(this.renderer, "https://staticw2.yotpo.com/vbWht62N5vShfWTnel3ir0s0imPG2iXJJ4kRoSlR/widget.js");
				}, 5000);
				if (this.authUser?.phone_json && this.authUser.phone_json && typeof this.authUser?.phone_json == 'string') {
					phoneObj = JSON.parse(this.authUser?.phone_json);
				} else {
					phoneObj = this.authUser?.phone_json;
				}
				this.OnlineSchedulingForm.patchValue({
					phone: this.authUser?.phone_json && this.authUser.phone_json ? phoneObj : ""
				});
				this.experienceDetailsPopup.show();
				let month = this.minimumDate.month;
				let year = this.minimumDate.year;
				const peopleCount = 2;
				const cacheKey = `${year}-${month}-${peopleCount}`;
				if (this.experienceDetails?.experience_booking_type > 1 && this.experienceDetails?.alternate_quantity !== 1) {
					this.getAvailableDates(month, year, cacheKey, peopleCount);
				}
				setTimeout(() => {
					if (this.isBrowser) {
						window.dispatchEvent(new Event('resize'));
					}

					if (this.videoElement) {
						this.videoElement.nativeElement.load();
					}

					if (this.isBrowser) {
						document.querySelector('#experienceDetailsPopup .modal-content').scrollTo(0, 0);
					}
					if (this.mainSwiperElement) {
						this.mainSwiper = new SwiperCore(this.mainSwiperElement.nativeElement, {
							// additional Swiper configuration if needed
						});
						if (this.additionalImages) {
							setTimeout(() => {
								this.mainSwiper.slideTo(0, 0);
							}, 100);
						}
					}

				}, 500);

			} else {
				this.experienceDetails = [];
				this.additionalImages = [];
				this.booking_slot_data = [];
				this.requires_visitors_details = [];

			}
			setTimeout(() => {
				if (this.isBrowser) {
					if (typeof window['yotpo'] !== 'undefined') {
						window['yotpo'].refreshWidgets();

					}
				}
			}, 2000);
		});
		this.end_navigate_stop = true
		this.authDataMessageSubscription = this.authdataMessageService.getAuthUserDataMessage().subscribe(message => {
			if (message && message.login_token && message.login_token.length > 0) {

				this.tokenkey = message.login_token;
			}
			this.getUserAuthDataApi();
		});
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				if (this.isBrowser) {
					this.onWindowScroll();
				}
				if (this.isBrowser) {
					document.querySelector(".burger").classList.remove("clicked");
					document.querySelector("body").classList.remove("overflow");
					document.querySelector("html").classList.remove("overflow");
					document.querySelector(".body-content-wrapper").classList.remove("show-menu");
					document.querySelector(".mobile-collapsable").classList.remove("menu-show");
					document.querySelector(".caret-arrow").classList.remove("show_submenu");
					document.getElementById("app-overlay").hidden = true;

					if (!this.isBoat) {
						fbq('track', 'PageView');
						pintrk('page');
					}
				}
				if (this.isBrowser) {
					if (localStorage.getItem('authUser')) {

						if (localStorage.getItem('login_token')) {
							this.tokenkey = localStorage.getItem('login_token');
							this.authUser = localStorage.getItem('authUser');

							this.getUserAuthDataApi(true);
						}
					} else {
						this.isLogin = false
						this.authCheck = false
					}
				}
			}
			this.show_card_details = false;
			this.currentURL = this.router?.url?.split("/")[1];
		});
		this.authDataMessageProfilePicSubscription = this.authdataMessageService.getProfilePicMessage().subscribe(message => {
			if (message !== 'false') {
				this.profile_img_url = message;
				this.showUploadProfileText = false;
			}
		});
		this.urlSubscription = this.messageService.getData().subscribe((data) => {
			if (data) {
				this.urlData = data

			}
		})
		if (!this.urlData) {
			this.urlData = this._location.path();
		}
		//this.deepLinkUrl(this.urlData)
		this.walletAmountSubscription = this.messageService.getAmountMessage().subscribe(message => {
			if (message !== 'false') {
				this.wallet_balance = parseFloat(message).toFixed(2);
			}
		});
		this.addExpCountSubscription = this.messageService.getTotalMessage().subscribe(message => {
			if (message && message !== 'false') {
				if (message == 'show_first_time_popup') {
					this.show_congratulation = false;
					if (this.authUser.gift_voucher_received == 0) {
						this.congratulationPopup.show();
					}
					if (this.isBrowser) {

						localStorage.removeItem('show_first_time_reg_popup');
					}
				} else {
					this.totalAdded = message.total_exp_count;
					if (typeof message.gift_add != "undefined" && message.gift_add == 1) {

						this.showCountDownText = false;
						this.show_congratulation = true;

						this.congratulationPopup.show();
						this.authUser.gift_voucher_received = 1;
						if (this.isBrowser) {

							var updateAuthUser = JSON.parse(localStorage.getItem("authUser"));
							updateAuthUser.gift_voucher_received = 1;
							localStorage.setItem("authUser", JSON.stringify(updateAuthUser));
						}

					}
				}
			}
		});
		this.getCartPaymentMsgSubscription = this.messageService.getPaymentMessage().subscribe(message => {
			if (this.isBrowser) {

				if (message !== 'false') {
					if (message == '1')
						this.cartDetails = JSON.parse(localStorage.getItem('cart_detail'))
				}

			}
		});
	
		this.getLogoutMessageSubscription = this.messageService.getLogoutMessage().subscribe(message => {
			if (message !== 'false') {
				if (message == "1") {
					this.isLogin = true;
				}
				else {
					this.isLogin = false;
				}
			}
		});
		const current = new Date();
		this.todayDate = {
			year: current.getFullYear(),
			month: current.getMonth() + 1,
			day: current.getDate()
		};
		this.yesterday = new Date(current);

		this.getPhotoVideoSubscription = this.messageService.getPhotoVideo().subscribe(message => {
			if (message !== 'false') {
				this.addPhotoVideoFromDevice(message);
			}
		});
		this.getGiftCertificateSubscription = this.messageService.getGiftCertificate().subscribe(message => {
			if (message !== 'false') {
				this.certificate_data = message;
				this.buymodal.show();
			}
		});
		this.getTipSubscription = this.messageService.getTip().subscribe(message => {
			if (message == true || Object.keys(message)?.length > 0) {
				this.experienceDetails = message
				this.gratuityAmount = '';
				this.gratuityModal.show();
			}
		});
		this.modalPopChangeSubscription = this.modelChanged.pipe(debounceTime(1000)).subscribe(searchText => {
			this.search_string = searchText;
			this.search_string = this.search_string.target.value;
			this.couple_searching(this.search_string);
		});
		this.FbAlbumSubscription = this.messageService.getPhotoUpdateProcess().subscribe(message => {
			this.uploadFromFacebook(message);
		});

		if (this.isBrowser) {
			if (localStorage.getItem('authUser')) {
				let authUser = JSON.parse(localStorage.getItem('authUser'));
				if (authUser && authUser.role_id == this.WEDDING_COUPLE_ROLE_ID && authUser.gift_voucher_received == 0) {
					let current_time_params = {};
					this.mainService.getCurrentTime(current_time_params).subscribe(res => {
						this.timerStartDate = res?.date_time;
					});
				}
			}
		}

	}

	@HostListener('window:popstate', ['$event'])
	queryStringToObject(url: string): { [key: string]: string } {
		const obj: { [key: string]: string } = {};
		const trimmedUrl = url.toString().substring(1);
		const urlParts = trimmedUrl?.split('?');
		urlParts.length > 1 || url.toString().includes('/') ? obj['feature'] = urlParts[0] : url == '' ? obj['feature'] = 'home' : obj

		if (urlParts.length == 1 ? urlParts[0] : urlParts[1]) {
			const params = urlParts.length == 1 ? urlParts[0]?.split('&') : urlParts[1]?.split('&');

			for (const param of params) {
				const parts = param?.split('=');

				if (parts.length === 2) {
					var key = decodeURIComponent(parts[0]);
					var value = decodeURIComponent(parts[1]);
					if (key == 'wcsid') {
						obj['channel'] = 'wcsid'
						obj['campaign'] = value
						this.isBannerHidden = true
						if (this.isBrowser) {

							localStorage.setItem('isBannerHidden', this.isBannerHidden)
						}

					}
					if (key == 'utm_source') {
						this.isBannerHidden = true
						if (this.isBrowser) {

							localStorage.setItem('isBannerHidden', this.isBannerHidden)
						}
					}

					key == 'utm_source' ? key = 'channel' : key == 'utm_campaign' ? key = 'campaign' : key == 'utm_medium' ? key = 'stage' :
						key == 'utm_content' ? key = 'alias' : key == 'utm_term' ? key = 'identity' : key == 'utm_path' ? key = 'feature' :
							key == 'utm_parameters' ? key = 'tags' : key
					obj[key] = value;
				}

			}
		}
		return obj;
	}

	getCartData(data?: any) {
		if (this.isBrowser) {
			if (localStorage.getItem('gift_box_details')) {
				localStorage.removeItem('gift_box_details');
			}
			let existingCartItems = [];


			if (data) {
				const stored = data;
				if (stored) {
					try {
						existingCartItems = JSON.parse(stored);
					} catch (e) {
						console.error("Error parsing cart_details:", e);
					}
				}
			} else if (localStorage.getItem('cart_details')) {
				const stored = localStorage.getItem('cart_details');
				if (stored) {
					try {
						existingCartItems = JSON.parse(stored);
					} catch (e) {
						console.error("Error parsing cart_details:", e);
					}
				}
			}

			const filteredCartItems = existingCartItems.filter(item => item.slug !== "gift-box");

			const stripKeys = (items: any[]) => {
				return items.map(({ voucher_for, packaging_method, send_email_to, ...rest }) => rest);
			};

			const cleanedCartDetails = stripKeys(filteredCartItems);

			if (cleanedCartDetails?.length == 0) {
				this.isLoading = false;
				this.cartDetails = [];
				// this.dataRetrieved = true;
				return;
			}

			let requestBody = {
				itemDetails: cleanedCartDetails,
				user_id: this.authUser?.id,
			};
			this.isLoading = true;

			this.cartService.getOrderOverview(requestBody).subscribe(res => {
				if (res?.response == 'success') {
					this.cartData = res?.data;
					if (res?.data?.final_total == 0) {
						localStorage.removeItem('cart_details');
						return;
					}
					this.cartDetails = res?.data?.cart_data?.itemDetails;
					const filteredItems = res?.data?.cart_data?.itemDetails?.filter(item => item?.slug !== "gift-box") || [];
					localStorage.setItem('cart_details', JSON.stringify(filteredItems));
					this.isLoading = false;
					//   this.dataRetrieved = true;
					this.toggleMenu();
					this.show_card_details = true;
					this.is_cart_fill = true;
					if (this.show_card_details == true) {
						if (this.isBrowser) {
							var element = document.querySelector("body");
							var htmlelement = document.querySelector("html")
							if (element) {
								element.classList.add('overflow');
							}
							if (htmlelement) {
								htmlelement.classList.add('overflow');
							}
						}

						if (this.isBrowser) {
							setTimeout(function () {
								var popupWrapElement = document.querySelector(".cartpopup-wrap");
								if (popupWrapElement) {
									popupWrapElement.classList.add('active');
								}
							}, 100);
						}
					}
				} else {
					//   this.dataRetrieved = true;
					this.isLoading = false;
				}
			});
		}
	}

	public loadJsScript(renderer: Renderer2, src: string, isAsync: boolean = false, isDefer: boolean = false): HTMLScriptElement {
		const script = renderer.createElement('script');
		script.type = 'text/javascript';
		script.src = src;
		if (isAsync) {
			script.async = true;
		}
		if (isDefer) {
			script.defer = true;
		}
		renderer.appendChild(document.body, script);
		return script;
	}

	deepLinkUrl(url) {
		const queryObject = this.queryStringToObject(url);
		let requestBody = queryObject
		this.userProfileService.deepLink(requestBody).subscribe(res => {
			this.deepUrl = res?.url;
		});
	}

	isSitePerformanceBoat(): boolean {
		if (this.isBrowser) {
			const userAgent = window.navigator.userAgent;
			if (userAgent.includes('GTmetrix') || userAgent.includes('Chrome-Lighthouse')) {
				return true;
			}
			return false;
		}
	}

	getUserAuthDataApi(navigation = false) {
		const $this = this;
		let requestBody = {};
		if (this.tokenkey != '') {
			this.userProfileService.get_auth_user_data(requestBody, this.tokenkey).subscribe(res => {
				if (res.response == "success") {
					if (res.data.gift_voucher_received == 1) {
						this.showCountDownText = false;
					}
					if (this.isBrowser) {

						localStorage.setItem('base_img_url', res.base_url);
						localStorage.setItem('authUser', JSON.stringify(res.data));
					}

					this.initializeAuthUserData();
				} else {
					this.logout();
				}
			});
		}
	}

	initializeAuthUserData(fromNavigation = false) {
		if (this.isBrowser) {
			if (localStorage.getItem('authUser')) {
				this.authUser = JSON.parse(localStorage.getItem('authUser'));
				if (this.authUser?.is_influencer == 1) {
					this.isInfluencer = true;
				} else {
					this.isInfluencer = false;
				}
				this.authCheck = true;
				this.isLogin = true;
				this.showCountDownText = false;
				this.getWalletAmount();

				this.couple_name = this.authUser.first_name + ' & ' + this.authUser.partner_first_name;
				this.tokenkey = localStorage.getItem('login_token');

				if (this.authUser.profile_image !== '' && this.authUser.profile_image !== null && this.authUser.profile_image !== undefined) {
					this.profile_img_url = localStorage.getItem('base_img_url') + this.authUser.profile_image;
					this.showUploadProfileText = false;
				} else {
					this.showUploadProfileText = true;
					this.profile_img_url = 'assets/images/option_img.png';

				}

				if (this.authUser.cover_image !== '' && this.authUser.cover_image !== null && this.authUser.cover_image !== undefined) {
					this.cover_image_url = localStorage.getItem('base_img_url') + this.authUser.cover_image;
				} else {
					this.cover_image_url = 'assets/images/cover_image.jpg';
				}

				if ([1, 4, 5].includes(this.authUser.role_id)) {
					this.showAddExpBtns = true;
				}

				if (this.authUser.role_id == 1) {
					if (this.authUser.gift_voucher_received == 1) {
						this.showCountDownText = false;
					} else {
						this.showCountDownTimer();
					}
				}
			} else {
				this.profile_img_url = 'assets/images/option_img.png';
				this.cover_image_url = 'assets/images/cover_image.jpg';
				this.showCountDownText = false;
				this.timerEndDate = "";
				this.isLogin = false;
				this.authCheck = false;
				this.showUploadProfileText = false;
			}
		}
	}

	ngOnDestroy() {
		if (this.subscription != undefined && this.subscription != null) {
			this.subscription.unsubscribe();
		}
		if (this.experienceDetailSubscription != undefined && this.experienceDetailSubscription != null) {
			this.experienceDetailSubscription.unsubscribe();
		}
		if (this.FbAlbumSubscription != undefined && this.FbAlbumSubscription != null) {
			this.FbAlbumSubscription.unsubscribe();
		}
		if (this.modalPopChangeSubscription != undefined && this.modalPopChangeSubscription != null) {
			this.modalPopChangeSubscription.unsubscribe();
		}
		if (this.addExpCountSubscription != undefined && this.addExpCountSubscription != null) {
			this.addExpCountSubscription.unsubscribe();
		}
		if (this.walletAmountSubscription != undefined && this.walletAmountSubscription != null) {
			this.walletAmountSubscription.unsubscribe();
		}
		if (this.urlSubscription != undefined && this.urlSubscription != null) {
			this.urlSubscription.unsubscribe();
		}
		if (this.authDataMessageProfilePicSubscription != undefined && this.authDataMessageProfilePicSubscription != null) {
			this.authDataMessageProfilePicSubscription.unsubscribe();
		}
		if (this.authDataMessageSubscription != undefined && this.authDataMessageSubscription != null) {
			this.authDataMessageSubscription.unsubscribe();
		}
		if (this.getCartPaymentMsgSubscription != undefined && this.getCartPaymentMsgSubscription != null) {
			this.getCartPaymentMsgSubscription.unsubscribe();
		}
		if (this.getCartMessageSubscription != undefined && this.getCartMessageSubscription != null) {
			this.getCartMessageSubscription.unsubscribe();
		}
		if (this.getLogoutMessageSubscription != undefined && this.getLogoutMessageSubscription != null) {
			this.getLogoutMessageSubscription.unsubscribe();
		}
		if (this.getPhotoVideoSubscription != undefined && this.getPhotoVideoSubscription != null) {
			this.getPhotoVideoSubscription.unsubscribe();
		}
		if (this.getGiftCertificateSubscription != undefined && this.getGiftCertificateSubscription != null) {
			this.getGiftCertificateSubscription.unsubscribe();
		}
		if (this.getTipSubscription != undefined && this.getTipSubscription != null) {
			this.getTipSubscription.unsubscribe();
		}
		if (this.isBrowser) {
			if (this.intervalId) {
				clearInterval(this.intervalId);
			}
			document.removeEventListener('click', this.checkCalendarPosition.bind(this));

		}

		if (this.locationListSubscription) {
			this.locationListSubscription.unsubscribe();
		}
	}

	ngAfterViewInit() {
		if (this.isBrowser) {
			var self = this;
			window.onkeydown = function (event) {
				if (event.keyCode == 27) {
					self.close()
				}
			};
			document.querySelector(".burger").addEventListener("click", (e) => {
				menuToggle();
			});

			document.querySelector(".overlay").addEventListener("click", (e) => {
				menuToggle();
			});

			function menuToggle() {
				document.querySelector(".burger").classList.toggle("clicked");
				document.querySelector("body").classList.toggle("overflow");
				document.querySelector("html").classList.toggle("overflow");
				document.getElementById("header").classList.toggle("stickyScrolHead");
				document.querySelector(".body-content-wrapper").classList.toggle("show-menu");
				document.querySelector(".mobile-collapsable").classList.toggle("menu-show");
				document.querySelector(".caret-arrow").classList.remove("show_submenu");
				document.getElementById("app-overlay").hidden = true;
				if (document.querySelector("body").classList.contains("overflow")) {
					document.getElementById("app-overlay").hidden = false;
				}
				if (document.getElementById("header").classList.contains("is-sticky")) {
					document.getElementById("header").classList.add("awake");
				}
			}
			var caretArrow = document.querySelector(".caret-arrow");
			caretArrow.addEventListener("click", (e) => {
				var target = getTargetElement(e);
				document.querySelector(".caret-arrow").classList.toggle("show_submenu");
			});

			function getTargetElement(e) {
				if (this.isBrowser) {
					e = e || window.event;
					return e.target || e.srcElement;
				}

			}
			this.checkCalendarPosition();
			document?.addEventListener('click', this.checkCalendarPosition.bind(this));
		}
	}

	checkCalendarPosition() {
		if (this.intervalId) {
			clearInterval(this.intervalId);
		}

		this.intervalId = setInterval(() => {
			const calendarElement = document.querySelector('[data-popper-placement="top-start"]');
			const targetElement = this.eRef?.nativeElement?.querySelector('.gettingTime');

			// Check if targetElement is not null or undefined
			if (targetElement) {
				if (calendarElement) {
					this.renderer?.addClass(targetElement, 'time-availability-top');
				} else {
					this.renderer?.removeClass(targetElement, 'time-availability-top');
				}
			}
		}, 100);
	}


	@HostListener("window:scroll", [])
	onWindowScroll() {
		if (this.isBrowser) {
			const verticalOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
			var navbar = document.getElementById("header");
			var HeadH = document.getElementById("header").clientHeight + 50;
			var scrollShow = document.getElementById("scroll_top");
			if (verticalOffset < HeadH) {
				document.getElementById("vebo_body").style.paddingTop = "0";
				navbar.classList.remove('is-sticky');
			}
			if (verticalOffset > HeadH) {
				if (!navbar.classList.contains("awake")) {
					document.getElementById("vebo_body").style.paddingTop = (HeadH - 45) + "px";
					navbar.classList.add('is-sticky');
				}
			}
			if (verticalOffset > HeadH * 2.012) {
				if (!navbar.classList.contains("awake")) {
					navbar.classList.add('awake');
				}
				scrollShow.classList.add('showScroll');
			}
			if (verticalOffset < HeadH * 2.012) {
				if (navbar.classList.contains("awake")) {
					navbar.classList.remove('awake');
				}
				scrollShow.classList.remove('showScroll');
			}
		}
	}

	navbarHeight() {
		if (this.isBrowser) {
			if (window.innerWidth <= 991) {
				var HeadNav = document.getElementById("mobile-collapsable");
				HeadNav.style.height = window.innerHeight + "px";

				var elems = document.querySelectorAll(".dropdown-menu.collapse");
				[].forEach.call(elems, function (el) {
					el.classList.remove("dropdown-menu");
				});
			}
		}
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.navbarHeight();
		if (event.target.innerWidth < 768) {
			this.is_mobile_view = true;
		} else {
			this.is_mobile_view = false;
		}
	}

	ngOnInit() {
		this.getLocationMenuList();
		if (this.isBrowser) {
			if (localStorage.getItem('cart_details')) {
				this.cartDetails = JSON.parse(localStorage.getItem('cart_details'));
				this.is_cart_fill = true;
			}
		}
		const today = new Date();
		this.maximumDOB = {
			year: today.getFullYear(),
			month: today.getMonth() + 1,
			day: today.getDate()
		};
		this.navbarHeight();
		this.ThankyouProcessForm = this.formBuilder.group({
			additional_emails: [''],
			thanku_text: [''],
			thank_you_email: ['']
		});
		this.PhotoVideoShareForm = this.formBuilder.group({
			description: [''],
			hash_tag: [''],
			image_data: [''],
		});
		this.form_data();
		let category_slug_for_gift_ideas = { 'category_for': 'experience', 'type': 'gift-ideas' };
		this.mainService.get_categories(category_slug_for_gift_ideas).subscribe(res => {
			this.categoryList_for_gift_ideas = res?.data;
		});
		let category_slug_for_experience = { 'category_for': 'experience', 'type': 'higher-level-category' };
		this.mainService.get_categories(category_slug_for_experience).subscribe(res => {
			this.categoryList_for_experiece = res?.data;

		});
	}

	sanitizeHtml(html: string): string {
		if (!html) return '';
		return html.replace(/(<br\s*\/?>\s*){2,}/g, '<br>');
	}

	decodeHtmlString(htmlString) {
		if (this.isBrowser) {
			const tempDiv = document.createElement('div');
			tempDiv.innerHTML = htmlString;
			return tempDiv.textContent || tempDiv.innerText || "";
		}
	}

	truncateHtml(html: string, maxLength: number): string {
		let truncatedText = '';
		let charCount = 0;
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, 'text/html');

		function traverseNodes(node: ChildNode): void {
			if (charCount >= maxLength) return;

			if (node.nodeType === Node.TEXT_NODE) {
				const remainingChars = maxLength - charCount;
				truncatedText += node.textContent!.substring(0, remainingChars);
				charCount += node.textContent!.length;
			} else if (node.nodeType === Node.ELEMENT_NODE) {
				truncatedText += `<${node.nodeName.toLowerCase()}${getAttributes(node as Element)}>`;
				node.childNodes.forEach(traverseNodes);
				truncatedText += `</${node.nodeName.toLowerCase()}>`;
			}
		}

		function getAttributes(element: Element): string {
			return Array.from(element.attributes)
				.map((attr) => ` ${attr.name}="${attr.value}"`)
				.join('');
		}

		doc.body.childNodes.forEach(traverseNodes);
		return truncatedText;
	}

	showMoreLess() {
		this.showMore = !this.showMore;
	}

	get formCtrl() {
		return this.OnlineSchedulingForm.controls;
	}

	form_data() {
		if (this.experienceDetails.provider_require_phone == 1 || this.experienceDetails.experience_booking_type > 1) {
			this.OnlineSchedulingForm = this.formBuilder.group({
				name: ['', [Validators.required]],
				phone: ['', [Validators.required]],
				couple_email: [''],
				couple_message: [''],
				booking_type: [''],
				display_book_number: [''],
				variant_id: [''],
				pricegroup_id: [''],
				book_number: [''],
				peek_unit_id: [''],
				peek_availability_id: [''],
				ventrata_availability_id: [''],
				ventrata_unit_id: [''],
				people_count: [''],
				product_code: [''],
				time_options: [''],
				price: [''],
				seat_label: [''],
				serialize_data: [''],
				hotel_pk: ['0'],
				hornblower_category: [''],
				pickup_location_index: [''],
				pickupLocations: ['']
			});

		} else {
			this.OnlineSchedulingForm = this.formBuilder.group({
				name: ['', [Validators.required]],
				phone: [''],
				couple_email: [''],
				couple_message: [''],
				booking_type: [''],
				pricegroup_id: [''],
				display_book_number: [''],
				variant_id: [''],
				peek_unit_id: [''],
				peek_availability_id: [''],
				ventrata_availability_id: [''],
				ventrata_unit_id: [''],
				book_number: [''],
				people_count: [''],
				product_code: [''],
				time_options: [''],
				price: [''],
				seat_label: [''],
				serialize_data: [''],
				hotel_pk: ['0'],
				hornblower_category: [''],
				pickup_location_index: ['']
			});
		}

		this.OnlineSchedulingForm.get("phone")!.valueChanges.pipe(
			throttleTime(600),
			tap((x) => {
				if (x && x.countryCode == "US") {
					if (x?.number) {
						const cleaned = x.number.replace(/\D/g, '');
						const formatted = `${cleaned?.length > 0 ? '(' : ''}${cleaned.slice(0, 3)}${cleaned?.length > 3 ? ') ' : ''}${cleaned.slice(3, 6)}${cleaned?.length > 6 ? '-' : ''}${cleaned.slice(6, 17)}`;
						x.number = formatted;
						this.OnlineSchedulingForm?.get("phone")!.setValue(x);
						this.phoneValidation = false;
					}
				} else {
					this.phoneValidation = true;
				}
			})).subscribe((x: any) => { });
	}

	toggleMenu() {
		this.isMenuOpen = !this.isMenuOpen;
	}

	logout() {
		this.isLoading = true;
		if (this.isBrowser) {
			localStorage.removeItem('authUser');
			localStorage.removeItem('remember_me');
			localStorage.removeItem('profile_img_url')
			localStorage.removeItem('login_token')
			localStorage.removeItem('cart_details');
			localStorage.removeItem('gift_box_details');
		}
		this.cartDetails = [];
		this.show_card_details = false;
		this.is_cart_fill = false;
		this.authUser = "";
		this.authCheck = false;
		this.isLogin = false;
		this.showCountDownText = false;
		setTimeout(() => {
			this.isLoading = false;
			this.showCountDownText = false;
			this.router.navigate(['/login']);
		}, 1000);
	}

	getLocationMenuList() {
		this.locationListSubscription = this.addexperience.getLocationMenuList().subscribe(res => {
			this.locationList = res?.data;
			this.locationAutocompleteList = res?.locations;
			this.cd.detectChanges();
		});
	}

	removeItem(product_id, index) {
		var childRemove = false;
		if (this.cartDetails[index]) {
			if (this.cartDetails[index].parent_id != "undefined" && this.cartDetails[index].parent_id > 0) {
				childRemove = true;
			}
			this.cartDetails.splice(index, 1);
		}
		if (this.cartDetails.length > 0) {
			if (!childRemove) {
				for (let j = 0; j < this.cartDetails.length; j++) {

					if (this.cartDetails[j] && this.cartDetails[j] != "undefined" && typeof this.cartDetails[j].parent_id != "undefined"
						&& this.cartDetails[j].parent_id == product_id) {
						delete this.cartDetails[j];
					}
				}
				this.cartDetails = this.cartDetails.filter(function (element) {
					return element != "undefined";
				});
			}
		}
		if (this.isBrowser) {
			if (this.cartDetails.length > 0) {
				localStorage.setItem('cart_details', JSON.stringify(this.cartDetails));
			} else {
				localStorage.removeItem('cart_details')
			}
		}

		let requestBody = {
			itemDetails: this.cartDetails,
			user_id: this.authUser?.id,
		};

		this.isLoading = true;
		this.cartService.getOrderOverview(requestBody).subscribe(res => {
			if (res?.response == 'success') {
				this.cartData = res?.data;
				this.cartDetails = res?.data?.cart_data?.itemDetails;
				if (res?.data?.final_total == 0) {
					localStorage.removeItem('cart_details');
					this.isLoading = false;
					return;
				}
				const filteredItems = res?.data?.cart_data?.itemDetails?.filter(item => item?.slug !== "gift-box") || [];
				localStorage.setItem('cart_details', JSON.stringify(filteredItems));
				if (this.isBrowser) {
					localStorage.setItem('cart_details', JSON.stringify(filteredItems));
				}
				this.isLoading = false;
			} else {
				this.isLoading = false;
			}
		});
		if (this.isBrowser) {
			var element = document.querySelector("body");
			var htmlelement = document.querySelector("html")
			if (element) {
				element.classList.add('overflow');
			}
			if (htmlelement) {
				htmlelement.classList.add('overflow');
			}
		}

	}

	purchaseUnits(event, unit, partial_price, className) {
		if (className == 'remaingPartialPurchaseUnits') {
			this.totalAmount = (unit * partial_price).toFixed(2);
			this.purchaseUnit = unit;
			this.disableCartBtn = false;
			this.selectedUnit = unit;
		}

	}

	openDialog(expData, qty, variationType, identifier, componentName = 'header', btnType = 0, customAmount = 0) {
		let gratuity = expData?.gratuity ? expData?.gratuity : 0;
		let people_count = expData?.for_individual_price > 0 && this.authUser?.role_id == 4 ? 1 : 2
		if (expData.alternate_quantity == 1) {
			people_count = expData?.max_quantity_range
		}
		this.isLoading = true;
		let id = expData.id;
		let slug = expData.slug;
		let title = expData.title;
		let image = expData.image_url;
		let price = expData?.for_individual_price > 0 && this.authUser?.role_id == 4 ? expData.for_individual_price : expData.couple_price;
		let bookPrice = 0;
		let individualPrice = expData.for_individual_price;
		let tax = expData.sales_tax;
		let experience_type = expData.experience_type
		let type = variationType;
		let city = expData.city;
		let state = expData.state;
		let at_home = expData.at_home;
		let instant_ship = expData.instant_ship;
		let voucher_data
		let name_label
		if (btnType == 1) {
			voucher_data = this.voucher_select_data && Object.keys(this.voucher_select_data).length > 0 ? JSON.parse(this.voucher_select_data) : {}
			this.buyVoucherPeople = voucher_data?.key && expData?.max_quantity != 0 ? voucher_data?.key : 0
			qty = voucher_data?.qty > 0 ? voucher_data?.qty : qty;
			name_label = voucher_data?.name ? voucher_data?.name : this.selected_name ? this.selected_name : ''
		}
		let veriation_id = expData.buy_for_yourself_veriation_id;
		if (componentName == 'guest_view') {
			veriation_id = expData.register_for_couple_veriation_id;
			people_count = 2
		}
		if (type == 'partial-purchase') {
			price = expData.partial_price;
		}
		if ([2, 3, 8].includes(expData.experience_type)) {
			price = customAmount;
		}
		price = Number(price);
		if (price == "" || price == 0) {
			this.amount_required_error = true;
			this.isLoading = false;
			return;
		} else {
			this.amount_required_error = false;
		}
		this.close_certificate_popup();
		let is_purchaseble = 1;
		if (is_purchaseble == 1) {
			this.addCartSpecialClassOnBody();
			if (experience_type == 1) {
			}
			var taxValue = ((price * qty) * tax / 100);
			var gratuityValue = ((price * qty) * gratuity / 100);
			let pusheditems = {};
			var cartitems: any = [];
			if (this.isBrowser) {
				if (localStorage.getItem('cart_details')) {
					cartitems = JSON.parse(localStorage.getItem('cart_details'));
				}
			}
			const $this = this;
			let hasPresentOn = cartitems.find(
				function (el) {

					if (el.product_id === id) {
						$this.isLoading = false;
						return true;
					} else {
						$this.isLoading = false;
						return false;
					}
				}
			);

			var index = cartitems.findIndex(x => x.experience_type != 1);
			if (!hasPresentOn) {
				if (this.authUser) {
					if (this.authUser.role_id == 5 || this.authUser.role_id == 1) {
						pusheditems['voucher_name'] = this.authUser.first_name + ' ' + this.authUser.last_name + ' & ' + this.authUser.partner_first_name + ' ' + this.authUser.partner_last_name;
					} else {
						pusheditems['voucher_name'] = this.authUser.first_name + ' ' + this.authUser.last_name;
					}
				}
				pusheditems['product_id'] = id;
				pusheditems['title'] = title;
				pusheditems['slug'] = slug;
				pusheditems['image'] = image;
				pusheditems['type'] = type;
				pusheditems['option'] = type;
				let total = {
					"line_total": price,
				}
				let encrypted = this.encryptionService.encryptPayload(total);
				pusheditems['encrypted_data'] = encrypted;

				pusheditems['line_total'] = price;
				pusheditems['price_label'] = expData?.price_label;
				pusheditems['alternate_quantity'] = expData.alternate_quantity
				if (expData && expData.alternate_quantity !== undefined && expData.alternate_quantity !== null &&
					expData.alternate_quantity === 1) {
					pusheditems['qty'] = 1;
					pusheditems['alternate_selected_qty'] = qty;
				} else {
					pusheditems['qty'] = qty;
				}
				pusheditems['variation_id'] = veriation_id;
				pusheditems['tax'] = taxValue;
				pusheditems['at_home'] = at_home;
				pusheditems['tax_percentage'] = Number(tax);
				pusheditems['gratuity_percentage'] = Number(gratuity);
				pusheditems['instant_ship'] = instant_ship;
				pusheditems['from_experience'] = 1;
				pusheditems['experience_type'] = experience_type;
				pusheditems['name_label'] = btnType == 1 ? name_label : this.selected_name
				pusheditems['is_added_registries'] = 0;
				pusheditems['keep_it_secrate'] = 0;
				pusheditems['cart_item_type'] = identifier;
				pusheditems['gratuity'] = gratuityValue;
				pusheditems['component_name'] = componentName;
				pusheditems['purchased_from'] = componentName;
				pusheditems['tourcms_component_key'] = this.tourcms_component_key;
				pusheditems['tourcms_channel_id'] = this.tourcms_channel_id;
				pusheditems['people_count'] = expData.alternate_quantity == 1 ? people_count : this.authUser?.role_id == 4 ? people_count : 2;
				pusheditems['city'] = city;
				pusheditems['state'] = state;
				pusheditems['promo_exp'] = 0;
				pusheditems['phone'] = this.OnlineSchedulingForm?.get('phone')?.value;
				pusheditems['instant_book_request'] = this.instant_book_request;
				pusheditems['time_slot_start'] = this.bookStartDate;
				pusheditems['time_slot_end'] = this.bookEndDate;

				if (this.booking_type == 11) {
					const transformedVisitors = this.transformVentrataData()
					pusheditems['booking_extra'] = {
						ventrata_visitors: transformedVisitors
					};
				}

				if (identifier == 'book_now') {
					if (expData?.allow_book_quantity == 1) {
						if (expData.alternate_quantity == 1) {
							if (individualPrice > 0) {
								bookPrice = individualPrice;
							} else {
								individualPrice = Number(price) / 2;
								bookPrice = individualPrice;
							}
						} else {
							if (this.selected_people % 2 === 0) {
								bookPrice = (Number(this.selected_people) / 2) * expData?.regular_price;
							} else {
								if (individualPrice > 0) {
									bookPrice = this.selected_people * individualPrice;
								} else {
									individualPrice = Number(price) / 2;
									bookPrice = this.selected_people * individualPrice;
								}
							}
						}
					} else {
						bookPrice = expData?.regular_price
						this.selected_people = expData?.total_of_people_included_in_this_experience
					}
					var taxValue = ((bookPrice * qty) * tax / 100);
					var gratuityValue = ((bookPrice * qty) * gratuity / 100);
					pusheditems['gratuity'] = gratuityValue;
					pusheditems['line_total'] = bookPrice;
					pusheditems['tax'] = taxValue;
					if (this.instant_book_request >= 1 && this.promo_price > 0) {
						let promoPrice;
						if (expData.alternate_quantity == 1) {
							promoPrice = this.promo_individual_price;
						} else {
							if (this.selected_people % 2 === 0) {
								promoPrice = (Number(this.selected_people) / 2) * this.promo_price;
							} else {
								promoPrice = this.selected_people * this.promo_individual_price;
							}
						}
						let promotaxValue = ((promoPrice * qty) * tax / 100);
						pusheditems['line_total'] = promoPrice;
						pusheditems['tax'] = promotaxValue;
						pusheditems['promo_exp'] = 1;
					}
					if (this.instant_book_request > 0) {
						pusheditems['instant_book'] = 1;
					} else {
						pusheditems['instant_book'] = 0;
					}
					this.booking_type = this.OnlineSchedulingForm.get('booking_type').value;
					this.selected_hotel = this.OnlineSchedulingForm.get('hotel_pk').value;
					this.hornblower_category = this.OnlineSchedulingForm.get('hornblower_category').value;
					this.product_code = this.OnlineSchedulingForm.get('product_code').value;
					this.time_options = this.OnlineSchedulingForm.get('time_options').value;
					this.seat_label = this.OnlineSchedulingForm.get('seat_label').value;
					this.booking_price = this.OnlineSchedulingForm.get('price').value;
					this.peek_availability_id = this.OnlineSchedulingForm.get('peek_availability_id').value;
					this.peek_unit_id = this.OnlineSchedulingForm.get('peek_unit_id').value;
					this.ventrata_availability_id = this.OnlineSchedulingForm.get('ventrata_availability_id').value;
					this.ventrata_unit_id = this.OnlineSchedulingForm.get('ventrata_unit_id').value;
					this.variant_id = this.OnlineSchedulingForm.get('variant_id').value;
					pusheditems['booking_type'] = this.booking_type;
					pusheditems['request_date'] = this.requestedDate;
					pusheditems['request_time'] = this.slot;
					pusheditems['formated_time'] = this.formated_time;
					pusheditems['people_count'] = this.selected_people;
					pusheditems['book_number'] = this.book_number;
					pusheditems['display_book_number'] = this.display_book_number;
					pusheditems['hotel_pk'] = this.selected_hotel;
					pusheditems['serialize_data'] = this.fare_harbor_custom_data;
					pusheditems['customers'] = this.fare_harbor_custom_user_data;
					pusheditems['hornblower_category'] = this.hornblower_category;
					pusheditems['product_code'] = this.product_code;
					pusheditems['time_options'] = this.time_options;
					pusheditems['booking_price'] = this.booking_price;
					pusheditems['seat_label'] = this.seat_label;
					pusheditems['peek_availability_id'] = this.peek_availability_id;
					pusheditems['peek_unit_id'] = this.peek_unit_id;
					pusheditems['ventrata_availability_id'] = this.ventrata_availability_id;
					pusheditems['gocity_unit_id'] = this.goCityUnitId;
					pusheditems['gocity_availability_id'] = this.goCityAvailabilityId;
					pusheditems['gocity_option_id'] = this.goCityOptiontId;
					pusheditems['ventrata_unit_id'] = this.ventrata_unit_id;
					pusheditems['variant_id'] = this.variant_id;
					pusheditems['travelotopos_pricegroup_id'] = this.priceGroup_id;
					pusheditems['visitor_data'] = this.requires_visitors_details?.map(person => {
						return {
							...person,
							details: person?.details?.map(detail => {
								const { err, showError, ...filteredDetail } = detail;
								return filteredDetail;
							}),
						};
					});
					let rezdyFieldsDataInput = this.rezdyFieldsDataInput();
					let rezdyParticipantDataInput = this.rezdyParticipantDataInput();
					if (rezdyFieldsDataInput) {
						pusheditems['rezdy_fields'] = rezdyFieldsDataInput;
					}
					if (rezdyParticipantDataInput) {
						pusheditems['rezdy_participants'] = rezdyParticipantDataInput;
					}
					if (this.booking_type == 14) {
						let bokunFieldsDataInput = this.bokunBookingDataInput();
						let bokunParticipantDataInput = this.bokunPassengerDataInput();
						let mainContactDetails = this.getMainContactDetails();

						let bokun_questions
						if (this.pickup_location_id) {

							bokun_questions = {
								bookingAnswers: bokunFieldsDataInput || [],
								passengersAnswers: bokunParticipantDataInput || [],
								mainContactDetails: mainContactDetails || [],
								pickupPlaceId: Number(this.pickup_location_id),
								dropoffPlaceId: Number(this.dropoff_location_id)

							};
						} else {
							bokun_questions = {
								bookingAnswers: bokunFieldsDataInput || [],
								passengersAnswers: bokunParticipantDataInput || [],
								mainContactDetails: mainContactDetails || [],
							};
						}

						pusheditems['bokun_questions'] = bokun_questions;
					}
					let travelers = this.hornBlowerParticipantDataInput();
					if (travelers) {
						pusheditems['travelers'] = travelers;
					}

					let contact_data = this.linkTwistParticipantDataInput();
					if (contact_data) {
						pusheditems['contact_data'] = contact_data;
					}
					pusheditems['participant_type_alias'] = this.participantTypeAlias;

					let xola_demographics = this.xolaBookingInputData();
					if (xola_demographics) {
						pusheditems['xola_demographics'] = xola_demographics;
					}
				}
				if (this.is_guest_view && this.guest_user_data) {
					pusheditems['user_id'] = this.guest_user_data.id;
					pusheditems['voucher_name'] = this.guest_user_data.couple_full_name;
					pusheditems['to_name'] = this.guest_user_data.couple_full_name;
					pusheditems['purchased_from'] = 'guest-view';
					pusheditems['is_added_registries'] = 1;
					pusheditems['keep_it_secrate'] = (new Date(this.user_data.wedding_date).getTime() > new Date().getTime()) ? 1 : 0;
					pusheditems['purchase_type'] = 'find_registry';

				} else if (this.authUser) {
					if ([2, 3, 8].includes(experience_type)) {
						pusheditems['user_id'] = this.selected_couple;
						pusheditems['voucher_name'] = this.gift_certificate_couple_full_name;
						if (this.selected_couple != 0 && this.selected_couple != this.authUser.id) {
							pusheditems['purchased_from'] = 'guest-view';
							pusheditems['is_added_registries'] = 1;
							pusheditems['people_count'] = btnType == 1 ? this.buyVoucherPeople : 2;
							pusheditems['keep_it_secrate'] = (new Date(this.user_data.wedding_date).getTime() > new Date().getTime()) ? 1 : 0;				// on checkout Message Tab 'TO' Options will not display.
							pusheditems['purchase_type'] = 'find_registry';
						} else {
							pusheditems['purchased_from'] = '';
							pusheditems['is_added_registries'] = 0;
							pusheditems['people_count'] = btnType == 1 ? this.buyVoucherPeople : 2;
							pusheditems['keep_it_secrate'] = 0;
						}
					}
					else {
						pusheditems['user_id'] = this.authUser.id;
					}
				} else {
					if ([2, 3, 8].includes(experience_type) || slug == 'gift-certificate') {
						pusheditems['user_id'] = this.selected_couple;
						pusheditems['voucher_name'] = this.gift_certificate_couple_full_name;
						if (!this.authUser && this.selected_couple != 0) {
							pusheditems['purchased_from'] = 'guest-view';
							pusheditems['is_added_registries'] = 1;
							pusheditems['people_count'] = btnType == 1 ? this.buyVoucherPeople : 2;
							pusheditems['keep_it_secrate'] = (new Date(this.user_data.wedding_date).getTime() > new Date().getTime()) ? 1 : 0;
							pusheditems['purchase_type'] = 'find_registry';
						} else {
							pusheditems['purchased_from'] = '';
							pusheditems['is_added_registries'] = 0;
							pusheditems['people_count'] = btnType == 1 ? this.buyVoucherPeople : 2;
							pusheditems['keep_it_secrate'] = 0;
						}

					}
					else {
						pusheditems['user_id'] = 0;
					}
				}
				cartitems.push(pusheditems);
				if (this.showContinueShopBtn == false) {
					this.cartService.sendMessage(JSON.stringify(cartitems));
				}
				this.partialPurchasePopup.hide();
				if (this.isBrowser) {
					localStorage.setItem('cart_details', JSON.stringify(cartitems));
				}
				this.cartService.sendMessage(JSON.stringify(cartitems));
			} else {
				if ([2, 3, 8].includes(experience_type) || slug == 'gift-certificate') {
					cartitems[index].line_total = Number(price);
					cartitems[index].user_id = this.selected_couple;
					cartitems[index].voucher_name = this.gift_certificate_couple_full_name;
					if (this.selected_couple != 0 && !this.authUser) {
						cartitems[index].purchased_from = 'guest-view';
						cartitems[index].is_added_registries = 1;
						cartitems[index].keep_it_secrate = (new Date(this.user_data.wedding_date).getTime() > new Date().getTime()) ? 1 : 0;
					} else {
						cartitems[index].purchased_from = '';
						cartitems[index].is_added_registries = 0;
						cartitems[index].keep_it_secrate = 0;
					}
					if (this.isBrowser) {
						localStorage.setItem('cart_details', JSON.stringify(cartitems));
						this.cartService.sendMessage(localStorage.getItem('cart_details'));
					}
				} else {
					this.toastr.errorToastr("Already added in your cart", 'Error!');
				}
			}
		}
		if (this.showContinueShopBtn == false) {
			this.experieneDetailPopupClose();
		}
		this.isLoading = false;
		this.amount = 0;
		this.voucher_select_data = {}
		this.close();
	}

	transformDateForFareharbor(inputDate: string): string | null {
		if (inputDate) {
			const dateParts = inputDate?.split('-');
			if (dateParts.length === 3) {
				const formattedDateString = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
				const dateObj = new Date(formattedDateString);
				if (!isNaN(dateObj.getTime())) {
					return this.datepipe.transform(dateObj, 'yyyy-MM-dd');
				} else {
					console.error(`Invalid date: ${inputDate}`);
					return null;
				}
			} else {
				console.error(`Unexpected date format: ${inputDate}`);
				return null;
			}
		}
		return null;
	}

	requestForBooking() {
		this.name_error = false;
		this.show_refund_button = false
		let name_str = this.OnlineSchedulingForm.get('name').value.toLowerCase();
		let invaild_str = this.names_arr.filter(function (txt) {
			return name_str.includes(txt);
		});
		if (this.instant_book_request == 1 || this.instant_book_request == 2) {
			if (!this.is_exp_purchased && (!this.selected_people || Number(this.selected_people) == 0) && this.experienceDetails.allow_book_quantity == 1) {
				this.displayRequiredMessageForPeopleCount = true;
				return;
			} else {
				this.displayRequiredMessageForPeopleCount = false;
			}
			this.submitted = true;
			if (this.OnlineSchedulingForm.invalid) {
				return;
			} else if (invaild_str != "") {
				this.name_error = true;
				return;
			} else if (!this.requestedDate) {
				if (!this.requestedDate) {
					this.toastr.errorToastr("Please select a valid date.", 'Error!');
				}
				return;
			}
			if (this.instant_book_request == 1 &&
				(this.experienceDetails.experience_booking_type != 7 && this.experienceDetails.experience_booking_type != 12)) {
				if (this.slot == '') {
					if (this.no_slot_avail_message == '') {
						this.toastr.errorToastr("Please select any time slot.", 'Error!');
					} else {
						this.toastr.errorToastr(this.no_slot_avail_message, 'Error!');
					}
					return;
				} else if (this.OnlineSchedulingForm.get('hotel_pk').value == 0 && this.OnlineSchedulingForm.get('booking_type').value == 2 && this.hotel_data.length > 0) {
					this.toastr.errorToastr("Please select hotel.", 'Error!');
					return;
				}
				if (this.OnlineSchedulingForm.get('booking_type').value == 5 && this.requires_visitors_details && this.requires_visitors_details.length > 0) {
					let isErr = false;
					for (let index = 0; index < this.requires_visitors_details.length; index++) {
						this.requires_visitors_details[index]?.details.forEach((element, i) => {
							const visitorD = element;
							if (visitorD.value.trim() == "") {
								isErr = true;
								visitorD.err = 'This field is required.';
							} else {
								visitorD.err = null;
							}
						});
					}
					if (!isErr) {
						this.matchingValuesExist = this.checkMatchingValues(this.requires_visitors_details);
					}
					if (isErr || this.matchingValuesExist) {
						return;
					}
				}

			} else {
			}
		} else {
			this.toastr.errorToastr("Invalid Request.", 'Error!');
			return;
		}
		this.isLoading = true;
		this.OnlineSchedulingForm.get('serialize_data').setValue(this.dynamic_option_array);
		if (this.requestedDate) {
			if (!this.show_instant_booking) {
				this.slot = "";
			}
			var requestbody = this.OnlineSchedulingForm.value;
			if (this.experienceDetails.experience_booking_type == 10) {
				requestbody.tourcms_component_key = this.tourcms_component_key;
				requestbody.tourcms_channel_id = this.tourcms_channel_id;
			}
			requestbody.experience_id = this.experienceDetails.id;
			requestbody.requested_date = this.requestedDate;
			requestbody.slot = this.slot;
			requestbody.people_count = this.selected_people;
			requestbody.instant_book_request = this.instant_book_request;
			requestbody.voucher_code = this.experienceDetails.voucher_code;
			requestbody.visitor_data = this.requires_visitors_details;

			if (this.fare_harbor_custom_user_data && this.fare_harbor_custom_user_data.length > 0) {
				for (let customerFieldData of this.fare_harbor_custom_user_data) {
					if (customerFieldData.custom_field_values && customerFieldData.custom_field_values.length > 0) {
						customerFieldData.custom_field_values = customerFieldData.custom_field_values.filter((customField) => {
							if (customField.field_type && customField.value != '') {
								if (customField.field_type == 'date') {
									const transformedDate = this.transformDateForFareharbor(customField?.value);
									if (transformedDate) {
										customField.value = transformedDate;
									}
								}
								delete customField["options"];
								delete customField["label_title"];
								delete customField["is_required"];
								delete customField["field_type"];
								delete customField["description"];
								delete customField["field_type2"];
								return customField;
							}
						});
					}
				}
				requestbody['customers'] = this.fare_harbor_custom_user_data;
			}

			if (this.fare_harbor_custom_data && this.fare_harbor_custom_data.length > 0) {
				this.fare_harbor_custom_data = this.fare_harbor_custom_data.filter((customField) => {
					if (customField.field_type && customField.value != '') {
						if (customField.field_type == 'date') {
							const transformedDate = this.transformDateForFareharbor(customField?.value);
							if (transformedDate) {
								customField.value = transformedDate;
							}
						}
						delete customField["options"];
						delete customField["label_title"];
						delete customField["is_required"];
						delete customField["field_type"];
						delete customField["description"];
						delete customField["field_type2"];
						return customField;
					}
				});
				requestbody['serialize_data'] = this.fare_harbor_custom_data;
			}
			requestbody['book_number'] = this.book_number;
			requestbody['display_book_number'] = this.display_book_number;
			requestbody['time_slot_start'] = this.bookStartDate;
			requestbody['time_slot_end'] = this.bookEndDate;
			requestbody['gocity_unit_id'] = this.goCityUnitId;
			requestbody['gocity_availability_id'] = this.goCityAvailabilityId;
			requestbody['gocity_option_id'] = this.goCityOptiontId;
			if (this.booking_type == 11) {
				const transformedVisitors = this.transformVentrataData()
				requestbody['booking_extra'] = {
					ventrata_visitors: transformedVisitors
				};
			}

			let rezdyFieldsDataInput = this.rezdyFieldsDataInput();
			let rezdyParticipantDataInput = this.rezdyParticipantDataInput();
			if (rezdyFieldsDataInput) {
				requestbody['rezdy_fields'] = rezdyFieldsDataInput;
			}
			if (rezdyParticipantDataInput) {
				requestbody['rezdy_participants'] = rezdyParticipantDataInput;
			}
			if (this.booking_type == 14) {
				let bokunFieldsDataInput = this.bokunBookingDataInput();
				let bokunParticipantDataInput = this.bokunPassengerDataInput();
				let mainContactDetails = this.getMainContactDetails();

				let bokun_questions
				if (this.pickup_location_id) {
					bokun_questions = {
						bookingAnswers: bokunFieldsDataInput || [],
						passengersAnswers: bokunParticipantDataInput || [],
						mainContactDetails: mainContactDetails || [],
						pickupPlaceId: Number(this.pickup_location_id),
						dropoffPlaceId: Number(this.dropoff_location_id),

					};
				} else {
					bokun_questions = {
						bookingAnswers: bokunFieldsDataInput || [],
						passengersAnswers: bokunParticipantDataInput || [],
						mainContactDetails: mainContactDetails || [],
					};
				}
				requestbody['bokun_questions'] = bokun_questions;
			}

			let travelers = this.hornBlowerParticipantDataInput();
			if (travelers) {
				requestbody['travelers'] = travelers;
			}

			let contact_data = this.linkTwistParticipantDataInput();
			if (contact_data) {
				requestbody['contact_data'] = contact_data;
			}
			requestbody['participant_type_alias'] = this.participantTypeAlias;
			requestbody['formated_time'] = this.formated_time;
			requestbody['travelotopos_pricegroup_id'] = this.priceGroup_id;

			let xola_demographics = this.xolaBookingInputData();
			if (xola_demographics) {
				requestbody['xola_demographics'] = xola_demographics;
			}
			if (this.is_exp_purchased) {
				this.submitted = true;
				this.experienceBookingService.requestForBooking(requestbody, this.tokenkey).subscribe(res => {
					if (res.response == 'success') {
						this.backfromRedemmeScheduleBtn = false;
						this.bookingDate = res.data.bookingDate;
						this.bookingStatus = res.data.bookingStatus;
						this.bookingMessage = res.data.message;
						this.bookingShortMessage = res.data.shortMessage;
						this.experienceDetails.booking_uuid = res.data.booking_uuid;
						this.experienceDetails.booking_short_message = res.data.shortMessage;
						this.experienceDetails.booking_message = res.data.message;
						this.experienceDetails.booking_slot = this.slot;
						this.experienceDetails.booking_slot_formated = this.formated_time;
						this.experienceDetails.experience_status_msg = res.data.bookingStatus;
						this.experienceDetails.experience_status = res.data.experience_status;
						this.experienceDetails.bookingDate = res.data.bookingDate;
						this.experienceDetails.promo_refund = res.data.promo_refund;
						this.experienceDetails.is_cancellable = res?.data?.is_cancellable;
						if (res.data.cancellation_please_note) {
							this.experienceDetails.cancellation_please_note = res.data.cancellation_please_note;
						}
						if (res.data.booking_order_number) {
							this.experienceDetails.booking_order_number = res.data.booking_order_number;
						}
						if (typeof this.authUser != "undefined" && typeof this.authUser != null && typeof this.authUser.name != "undefined" && typeof this.authUser.name != null && this.show_user_name_input) {
							this.authUser.name = this.OnlineSchedulingForm.get('name').value;
						}
						this.onlineBookingRejectBlock = false;
						this.onlineScheduleBlock = false;
						this.onlineBookingMsgBlock = true;
						this.priceBlock = true;
						this.isLoading = false;
						this.submitted = false;
						this.messageService.sendExpStatusChangedToMainComponent({
							'exp_id': this.experienceDetails.id,
							'experience_status': this.experienceDetails.experience_status,
							'experience_status_msg': this.experienceDetails.experience_status_msg,
							'exp_data': this.experienceDetails
						});
						if (this.isBrowser) {
							var element = document.querySelector("body")
							var htmlelement = document.querySelector("html")
							if (element)
								element.classList.remove('overflow');
							if (htmlelement) {
								htmlelement.classList.remove('overflow');
							}
						}
						this.requestedDate = '';
						this.booking_date_selected = ''
					} else if (res.response == 'error') {
						if (this.isBrowser) {
							var element = document.querySelector("body")
							var htmlelement = document.querySelector("html")
							if (element)
								element.classList.remove('overflow');
							if (htmlelement) {
								htmlelement.classList.remove('overflow');
							}
						}
						this.experieneDetailPopupClose();
						this.isLoading = false;
						this.submitted = false;
						this.toastr.errorToastr(res?.message, 'Error!');
					}
				});
			} else {
				let identifier = 'book_now';
				let componentName = 'header';
				let qty = this.selected_qty > 1 ? this.selected_qty : 1;
				let variationType = 'buy-for-yourself';
				this.openDialog(this.experienceDetails, qty, variationType, identifier, componentName = 'header');
			}
		} else {
			this.toastr.errorToastr("Please select the date first.", 'Error!');
			this.isLoading = false;
		}
	}

	checkMatchingValues(persons) {
		for (let i = 0; i < persons.length; i++) {
			for (let j = i + 1; j < persons.length; j++) {
				const person1 = persons[i];
				const person2 = persons[j];
				for (let detail1 of person1.details) {
					for (let detail2 of person2.details) {
						if (detail1?.key != 'date_of_birth' && detail1?.key != 'nationality' && detail1?.key != 'address' && detail1?.key != 'pickup_location' && detail1?.key != 'full_name' && detail1.key === detail2.key && detail1.value === detail2.value) {
							return true; // Matching values found
						}
					}
				}
			}
		}
		return false; // No matching values found
	}

	select_location(event) {
		this.pickupLocationList.forEach((element, i) => {
			if (i == this.formCtrl['pickup_location_index'].value) {
				this.OnlineSchedulingForm.patchValue({
					pickupLocations: element
				})
			}
		});
		this.selectedLocation = this.formCtrl['pickup_location_index'].value;
		this.validateBookNowButton();
	}

	cancelBooking() {
		this.submitted = true;
		this.isLoading = true;
		var requestbody = {
			'experience_id': this.experienceDetails.id,
			'booking_uuid': this.experienceDetails.booking_uuid,
			'booking_type': this.experienceDetails.booking_type,
			'voucher_code': this.experienceDetails.voucher_code,
			'cancel_reason': this.selectedReason
		};
		this.experienceBookingService.cancelBooking(requestbody, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				if (this.experienceDetails.experience_booking_type > 0) {
					this.newBookingRequestBtn = true;
				} else {
					this.showRedeemNowBtn = true;
				}
				this.showExchangeBtn = true;
				this.onlineBookingRejectBlock = false;
				this.onlineBookingMsgBlock = false;
				this.onlineScheduleBlock = false;
				this.isLoading = false;
				this.experienceDetails.experience_status_msg = res.data.experience_status_msg;
				this.experienceDetails.experience_status = res.data.experience_status;
				this.messageService.sendExpStatusChangedToMainComponent({ 'exp_id': this.experienceDetails.id, 'experience_status': this.experienceDetails.experience_status, 'experience_status_msg': this.experienceDetails.experience_status_msg, 'exp_data': this.experienceDetails });
				this.closeModal();
				this.toastr.successToastr(res?.message, 'Success!');
			} else if (res.response == 'error') {
				this.experieneDetailPopupClose();
				this.isLoading = false;
				this.closeModal();
				this.toastr.errorToastr(res?.response, 'Error!');

			}
		});
	}


	viewScheduleExpAvailabilityInfo() {
		this.isLoading = true;
		this.backfromRedemmeScheduleBtn = true;
		this.newBookingRequestBtn = false;
		this.showExchangeBtn = false;
		this.showAddRegBtn = false;
		this.showRemoveRegBtn = false;
		this.showBuyYourSelfBtn = false;
		this.showBuyAsGiftBtn = false;
		this.showCloseBtn = false;
		this.showReviewExpBtn = false;
		this.showAddPhotoVideoBtn = false;
		this.showSendThankYouBtn = false;
		this.showAddPhotoDeviceBtn = false;
		this.showAddVideoDeviceBtn = false;
		this.showRedeemScheduleBtn = false;
		this.showExchangeBtn = false;
		this.showViewPrintBtn = false;
		this.onlineScheduleBlock = true;
		this.showScheduleExpBtn = false;
		this.showViewAvaibalityExpBtn = false;
		this.showRedeemNowBtn = false;
		this.showExcConfirmBtn = false;
		this.showExcCancelBtn = false;
		this.showCompletePurchBtn = false;
		this.showBackBtn = false;
		this.showCheckoutBtn = false;
		this.showContinueShopBtn = false;
		this.priceBlock = false;
		this.exchangeBlock = false;
		this.redeemScheduleBlock = false;
		this.onlineBookingRejectBlock = false;
		this.onlineBookingMsgBlock = false;
		this.isActiveTab = 'how_to_redeem';
		if (this.experienceDetails.allow_fareharbor == 1) {
			this.request_to_book = false;
		}
		else {
			this.request_to_book = true;
		}
		this.isLoading = false;
	}

	addToRegistry(exp_id, type, is_suggestion = 0, registry_for = "") {
		this.isLoading = true;
		this.addexperience.addExperienceRegistry(exp_id, type, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.messageService.sendTotalMessage(res.data);
				if (Object.keys(this.experienceDetails).length > 0) {
					if (this.experienceDetails.id == exp_id) {
						this.experienceDetails.experience_status = res.data.is_registry_status;
						this.experienceDetails.experience_status_msg = res.data.experience_status_msg;
						this.experienceDetails.add_reg_msg_class = res.data.add_reg_msg_class;

						if (this.experienceDetails.experience_status == 1) {
							this.showRemoveRegBtn = true;
							this.showAddRegBtn = false;
						} else if (this.experienceDetails.experience_status == 0) {
							this.showRemoveRegBtn = false;
							this.showAddRegBtn = true;
						}
					}
				}

				this.messageService.sendExpStatusChangedToMainComponent({ 'exp_id': exp_id, 'type': type, 'is_suggestion': is_suggestion, 'registry_for': registry_for, 'is_registry_status': res.data.is_registry_status, 'experience_status': res.data.is_registry_status, 'experience_status_msg': res.data.experience_status_msg, 'add_reg_msg_class': res.data.add_reg_msg_class, 'added_registry_type': res.data.added_registry_type, 'exp_data': this.experienceDetails }); // send data to add Experience component.
				this.isLoading = false;

				this.experieneDetailPopupClose();

				if (this.isBrowser) {
					var element = document.querySelector("body");
					var htmlelement = document.querySelector("html")
					if (element) {
						element.classList.remove('overflow');
					}
					if (htmlelement) {
						htmlelement.classList.remove('overflow');
					}
				}

			} else if (res.response == 'error') {
				this.isLoading = false;
			}
			this.isLoading = false;
		});
	}
	redeemScheduleInfo() {
		this.isLoading = true;
		this.showDetailsTab = true;
		this.showExchangeTab = false;
		this.showGiftedByTab = true;
		this.show_refund_button = false
		this.showPhotosVideosTab = false;
		this.showSummeryTab = true;
		this.showHowToRedeemTab = true;
		this.showPartialPurchTab = false;
		this.showReviewTab = false;
		this.showJoinUsTab = false;
		if (this.experienceDetails.is_registry_status == 0) {
			this.showRemoveRegBtn = false;
			this.showAddRegBtn = true;
		}
		if (this.experienceDetails.is_registry_status == 1) {
			this.showRemoveRegBtn = true;
			this.showAddRegBtn = false;
		}
		// this.showAddRegBtn = false; 
		// this.showRemoveRegBtn = false;
		this.showBuyYourSelfBtn = false;
		this.showBuyAsGiftBtn = false;
		this.showCloseBtn = false;
		this.showReviewExpBtn = false;
		this.showAddPhotoVideoBtn = false;
		this.showSendThankYouBtn = false;
		this.showAddPhotoDeviceBtn = false;
		this.showAddVideoDeviceBtn = false;
		this.showRedeemScheduleBtn = false;
		this.showExchangeBtn = false;
		this.showViewPrintBtn = false;
		this.showSeasonHeadline = false;
		if (this.experienceDetails.experience_booking_type > 0) {
			this.showViewAvaibalityExpBtn = false;
			this.onlineScheduleBlock = true;
			this.showScheduleExpBtn = false;
			this.showRedeemNowBtn = false;
			if (this.experienceDetails.experience_booking_type == 1) {
				this.request_to_book = true;
			}
			else {
				this.request_to_book = false;
			}

		} else {
			this.showRedeemNowBtn = true;
			this.showScheduleExpBtn = true;
			this.showViewAvaibalityExpBtn = false;
		}
		this.showExcConfirmBtn = false;
		this.showExcCancelBtn = false;
		this.showCompletePurchBtn = false;
		this.showBackBtn = false;
		this.showCheckoutBtn = false;
		this.showContinueShopBtn = false;
		this.backfromRedemmeScheduleBtn = true;
		this.priceBlock = false;
		this.exchangeBlock = false;
		this.redeemScheduleBlock = false;
		this.onlineBookingMsgBlock = false;
		this.isActiveTab = 'how_to_redeem';
		this.isLoading = false;
	}

	// back button
	backfromRedemmeSchedule() {
		if (this.experienceDetails.is_registry_status == 0) {
			this.showRemoveRegBtn = false;
			this.showAddRegBtn = true;
		}
		if (this.experienceDetails.is_registry_status == 1) {
			this.showRemoveRegBtn = true;
			this.showAddRegBtn = false;
		}
		this.showViewAvaibalityExpBtn = false;
		this.showRedeemNowBtn = false;
		this.showRedeemNowConfirm = false;
		this.showRedeemNowCancel = false;
		this.backfromRedemmeScheduleBtn = false;
		this.priceBlock = true;
		this.showRedeemScheduleBtn = true;
		this.onlineScheduleBlock = false;
		this.showSeasonHeadline = true;
		this.isActiveTab = 'summary';
		if (this.experienceDetails.show_refund_button == 1) {
			this.show_refund_button = true;
		} else {
			this.show_refund_button = false;
		}
		if (this.is_exp_purchased) {
			this.showViewPrintBtn = true;
			this.showExchangeBtn = true;
		} else {
			this.showBuyYourSelfBtn = true;
			this.showBuyAsGiftBtn = true;
		}
	}

	addCartSpecialClassOnBody() {
		if (this.isBrowser) {
			if (window.innerWidth > 768) {

				var element = document.querySelector("body");
				var htmlelement = document.querySelector("html")
				if (element) {
					element.classList.add('overflow');
				}
				if (htmlelement) {
					htmlelement.classList.add('overflow');
				}
			}
		}
	}

	hidePopup() {
		this.showCountDownText = false;
	}

	@HostListener('document:click', ['$event'])
	onClickOutside(event: Event) {
		const target = event.target as HTMLElement;
		const clickedInside = this.miniCart?.nativeElement.contains(target);

		if (!clickedInside) {
			this.closeCart();
		}
	}

	closeCart() {
		this.show_card_details = false;
		// this.show_card_details = false;
		this.removeOverflow();
	}

	removeOverflow() {
		if (this.isBrowser) {
			var element = document.querySelector("body")
			var htmlelement = document.querySelector("html")
			if (element) {
				element.classList.remove('overflow');
			}
			if (htmlelement) {
				htmlelement.classList.remove('overflow');
			}
		}
	}

	addExchangeInfo() {
		this.isLoading = true;
		this.showDetailsTab = true;
		this.showExchangeTab = true;
		this.showGiftedByTab = true;
		this.showPhotosVideosTab = false;
		this.showSummeryTab = false;
		this.showHowToRedeemTab = false;
		this.showPartialPurchTab = false;
		this.showReviewTab = false;
		this.showJoinUsTab = false;
		this.show_refund_button = false
		this.showAddRegBtn = false;
		this.showRemoveRegBtn = false;
		this.showBuyYourSelfBtn = false;
		this.showBuyAsGiftBtn = false;
		this.showCloseBtn = false;
		this.showReviewExpBtn = false;
		this.showAddPhotoVideoBtn = false;
		this.showSendThankYouBtn = false;
		this.showAddPhotoDeviceBtn = false;
		this.showAddVideoDeviceBtn = false;
		this.showRedeemScheduleBtn = false;
		this.showExchangeBtn = false;
		this.showViewPrintBtn = false;
		this.showScheduleExpBtn = false;
		this.showRedeemNowBtn = false;
		this.showExcConfirmBtn = true;
		this.showExcCancelBtn = true;
		this.showCompletePurchBtn = false;
		this.showBackBtn = false;
		this.showCheckoutBtn = false;
		this.showContinueShopBtn = false;
		this.priceBlock = false;
		this.exchangeBlock = true;
		this.redeemScheduleBlock = false;
		this.showSeasonHeadline = false;
		this.isActiveTab = 'exchange';
		this.isLoading = false;
	}

	showCheckout(expData, qty, variationType, identifier, componentName = 'header') {
		this.showCheckoutBtn = true;
		this.showContinueShopBtn = false;
		this.addedtocart = true;
		this.showCompletePurchBtn = false;
		this.showExchangeBtn = false
		this.openDialog(expData, qty, variationType, identifier, componentName)
		this.showCheckoutBtn = false;

	}

	exchangeExp(id, order_id, order_item_id, voucher_code) {
		this.isLoading = true;
		this.addexperience.exchangeExp(voucher_code, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.experienceDetails.experience_status = 3;
				this.experienceDetails.experience_status_msg = 'EXCHANGED';
				this.experienceDetails.exchange_date = new Date();
				this.messageService.sendExpStatusChangedToMainComponent({ 'exp_id': this.experienceDetails.id, 'experience_status': this.experienceDetails.experience_status, 'experience_status_msg': this.experienceDetails.experience_status_msg, 'exp_data': this.experienceDetails });
				this.showExcConfirmBtn = false;
				this.newBookingRequestBtn = false;
				this.onlineBookingMsgBlock = false;
				this.showExcCancelBtn = false;
				this.exchangeBlock = false;
				this.exchangedBlock = true;
				this.show_close_button = true;
				this.showBuyYourSelfBtn = false;
				this.showCloseBtn = false;
				this.showBuyAsGiftBtn = false;
				this.showEwalletBalance = true;
				this.getWalletAmount();
				setTimeout(() => {
					this.isLoading = false;
				}, 100);
			} else if (res?.response == 'error') {
				this.experieneDetailPopupClose();
				setTimeout(() => {
					this.isLoading = false;
				}, 100);
				this.toastr.errorToastr(res?.message, 'Error!');
			}
		});
	}

	scheduleExpInfo() {
		this.isLoading = true;
		this.showAddRegBtn = false;
		this.showRemoveRegBtn = false;
		this.showBuyYourSelfBtn = false;
		this.showBuyAsGiftBtn = false;
		this.showCloseBtn = false;
		this.showReviewExpBtn = false;
		this.showAddPhotoVideoBtn = false;
		this.showSendThankYouBtn = false;
		this.showAddPhotoDeviceBtn = false;
		this.showAddVideoDeviceBtn = false;
		this.showRedeemScheduleBtn = false;
		this.showExchangeBtn = false;
		this.showViewPrintBtn = true;
		this.showScheduleExpBtn = false;
		this.showViewAvaibalityExpBtn = false;
		this.showRedeemNowBtn = false;
		this.showExcConfirmBtn = false;
		this.showExcCancelBtn = false;
		this.showCompletePurchBtn = false;
		this.showBackBtn = true;
		this.showCheckoutBtn = false;
		this.showContinueShopBtn = false;
		this.priceBlock = false;
		this.exchangeBlock = false;
		this.redeemScheduleBlock = true;
		this.isActiveTab = 'how_to_redeem';
		this.isLoading = false;
	}

	redeemNowExp(id, order_id, order_item_id, voucher_code) {
		this.isLoading = true;
		this.addexperience.redeemExp(voucher_code, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.experienceDetails.experience_status = 5;
				this.experienceDetails.experience_status_msg = 'REDEEMED';
				this.experienceDetails.redeem_date = new Date();

				this.messageService.sendExpStatusChangedToMainComponent({ 'exp_id': this.experienceDetails.id, 'experience_status': this.experienceDetails.experience_status, 'experience_status_msg': this.experienceDetails.experience_status_msg, 'exp_data': this.experienceDetails }); // send data to add Experience component.

			} else if (res.response == 'error') {
				this.experieneDetailPopupClose();
			}
			this.experieneDetailPopupClose();

		});
		this.isLoading = false;
	}

	addPhotoVideoInfo() {
		this.isLoading = true;
		this.showDetailsTab = true;
		this.showExchangeTab = false;
		this.showGiftedByTab = true;
		this.showPhotosVideosTab = true;
		this.showSummeryTab = false;
		this.showHowToRedeemTab = false;
		this.showPartialPurchTab = false;
		this.showReviewTab = false;
		this.showJoinUsTab = false;
		this.showRemoveRegBtn = false;
		this.showAddRegBtn = false;
		this.showBuyYourSelfBtn = false;
		this.showBuyAsGiftBtn = false;
		this.showCloseBtn = false;
		this.showReviewExpBtn = false;
		this.showAddPhotoVideoBtn = false;
		this.showSendThankYouBtn = false;
		this.showAddPhotoDeviceBtn = true;
		this.showAddVideoDeviceBtn = true;
		this.showRedeemScheduleBtn = false;
		this.showExchangeBtn = false;
		this.showViewPrintBtn = false;
		this.showScheduleExpBtn = false;
		this.showRedeemNowBtn = false;
		this.showExcConfirmBtn = false;
		this.showExcCancelBtn = false;
		this.showCompletePurchBtn = false;
		this.showBackBtn = false;
		this.showCheckoutBtn = false;
		this.showContinueShopBtn = false;
		this.showEwalletBalance = false;

		this.priceBlock = false;
		this.exchangeBlock = false;
		this.redeemScheduleBlock = false;
		this.reviewRatingBlock = false;
		if (this.experienceDetails.experience_type == 3) {
			this.redeemedBlock = false;
		} else {
			this.redeemedBlock = true;
		}
		this.exchangedBlock = false;
		this.isActiveTab = 'detail';
		this.isLoading = false;
	}

	sendThankYou() {
		this.isLoading = true;
		this.addPhotoVideoModal.hide();
		this.experieneDetailPopupClose();
		this.sendThankYouEmailImages();
		this.thankYouStep1 = true;
		this.thankYouStep2 = false;
		this.thankYouStep3 = false;
		this.thankYouStep4 = false;
		this.thankYouStep5 = false;
		this.thankyouModal.show();
		this.isLoading = false;
		this.thank_you_file_url = '';
		this.ThankyouProcessForm.controls['additional_emails'].setValue('');
		this.ThankyouProcessForm.controls['thanku_text'].setValue('');
	}

	ganerateStaticFrames() {
		var frameArr = [];
		frameArr.push({ 'id': 2, 'image_url': 'assets/images/frame2.png' });
		frameArr.push({ 'id': 3, 'image_url': 'assets/images/frame3.png' });
		frameArr.push({ 'id': 4, 'image_url': 'assets/images/frame4.png' });
		frameArr.push({ 'id': 5, 'image_url': 'assets/images/frame5.png' });
		frameArr.push({ 'id': 6, 'image_url': 'assets/images/frame6.png' });
		frameArr.push({ 'id': 7, 'image_url': 'assets/images/frame7.png' });
		frameArr.push({ 'id': 8, 'image_url': 'assets/images/frame8.png' });
		this.frameImages = frameArr;
	}

	addPhotoVideoFromDevice(type) {
		this.isLoading = true;
		this.experieneDetailPopupClose();

		if (type == 'photo') {
			this.removeFrame();
			this.choosedSharePhotoUrl = '';
			this.mainService.getFrameImages(this.tokenkey).subscribe(res => {
				if (res.response == 'success') {
					this.frameImages = res.data;
					this.ganerateStaticFrames();
					this.photoVideoStep1 = true;
					this.photoVideoStep2 = false;
					this.ShareVideoStep1 = false;
					this.photoVideoStep3 = false;
				} else if (res.response == 'error') {
					this.experieneDetailPopupClose();

				}
			})
		} else {
			this.choosedShareVideoUrl = '';
			this.ShareVideoStep1 = true;
			this.photoVideoStep1 = false;
			this.photoVideoStep2 = false;
			this.photoVideoStep3 = false;
		}
		this.hide_back_button = true;
		this.addPhotoVideoModal.show();
		this.isLoading = false;
	}

	thankYouNext(step) {
		this.isLoading = true;
		if (step == 1) {
			this.thankYouStep1 = true;
			this.thankYouStep2 = false;
			this.thankYouStep3 = false;
			this.thankYouStep4 = false;
			this.thankYouStep5 = false;
		} else if (step == 2) {
			this.thank_you_file_url = '';
			this.thankYouStep1 = false;
			this.thankYouStep2 = true;
			this.thankYouStep3 = false;
			this.thankYouStep4 = false;
			this.thankYouStep5 = false;
		} else if (step == 3) {
			this.thankYouStep1 = false;
			this.thankYouStep2 = false;
			this.thankYouStep3 = true;
			this.thankYouStep4 = false;
			this.thankYouStep5 = false;
		} else if (step == 4) {
			this.thankYouStep1 = false;
			this.thankYouStep2 = false;
			this.thankYouStep3 = false;
			this.thankYouStep4 = true;
			this.thankYouStep5 = false;
		}
		this.isLoading = false;
		this.thankYouEmailReceipents = this.ThankyouProcessForm.get('additional_emails').value;
	}

	editThankYouImage() {
		this.thank_you_file_url = '';
	}

	chooseThankyouImage(event) {
		this.isLoading = true;
		this.thankYouImages = [];
		var files = event.target.files;
		this.thank_you_file_path = event.target.files[0];
		this.fileFormat = event?.target?.value?.split('.')?.pop();
		if (this.fileFormat == "jpg" || this.fileFormat == "JPG" || this.fileFormat == "jpeg" || this.fileFormat == "png" || this.fileFormat == "PNG") {
			var reader = new FileReader();
			reader.readAsDataURL(files[0]);
			reader.onload = (e: any) => {
				this.thankYouImages.push(e.target.result);
				this.thank_you_file_url = e.target.result;
			}
			this.isLoading = false;
		} else {
			this.isLoading = false;
			this.toastr.errorToastr("Invalid file format.", 'Error!');
			return;
		}
	}

	chooseThankyouImageFromUploaded(imageId, imageUrl) {
		const self = this;
		this.images = [];
		const xhr = new XMLHttpRequest();
		self.thankYouImageId = imageId;
		xhr.open("GET", imageUrl);
		xhr.responseType = "blob";
		xhr.send();
		xhr.addEventListener("load", function () {
			var reader = new FileReader();
			reader.readAsDataURL(xhr.response);
			reader.addEventListener("loadend", function () {

				self.thankYouImages.push(reader.result);
				self.thank_you_file_url = reader.result;

			});
		});
	}

	initializeCropieOnThankYouPhoto() {
		if (this.isBrowser) {
			this.thankYouCroppieModal.show();
			setTimeout(() => {
				this.croppieThankYouImageDirective.croppie.bind({ url: this.thank_you_file_url });
			}, 1000);
		}
	}

	saveThankYouCropiePhotoResult() {
		if (this.isBrowser) {
			this.thankYouImages = [];
			const $this = this;
			this.croppieThankYouImageDirective.croppie.result({ type: 'canvas', size: 'original', format: 'png', quality: 1 }).then(function (data) {
				$this.thankYouCroppieModal.hide();
				$this.thankYouImages.push(data);
				$this.thank_you_file_url = data;
			});
		}
	}

	thankYouPreview() {
		if (!this.thankYouMessage_error) {
			this.thankyou_message_is_blank = false;
			this.thankYouNext(4);
		} else {
			this.thankyou_message_is_blank = true;
			setTimeout(() => {
				this.thankyou_message_is_blank = false;
			}, 3000)

		}
	}

	thankYouMessage($event) {
		if ($event.target.value.replace(/^\s+|\s+$/gm, '') != '') {
			this.thankYouMessage_error = false;
		} else {
			this.thankYouMessage_error = true;
		}
	}

	sendThankYouEmailImages() {
		let requestBody = {};
		this.experienceShareService.sendThankYouEmailImages(requestBody, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.thankYouUploadedImages = res.data;
			}
		});
		this.isLoading = false;
	}

	sendThankYouFinal() {
		this.isLoading = true;
		let requestBody = {
			"order_id": this.experienceDetails.order_id,
			"order_item_id": this.experienceDetails.order_item_id,
			"voucher_code": this.experienceDetails.voucher_code,
			"exp_id": this.experienceDetails.id,
			"email": this.experienceDetails.billing_email,
			"additional_email": this.ThankyouProcessForm.get('additional_emails').value,
			"message": this.ThankyouProcessForm.get('thanku_text').value,
			"thank_you_file_url": this.thank_you_file_url,
			"thank_you_image_id": this.thankYouImageId,
		}
		this.experienceShareService.sendThankYouEmail(requestBody, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.thankYouStep1 = false;
				this.thankYouStep2 = false;
				this.thankYouStep3 = false;
				this.thankYouStep4 = false;
				this.thankYouStep5 = true;
				this.isLoading = false;
				this.experienceDetails.thank_you_email_sent = 1;
				this.messageService.sendExpStatusChangedToMainComponent({ 'exp_id': this.experienceDetails.id, 'experience_status': this.experienceDetails.experience_status, 'experience_status_msg': this.experienceDetails.experience_status_msg, 'exp_data': this.experienceDetails });
			} else if (res.response == 'error') {
				this.thankyouModal.hide();
				this.isLoading = false;
			}
		});

	}

	closePhotoVideoModal() {
		this.addPhotoVideoModal.hide();
	}

	choosePhotoForShare(event) {
		this.shareProcess = false;
		this.shareImages = [];
		this.fileFormat = event?.target?.value?.split('.')[1];

		if (this.fileFormat == "jpg" || this.fileFormat == "JPG" || this.fileFormat == "JPEG" || this.fileFormat == "jpeg" || this.fileFormat == "png" || this.fileFormat == "PNG") {
			var files = event.target.files;
			var reader = new FileReader();
			reader.readAsDataURL(files[0]);
			reader.onload = (e: any) => {
				this.shareImages.push(e.target.result);
				this.choosedSharePhotoUrl = e.target.result;
			}
		} else {
			this.toastr.errorToastr("Invalid file format.", 'Error!');
			return;
		}
	}

	initializeCropieOnSharePhoto() {
		if (this.isBrowser) {
			this.photoShareCroppieModal.show();
			const self = this;
			setTimeout(function () {
				self.croppieShareImageDirective.croppie.bind({ url: self.choosedSharePhotoUrl });
				self.croppieShareImageDirective.croppie.setZoom(0);
			}, 500);
		}
	}

	saveShareCropiePhotoResult() {
		if (this.isBrowser) {
			const $this = this;
			this.croppieShareImageDirective.croppie.result({ type: 'canvas', size: 'original', format: 'png', quality: 1 }).then(function (data) {
				$this.photoShareCroppieModal.hide();
				$this.shareImages.push(data);
				$this.choosedSharePhotoUrl = data;
			});
		}
	}

	takeScreenShot(elementId, type) {
		if (this.isBrowser) {
			const $this = this;
			if (type == 'image') {
				$this.isLoading = true;
				var imageElement = document.getElementById(elementId);
				const area = imageElement.getBoundingClientRect();
				html2canvas(imageElement, {
					allowTaint: false,
					useCORS: false,
					scrollX: 0,
					scrollY: 0,
					width: area.width,
					height: area.height
				}).then(canvas => {
					var imgData = canvas.toDataURL("image/jpeg");
					$this.choosedSharePhotoUrl = imgData;
					$this.isLoading = false;
					$this.shareType = type;
					$this.ShareVideoStep1 = false;
					$this.photoVideoStep1 = false;
					$this.photoVideoStep3 = false;
					$this.photoVideoStep2 = true;

				});
			} else {
				$this.ShareVideoStep1 = false;
				$this.photoVideoStep1 = false;
				$this.photoVideoStep3 = false;
				$this.photoVideoStep2 = true;
			}
		}
	}

	photoVideoNextStep(type, identify = 0) {
		if (identify == 0) {
			this.takeScreenShot('imageBackDiv', type);
		}
	}

	chooseVideoForShare(event) {
		this.shareProcess = false;
		const file = event.target.files && event.target.files[0];
		this.share_video_path = event?.target?.files[0];
		this.fileFormat = event?.target?.value?.split('.')[1]
		if (this.fileFormat == 'mov' || this.fileFormat == 'MOV' || this.fileFormat == 'webm' || this.fileFormat == 'WEBM' || this.fileFormat == 'mp4' || this.fileFormat == 'MP4' || this.fileFormat == 'm4p' || this.fileFormat == 'M4P' || this.fileFormat == 'm4v' || this.fileFormat == 'M4V' || this.fileFormat == 'avi' || this.fileFormat == 'AVI' || this.fileFormat == 'qt' || this.fileFormat == 'QT') {
			if (file) {
				var reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = (event) => {
					this.choosedShareVideoUrl = (<FileReader>event.target).result;
				}
				this.photoVideoNextStep('video');
			}
		} else {
			this.toastr.errorToastr("Invalid file format.", 'Error!');
		}
	}

	saveImageShareProcess(type) {
		this.isLoading = true;
		let formData = new FormData();
		formData.append('exp_id', this.experienceDetails.id);
		formData.append('order_id', this.experienceDetails.order_id);
		formData.append('order_item_id', this.experienceDetails.order_item_id);
		formData.append('voucher_code', this.experienceDetails.voucher_code);
		formData.append('type', type);
		formData.append('description', this.PhotoVideoShareForm.get('description').value);
		formData.append('hash_tag', this.PhotoVideoShareForm.get('hash_tag').value);
		if (type == "image") {
			formData.append('file_path', this.choosedSharePhotoUrl);
		} else {
			formData.append('file_path', this.share_video_path);
		}

		this.shareProcess = true;

		this.experienceShareService.photoVideoShareSave(formData, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.isLoading = false;
				this.imageSaveMsg = res.message;
				this.uploadedPhotoVideoUrl = res.file_url;
				this.imageSaveMsgShow = true;
				this.photoVideoSaveStatus = true;
				this.shareProcess = false;
				setTimeout(() => {
					this.imageSaveMsgShow = false;
				}, 4000);
			} else if (res.response == 'error') {
				this.isLoading = false;
				this.addPhotoVideoModal.hide();
				this.shareProcess = false;
			}
		})
	}

	sharePhotoOnFacebook() {
		var shareData = {
			'name': 'Test Exp',
			'url': this.uploadedPhotoVideoUrl,
			'image': this.uploadedPhotoVideoUrl,
			'caption': '',
			'description': '',
			'message': '',
		};
		this.fbService.postToFeed(shareData);
		this.shareFacebookStatus = true;
	}

	backToPhotoVideoShareStep1(type) {
		if (type == 'image') {
			this.photoVideoStep1 = true;
			this.ShareVideoStep1 = false;
			this.photoVideoStep2 = false;
			this.photoVideoStep3 = false;
		} else {
			this.photoVideoStep1 = false;
			this.ShareVideoStep1 = true;
			this.photoVideoStep2 = false;
			this.photoVideoStep3 = false;
		}

	}

	completeShareProcess() {
		this.completeSharingProcess = true;
		this.photoVideoStep3 = true;
		this.photoVideoStep1 = false;
		this.ShareVideoStep1 = false;
		this.photoVideoStep2 = false;
	}

	getWalletAmount() {
		if (this.authUser) {
			this.mainService.getWalletAmount(this.tokenkey).subscribe(res => {
				if (res.response == 'success') {
					this.messageService.sendNotificationCount(res);
					this.messageService.sendAmountMessage(res.data.wallet_amount);
					this.wallet_balance = parseFloat(res.data.wallet_amount).toFixed(2);
					this.totalAdded = res.data.total_exp_count;
				} else if (res.response == 'error') {
					this.wallet_balance = 0.00;
				}
			});
		}
	}

	saveCroppieImage() {
		const $this = this
		$this.isLoading = true;
		if (this.isBrowser) {
			this.croppieDirective.croppie.result({ type: 'canvas', size: 'original', format: 'png', quality: 1 }).then(function (data) {
				let requestBody = { 'image': JSON.stringify(data) }
				$this.registerService.upload_profile_picture(requestBody, $this.tokenkey).subscribe(res => {
					if (res.response == "success") {
						if (this.isBrowser) {
							$this.isLoading = false
							var updateAuthUser = JSON.parse(localStorage.getItem("authUser"));
							updateAuthUser.profile_image = res.data;
							localStorage.setItem("profile_img_url", res.base_url + res.data);
							localStorage.setItem("authUser", JSON.stringify(updateAuthUser));
							$this.authUser = JSON.parse(localStorage.getItem('authUser'));
							$this.profile_img_url = res.base_url + res.data;
							$this.is_profile_edit = !$this.is_profile_edit;
							$this.upload_profile.hide();
							$this.large.hide();

							$this.authdataMessageService.sendProfilePicMessage($this.profile_img_url);
							$this.profileService.sendMessage($this.profile_img_url);
							if (typeof res.gift_add != "undefined" && res.gift_add == 1) {

								var updateAuthUser = JSON.parse(localStorage.getItem("authUser"));
								$this.authUser.gift_voucher_received = 1;
								updateAuthUser.gift_voucher_received = 1;
								$this.showCountDownText = false;
								$this.show_congratulation = true;
								$this.congratulationPopup.show();

								localStorage.setItem("authUser", JSON.stringify(updateAuthUser));

								$this.getWalletAmount();
							}
						}

					} else {
						$this.isLoading = false
					}
				});
			});
		}

	}

	rotateLeft(degrees) {
		if (this.isBrowser) {
			this.croppieDirective.croppie.rotate(degrees)
		}
	}

	rotateRight(degrees) {
		if (this.isBrowser) {
			this.croppieDirective.croppie.rotate(degrees)
		}
	}

	reset() {
		if (this.isBrowser) {
			this.croppieDirective.croppie.bind({ url: this.images[0] });
		}
	}

	rotateLeftSharePhoto(degrees) {
		if (this.isBrowser) {
			this.croppieShareImageDirective.croppie.rotate(degrees)
		}
	}

	rotateRightSharePhoto(degrees) {
		if (this.isBrowser) {
			this.croppieShareImageDirective.croppie.rotate(degrees)
		}
	}

	resetSharePhoto() {
		if (this.isBrowser) {
			this.croppieShareImageDirective.croppie.bind({ url: this.shareImages[0] });
		}
	}

	rotateLeftThankYouPhoto(degrees) {
		if (this.isBrowser) {
			this.croppieThankYouImageDirective.croppie.rotate(degrees)
		}
	}

	rotateRightThankYouPhoto(degrees) {
		if (this.isBrowser) {
			this.croppieThankYouImageDirective.croppie.rotate(degrees)
		}
	}

	resetThankYouPhoto() {
		if (this.isBrowser) {
			this.croppieThankYouImageDirective.croppie.bind({ url: this.thankYouImages[0] });
		}
	}

	videoPopup(vdo) {
		this.videoPopupModal.show();
		this.experience_video_url = this.sanitizer.bypassSecurityTrustResourceUrl(vdo);
	}

	applyFrame(imgFrmeUrl) {
		this.imgFrmeUrlCover = imgFrmeUrl;
	}

	removeFrame() {
		this.imgFrmeUrlCover = 'opacityImg';
	}

	frameZoom(type = '') {
		if (type == 'minus') {
			if (this.isBrowser) {
				var GFG = document.getElementById("sharePhotoSource");
				var currWidth = GFG.clientWidth;
				GFG.style.width = (currWidth - 100) + "px";
			}
		} else if (type == 'plus') {
			if (this.isBrowser) {
				var GFG = document.getElementById("sharePhotoSource");
				var currWidth = GFG.clientWidth;
				GFG.style.width = (currWidth + 100) + "px";
			}
		}
	}

	onSchedulingDateSelect($event) {
		if ($event) {
			this.requestedDate = this.createDateFromNGB($event);
			if ((this.experienceDetails.experience_booking_type ? this.availableDatesArr.includes(this.requestedDate) && this.availableDatesArr.length > 0 : true) && this.experienceDetails.experience_booking_type > 1 && this.experienceDetails.provider_booking_type > 1) {
				if (this.dateCalendarElement1?.nativeElement) {
					this.dateCalendarElement1.nativeElement.click()
				}
				if (this.booking_slot_data?.length == 1) {
					this.isTimeSelected = true;

				} else {
					this.isTimeSelected = false;
				}
				// this.isLoading = true;
				this.dateSelectedLoader = true;
				this.slot = '';
				this.people_data = [];
				this.booking_price = 0;
				this.booking_price_with_tax = 0;
				this.no_slot_avail_message = '';
				this.booking_slot_data = [];
				this.fare_harbor_custom_data = [];
				this.fare_harbor_custom_user_data = [];
				this.rezdy_custom_fields = [];
				this.rezdy_custom_user_fields = [];
				this.requires_visitors_details = [];
				this.hornBlowerCustomFields = [];
				this.linkTwistCustomFields = [];
				this.bokunFieldsPerBookingData = [];
				this.bokunFieldsPerPersonData = [];
				this.ventrata_custom_fields = [];
				this.ventrata_custom_user_data = [];
				this.bokun_main_contact_fields = [];
				this.mainContactDetails = [];
				this.booking_slot_index = "";
				var year = "" + $event?.year;
				var month = "" + ($event.month); if (month.length == 1) { month = "0" + month; }
				var day = "" + $event.day; if (day.length == 1) { day = "0" + day; }
				this.requestedDate = year + "-" + month + "-" + day;
				var inputElement: any = document.getElementById('ngbDate');
				if (inputElement) {
					inputElement.value = month + "-" + day + "-" + year;
				}
				if (!this.is_exp_purchased && Number(this.selected_people) == 0 && this.experienceDetails.allow_book_quantity == 1) {
					this.displayRequiredMessageForPeopleCount = true;
					this.isLoading = false;
					this.dateSelectedLoader = false;
					return;
				} else {
					this.displayRequiredMessageForPeopleCount = false;
				}

				if (this.experienceDetails.instant_book == 1) {
					let requestBody = {
						'experience_id': this.experienceDetails.id,
						'booking_date': this.requestedDate,
						'voucher_code': this.experienceDetails.voucher_code,
						'quantity': this.selected_qty,
						'people_count': this.selected_people
					};
					this.experienceProviderAvailablityService.provider_availablity(requestBody, this.tokenkey).subscribe(res => {
						if (res.response == 'success') {
							this.promo_price = res?.promo_data?.final_price
							this.promo_individual_price = res.promo_data?.final_individual_price
							switch (res.data.booking_type) {
								case 2:
									this.setDataForFareharbor(res.data);
									break;

								case 3:
									this.setDataForHornBlower(res.data);
									break;

								case 4:
									this.setDataForRezdy(res);
									break;

								case 5:
									this.setDataForTiqets(res.data);
									break;
								case 6:
									this.setDataForPeekOcta(res.data);
									break;

								case 7:
									this.booking_type = res?.data?.booking_type;
									this.setDataForGocity(res?.data);
									break;

								case 9:
									this.setDataFortravelotopos(res.data);
									break;

								case 10:
									this.setDataForTourCms(res.data);
									break;

								case 11:
									this.setDataForVentrataOcta(res.data);
									break;
								case 12:
									this.setDataForXola(res.data);
									break;
								case 13:
									this.setDataForLinkTwist(res.data);
									break;
								case 14:
									this.setDataForBokun(res?.data);
									break;
							}
							this.validateBookNowButton(); // calls function or enable/disable Book Now button.
						}
						else {
							this.request_to_book = false;
							this.show_instant_booking = true;
							this.isLoading = false;
							this.dateSelectedLoader = false;
							this.no_slot_avail_message = res?.message;
							this.toastr.errorToastr(res?.message, 'Error!');
						}
					})
				} else {
					this.instant_book_request = 2;
					this.isLoading = false;
					this.dateSelectedLoader = false;
					this.request_to_book = true;
					this.show_instant_booking = true;
				}
			}
			else {
				// Request Book Case.......
				if (this.experienceDetails.experience_booking_type > 1 || this.experienceDetails.block_dates.includes(this.requestedDate)) {
					this.requestedDate = ''
					var inputElement: any = document.getElementById('ngbDate');
					if (inputElement) {
						inputElement.value = '';
					}
					this.booking_date_selected = ''
				} else {
					if (this.dateCalendarElement1.nativeElement) {
						this.dateCalendarElement1.nativeElement.click()
					}
					this.instant_book_request = 2;
				}
				this.booking_date_selected = ''
				this.show_instant_booking = true;
				this.booking_slot_data = []
				this.fare_harbor_custom_data = []
				this.fare_harbor_custom_user_data = [];
			}
		}
		this.selectedLocation = '';
		this.formCtrl['pickup_location_index'].setValue('');
	}

	onMonthChange(current) {
		if (current && current?.next?.year && current?.next?.month) {
			const peopleCount = this.selected_people || 2;
			const cacheKey = `${current.next.year}-${current.next.month}-${peopleCount}`;

			if (this.cachedDates.has(cacheKey)) {
				this.availableDatesArr = this.cachedDates.get(cacheKey)!;
			} else {
				if (this.experienceDetails.experience_booking_type > 1) {
					this.isRenderingDates = true
				}
				this.getAvailableDates(current.next.month, current.next.year, cacheKey, peopleCount);
			}
		}
	}

	getAvailableDates(month: number, year: number, cacheKey?: string, peopleCount?: number) {
		if (this.experienceDetails.experience_booking_type > 1) {
			let requestBody = { "slug": this.experienceDetails?.slug, 'month': month, 'year': year };
			if (peopleCount) {
				requestBody['people_count'] = peopleCount;
			}
			if (this.selected_qty) {
				requestBody['quantity'] = this.selected_qty;
			}
			this.experience.getAvailableDatesInstant(requestBody).subscribe(res => {
				if (res.response == 'success') {
					this.isRenderingDates = false
					this.availableDatesArr = res?.data;
					this.cachedDates.set(cacheKey, res?.data);
				}
				else {
					this.isRenderingDates = false;
					this.isLoading = false;
				}
			});
		}
	}

	createDateFromNGB(dateObj) {
		var year = "" + dateObj.year;
		var month = "" + (dateObj.month); if (month.length == 1) { month = "0" + month; }
		var day = "" + dateObj.day; if (day.length == 1) { day = "0" + day; }
		let formatDate = year + "-" + month + "-" + day;
		return formatDate;
	}

	setDataForLinkTwist(res) {
		this.booking_type = res?.booking_type;
		this.booking_slot_data = res?.slots;
		this.instant_book_request = 1;
		this.dateSelectedLoader = false;
		this.show_instant_booking = true;
		this.request_to_book = false;
		this.linkTwistFields = res?.dynamic_fields_data;
		this.OnlineSchedulingForm.get('booking_type').setValue(res?.booking_type);
		this.setFieldsDataForLinkTwist();
	}

	setDataForBokun(res) {
		this.booking_type = res?.booking_type;
		this.booking_slot_data = res.slots;
		this.instant_book_request = 1;
		this.dateSelectedLoader = false;
		this.show_instant_booking = true;
		this.request_to_book = false;
		this.bokunFieldsData = res?.bookingFields;
		this.mainContactDetails = res?.requiredCustomerFields;
		if (res?.getBokunProduct?.pickupService) {
			this.pickupLocationList = res?.pickUplocation?.pickupPlaces;
		} else {
			this.pickupLocationList = [];
		}
		if (res?.getBokunProduct?.dropoffService) {
			this.dropOffLocationList = res?.pickUplocation?.dropoffPlaces;
		} else {
			this.dropOffLocationList = [];
		}
		this.OnlineSchedulingForm.get('booking_type').setValue(res?.booking_type);
		if (this.bokunFieldsData) {
			this.setBookingFieldsForBokun();
		}
		if (this.mainContactDetails) {
			this.initializeFields(this.mainContactDetails);
			this.getCountryListForRezdy();
		}
	}

	transformApiResponseToFields(apiResponse: string[]): any[] {
		return apiResponse.map(fieldName => {

			const FIELD_CONFIG = {
				title: { label: 'Title', dataType: 'SHORT_TEXT', required: true },
				firstName: { label: 'First Name', dataType: 'SHORT_TEXT', required: true },
				lastName: { label: 'Last Name', dataType: 'SHORT_TEXT', required: true },
				email: { label: 'Email', dataType: 'SHORT_TEXT', required: true },
				phoneNumber: { label: 'Phone Number', dataType: 'PHONE', required: true },
				passportId: { label: 'Passport ID', dataType: 'SHORT_TEXT', required: true },
				passportExpiry: { label: 'Passport Expiry', dataType: 'DATE', required: true },
				dateOfBirth: { label: 'Date of Birth', dataType: 'DATE', required: true },
				personalIdNumber: { label: 'Personal ID Number', dataType: 'SHORT_TEXT', required: true },
				nationality: { label: 'Nationality', dataType: 'OPTIONS', required: true },
				gender: { label: 'Gender', dataType: 'SHORT_TEXT', required: true },
				organization: { label: 'Organization', dataType: 'SHORT_TEXT', required: true },
				address: { label: 'Address', dataType: 'LONG_TEXT', required: true },
				language: { label: 'Language', dataType: 'HIDDEN', required: false },
			};

			const config = FIELD_CONFIG[fieldName as keyof typeof FIELD_CONFIG];

			if (!config) {
				console.warn(`Unknown field: ${fieldName}`);
				return null;
			}

			return {
				questionId: fieldName,
				label: config.label,
				dataType: config.dataType,
				required: config.required,
				value: '',
				emailError: fieldName === 'email' ? null : undefined
			};
		}).filter(field => field !== null);
	}

	initializeFields(Response) {
		this.bokun_main_contact_fields = this.transformApiResponseToFields(Response);
	}


	getMainContactDetails(): any[] {
		return this.bokun_main_contact_fields
			.filter(field => field)
			.map(field => {
				let transformedValue = field.value;

				// Handle phone number fields
				if (field.questionId === 'phoneNumber' && field.value && typeof field.value === 'object') {
					transformedValue = field.value.e164Number || field.value;
				}

				// Handle date fields (passportExpiry, dateOfBirth)
				if ((field.questionId === 'passportExpiry' || field.questionId === 'dateOfBirth') && field.value) {
					const dateResult = this.transformDate(field.value);
					transformedValue = dateResult;
				}

				return {
					questionId: field.questionId,
					values: [transformedValue]
				};
			});
	}

	setBookingFieldsForBokun() {
		let bookingFields = [];
		let userFields = [];
		if (this.bokunFieldsData?.length > 0) {
			for (let itemObj of this.bokunFieldsData) {
				if (itemObj?.context == 'PASSENGER') {
					userFields.push(itemObj);
				} else if (itemObj?.context == 'BOOKING') {
					bookingFields.push(itemObj);
				}
			}
		}

		if (bookingFields?.length > 0) {
			this.bokunFieldsPerBookingData = bookingFields;
		}
		this.bokunFieldsPerPersonData = [];
		if (userFields.length > 0) {
			if (this.selected_people > 0) {
				for (let i = 0; i < this.selected_people; i++) {
					const userFieldsCopy = userFields.map(field => ({ ...field }));
					this.bokunFieldsPerPersonData[i] = userFieldsCopy;
				}
			}
		}
	}

	bokunBookingDataInput() {
		if (this.bokunFieldsPerBookingData?.length > 0) {
			const formattedFields = this.bokunFieldsPerBookingData
				.filter(field => field.value !== undefined && field.value !== null)
				.map(field => ({
					questionId: field.id,  // Use `id` as `questionId`
					values: Array.isArray(field.value)
						? field.value  // For multi-select options, keep array
						: [field.dataType === 'DATE' ? this.transformDate(field.value) : field.value]  // Wrap single values in an array
				}));

			return formattedFields;
		}
		return [];
	}

	bokunPassengerDataInput() {
		if (this.bokunFieldsPerPersonData?.length > 0) {
			return this.bokunFieldsPerPersonData.map(participantFields => ({
				answers: participantFields
					.filter(field => field.value !== undefined && field.value !== null)
					.map(field => ({
						questionId: field.id,  // Use `id` as `questionId`
						values: Array.isArray(field.value)
							? field.value
							: [field.dataType === 'DATE' ? this.transformDate(field.value) : field.value]  // Wrap single values in an array
					}))
			}));
		}
		return [];
	}

	setFieldsDataForLinkTwist() {
		let userFields = [];
		if (this.linkTwistFields?.length > 0) {
			for (let itemObj of this.linkTwistFields) {
				if (itemObj.type == "per_person") {
					userFields.push(itemObj);
				} else {

				}
			}
		}

		this.linkTwistCustomFields = [];
		if (userFields.length > 0) {
			if (this.selected_people > 0) {
				for (let i = 0; i < this.selected_people; i++) {
					const userFieldsCopy = userFields.map(field => ({ ...field }));
					this.linkTwistCustomFields[i] = userFieldsCopy;
				}
			}
		}
	}

	setDataForXola(res) {
		this.booking_type = res?.booking_type;
		this.booking_slot_data = res?.slots;
		this.instant_book_request = 1;
		this.isLoading = false;
		this.dateSelectedLoader = false;
		this.show_instant_booking = true;
		this.request_to_book = false;
		this.demographic_id = res?.demographic_id;
		if (this.booking_slot_data.length == 0) {
		}
		this.OnlineSchedulingForm.get('booking_type').setValue(res?.booking_type);
	}

	xolaBookingInputData() {
		const formattedXolaInputData = [
			{
				demographic: {
					id: this.demographic_id
				},
				quantity: this.selected_people > 0 ? this.selected_people : this.selected_qty
			}
		];

		return formattedXolaInputData;
	}

	setDataForFareharbor(res) {
		this.instant_book_request = 1;
		this.booking_slot_data = res?.slots;
		this.minimum_party_size = this.booking_slot_data[0]?.minimum_party_size;
		this.booking_type = res.booking_type;
		this.hotel_data = res.hotels;
		this.isLoading = false;
		this.dateSelectedLoader = false;
		this.request_to_book = false;
		this.show_instant_booking = true;
		this.OnlineSchedulingForm.get('booking_type').setValue(res.booking_type);
	}

	setFareharborCustomFieldsForPeople(customFields) {
		let customers = [];
		let selected_members;
		if (this.minimum_party_size && this.minimum_party_size > 0) {
			selected_members = this.experienceDetails?.alternate_quantity === 1 ? this.selected_qty * this.minimum_party_size : this.selected_people;
		} else {
			selected_members = this.experienceDetails?.alternate_quantity === 1 ? this.selected_qty : this.selected_people;
		}
		for (let i = 0; i < selected_members; i++) {
			let customer = { 'customer_type_rate': this.display_book_number, 'custom_field_values': [] };
			if (customFields?.length > 0) {
				for (let field of customFields) {
					if (field?.field_type == 'count' && !field?.count_min) {
						field.count_min = 0;
					}

					let fieldObj = {
						'custom_field': field.field_name,
						'value': '',
						'is_required': field.is_required,
						'field_type': field.field_type,
						'field_type2': field.field_type2,
						'options': [],
						'label_title': field.label_title,
						'description': field?.description
					};

					if (field?.field_type == 'count' && field?.count_min !== undefined && field?.count_max !== undefined) {
						for (let j = field.count_min; j <= field.count_max; j++) {
							fieldObj.options.push({ 'key': j, 'value': j });
						}
					} else {
						fieldObj.options = field.options || [];
					}

					customer.custom_field_values.push(fieldObj);
				}
			}
			customers.push(customer);
		}
		return customers;
	}

	setFareharborCustomFieldsAvailability(customFields) {
		let custom_field_values = [];
		if (customFields?.length > 0) {
			for (let field of customFields) {
				let fieldObj = {
					'custom_field': field?.field_name, 'value': '', 'is_required': field?.is_required,
					'field_type': field?.field_type, 'field_type2': field?.field_type2,
					'options': field?.options, 'label_title': field?.label_title,
					'description': field?.description
				};
				if (field?.field_type == 'count') {
					if (field?.count_min) {
						field.count_min = field?.count_min;
					} else {
						field.count_min = 0;
					}
				}
				if (field?.field_type == 'count' && field?.count_min !== undefined && field?.count_max !== undefined) {
					for (let i = field.count_min; i <= field.count_max; i++) {
						fieldObj.options.push({ 'key': i, 'value': i });
					}
				}
				custom_field_values.push(fieldObj);
			}
		}
		return custom_field_values;
	}

	setDataForHornBlower(res) {
		this.instant_book_request = 1;
		this.booking_slot_data = res.slots;
		this.isLoading = false;
		this.dateSelectedLoader = false;
		this.request_to_book = false;
		this.show_instant_booking = true;
		this.OnlineSchedulingForm.get('booking_type').setValue(res?.booking_type);
		this.hornBlowerDynamicFields = res?.dynamic_fields_data;
		this.setFieldsDataForHornBlower();
	}

	setFieldsDataForHornBlower() {
		let userFields = [];
		if (this.hornBlowerDynamicFields?.length > 0) {
			for (let itemObj of this.hornBlowerDynamicFields) {
				if (itemObj.type == "per_person") {
					userFields.push(itemObj);
				} else {

				}
			}
		}

		this.hornBlowerCustomFields = [];
		if (userFields.length > 0) {
			if (this.selected_people > 0) {
				for (let i = 0; i < this.selected_people; i++) {
					const userFieldsCopy = userFields.map(field => ({ ...field }));
					this.hornBlowerCustomFields[i] = userFieldsCopy;
				}
			}
		}
	}

	linkTwistParticipantDataInput() {
		if (this.linkTwistCustomFields?.length > 0) {
			const formattedParticipants = this.linkTwistCustomFields.map(participantFields => {
				return participantFields
					.filter(field => field.value !== undefined && field.value !== null)
					.reduce((acc, field) => {
						// Check if the field is of type 'Phone' and assign the e164Number
						if (field.field_type === 'phone' && field.value?.e164Number) {
							acc[field.key] = field.value.e164Number;
						} else {
							acc[field.key] = field.value;
						}
						return acc;
					}, {});
			});
			return formattedParticipants;
		}
		return [];
	}

	hornBlowerParticipantDataInput() {
		if (this.hornBlowerCustomFields?.length > 0) {
			const formattedParticipants = this.hornBlowerCustomFields.map(participantFields => {
				return participantFields
					.filter(field => field.value !== undefined && field.value !== null)
					.reduce((acc, field) => {
						// Check if the field is of type 'Phone' and assign the e164Number
						if (field.field_type === 'Phone' && field.value?.e164Number) {
							acc[field.key] = field.value.e164Number;
						} else {
							acc[field.key] = field.value;
						}
						return acc;
					}, {});
			});
			return formattedParticipants;
		}
		return [];
	}

	setDataForRezdy(res) {
		this.instant_book_request = 1;
		this.booking_slot_data = res?.data?.slots;
		this.isLoading = false;
		this.dateSelectedLoader = false;
		this.request_to_book = false;
		this.show_instant_booking = true;
		if (res?.data?.pickupLocations) {
			this.pickupLocationList = res?.data?.pickupLocations
		}
		this.OnlineSchedulingForm.get('booking_type').setValue(res?.data?.booking_type);
		this.OnlineSchedulingForm.get('product_code').setValue(res?.data?.product_code);
		this.rezdy_fields_data = res?.bookingFields.filter(field =>
			field.label !== "TERM AND CONDITIONS" &&
			field.label !== "I have read and agree to the terms and conditions listed above"
		);
		this.setRezdyBookingFields();
		if (this.rezdy_fields_data?.length > 0) {
			this.getCountryListForRezdy();
		}
	}

	getCountryListForRezdy() {
		this.homeService.getCountryList().subscribe(res => {
			if (res?.response == 'success') {
				this.CountryListDataRezdy = res?.data;
			}
		});
	}

	setRezdyBookingFields() {
		let bookingFields = [];
		let userFields = [];
		if (this.rezdy_fields_data?.length > 0) {
			for (let itemObj of this.rezdy_fields_data) {
				if (itemObj.visiblePerParticipant) {
					userFields.push(itemObj);
				} else if (itemObj.visiblePerBooking) {
					bookingFields.push(itemObj);
				}
			}
		}
		if (bookingFields?.length > 0) {
			this.rezdy_custom_fields = bookingFields;
		}
		this.rezdy_custom_user_fields = [];
		if (userFields?.length > 0) {
			if (this.selected_people > 0) {
				for (let i = 0; i < this.selected_people; i++) {
					const userFieldsCopy = userFields.map(field => ({ ...field }));
					this.rezdy_custom_user_fields[i] = userFieldsCopy;
				}
			}
		}

	}

	rezdyFieldsDataInput() {
		if (this.rezdy_custom_fields?.length > 0) {
			const formattedFields = this.rezdy_custom_fields
				.filter(field => field.value !== undefined && field.value !== null)
				.map(field => ({
					label: field.label,
					value: field.fieldType === 'Phone'
						? field?.value?.e164Number
						: field.fieldType === 'Date'
							? this.transformDate(field.value)
							: field.value
				}));
			return formattedFields;
		}
	}

	rezdyParticipantDataInput() {
		if (this.rezdy_custom_user_fields?.length > 0) {
			const formattedParticipants = this.rezdy_custom_user_fields.map(participantFields => {
				return {
					fields: participantFields
						.filter(field => field.value !== undefined && field.value !== null)
						.map(field => ({
							label: field.label,
							value: field.fieldType === 'Phone'
								? field?.value?.e164Number
								: field.fieldType === 'Date'
									? this.transformDate(field.value)
									: field.value
						}))
				};
			});

			return formattedParticipants;
		}
	}

	transformDate(dateStr: any) {
		if (typeof dateStr === "string") {
			const dateParts = dateStr?.split('-');
			if (dateParts.length === 3) {
				const [day, month, year] = dateParts;
				const date = new Date(+year, +month - 1, +day);
				return this.datepipe.transform(date, 'yyyy-MM-dd');
			}
			return null;
		} else if (typeof dateStr === "object" && dateStr?.year && dateStr?.month && dateStr?.day) {
			const { year, month, day } = dateStr;
			const date = new Date(year, month - 1, day);
			return this.datepipe.transform(date, 'yyyy-MM-dd');
		} else {
			console.log('Invalid date format:', dateStr);
		}
	}

	parseListOptions(options: string): string[] {
		if (options) {
			return options?.split('\r\n').filter(option => option.trim() !== '');
		}
	}

	getPrimeNgOptions(options: string): { label: string; value: string }[] {
		const parsedOptions = this.parseListOptions(options);
		return parsedOptions.map(option => ({
			label: option,
			value: option,
		}));
	}

	setDataForTiqets(res) {
		this.instant_book_request = 1;
		this.booking_slot_data = res.slots;
		this.maxRequireVisitorsDate = this.getDateObject(new Date());
		this.isLoading = false;
		this.dateSelectedLoader = false;
		this.request_to_book = false;
		this.show_instant_booking = true;
		this.OnlineSchedulingForm.get('booking_type').setValue(res.booking_type);
	}

	setDataForPeekOcta(res) {
		this.instant_book_request = 1;
		this.booking_slot_data = res.slots;
		this.isLoading = false;
		this.dateSelectedLoader = false;
		this.request_to_book = false;
		this.show_instant_booking = true;
		this.OnlineSchedulingForm.get('booking_type').setValue(res.booking_type);
	}

	setDataForVentrataOcta(res) {
		this.instant_book_request = 1;
		this.booking_slot_data = res.slots;
		this.isLoading = false;
		this.dateSelectedLoader = false;
		this.request_to_book = false;
		this.show_instant_booking = true;
		this.OnlineSchedulingForm.get('booking_type').setValue(res.booking_type);
	}

	setDataForGocity(res) {
		this.instant_book_request = 1;
		this.booking_slot_data = res.slots;
		this.isLoading = false;
		this.dateSelectedLoader = false;
		this.request_to_book = false;
		this.show_instant_booking = true;
		this.OnlineSchedulingForm.get('booking_type').setValue(res.booking_type);
	}

	setDataFortravelotopos(res) {
		this.instant_book_request = 1;
		this.booking_slot_data = res?.slots;
		this.isLoading = false;
		this.dateSelectedLoader = false;
		this.request_to_book = false;
		this.show_instant_booking = true;
		this.OnlineSchedulingForm.get('booking_type').setValue(res.booking_type);
	}

	setDataForTourCms(res) {
		this.instant_book_request = 1;
		this.booking_slot_data = res?.slots;
		this.tourcms_channel_id = res.channel_id
		this.isLoading = false;
		this.dateSelectedLoader = false;
		this.request_to_book = false;
		this.show_instant_booking = true;
		this.OnlineSchedulingForm.get('booking_type').setValue(res.booking_type);
	}

	time_slot(event, slot, index) {
		if (index) {
			this.slot = slot;
			this.booking_slot_index = index
			this.formated_time = this.booking_slot_data[index]?.standard_slot_format;
			this.bookStartDate = this.booking_slot_data[index]?.time_slot_start;
			this.bookEndDate = this.booking_slot_data[index]?.time_slot_end;
			this.requires_visitors_details = [];
			this.fare_harbor_custom_data = [];
			this.ventrata_custom_fields = [];
			this.ventrata_custom_user_data = [];
			this.fare_harbor_custom_user_data = [];
			this.goCityUnitId = '';
			this.goCityAvailabilityId = '';
			this.goCityOptiontId = '';
			if (this.booking_slot_data?.length == 1 && index == '') {
				this.isTimeSelected = true
			} else {
				this.isTimeSelected = false
			}
			if (this.OnlineSchedulingForm.get('booking_type').value == 2) {
				this.OnlineSchedulingForm.get('display_book_number').setValue(event.target.value);
				this.display_book_number = this.booking_slot_data[index].display_book_number;
				this.book_number = this.booking_slot_data[index].book_number;

				let custom_fields_data = this.setFareharborCustomFieldsAvailability(this.booking_slot_data[index].custom_fields_data)
				this.fare_harbor_custom_data = custom_fields_data;

				let customers = this.setFareharborCustomFieldsForPeople(this.booking_slot_data[index].rate_custom_fields_data);
				this.fare_harbor_custom_user_data = customers;

			} else if (this.OnlineSchedulingForm.get('booking_type').value == 3) {
				let hornblower_category = this.booking_slot_data[index].category;
				this.OnlineSchedulingForm.get('hornblower_category').setValue(hornblower_category);
			} else if (this.OnlineSchedulingForm.get('booking_type').value == 5) {
				this.slot = this.booking_slot_data[index].start_time;
				let variant_id = this.booking_slot_data[index].variant_id;
				this.OnlineSchedulingForm.get('variant_id').setValue(variant_id);
			} else if (this.OnlineSchedulingForm.get('booking_type').value == 6) {
				let unit_id = this.booking_slot_data[index].unit_id;
				let availability_id = this.booking_slot_data[index].availability_id;
				this.OnlineSchedulingForm.get('peek_unit_id').setValue(unit_id);
				this.OnlineSchedulingForm.get('peek_availability_id').setValue(availability_id);
			} else if (this.booking_type == 7) {
				this.goCityUnitId = this.booking_slot_data[index]?.unitID;
				this.goCityAvailabilityId = this.booking_slot_data[index]?.availabilityId;
				this.goCityOptiontId = this.booking_slot_data[index]?.optionId;
			} else if (this.OnlineSchedulingForm.get('booking_type').value == 9) {
				this.priceGroup_id = this.booking_slot_data[index].pricegroup_id;
				this.OnlineSchedulingForm.get('pricegroup_id').setValue(this.priceGroup_id);
			} else if (this.OnlineSchedulingForm.get('booking_type').value == 10) {
				this.tourcms_component_key = this.booking_slot_data[index]?.component_key;
			} else if (this.OnlineSchedulingForm.get('booking_type').value == 11) {

				let unit_id = this.booking_slot_data[index].unit_id;
				this.ventrata_availability_id = this.booking_slot_data[index].availability_id;

				this.OnlineSchedulingForm.get('ventrata_unit_id').setValue(unit_id);
				this.OnlineSchedulingForm.get('ventrata_availability_id').setValue(this.ventrata_availability_id);
				let bookingFields = this.booking_slot_data[index]?.unit_details?.requiredContactFields;
				this.ventrata_custom_fields = bookingFields;
				this.initializeVentrataCustomUserData();

			} else if (this.OnlineSchedulingForm.get('booking_type').value == 13) {
				this.participantTypeAlias = this.booking_slot_data[index].participant_type_alias;
			}

			if (this.booking_slot_data[index]) {
				if (this.OnlineSchedulingForm.get('booking_type').value == 2 || this.OnlineSchedulingForm.get('booking_type').value == 4) {

					this.booking_price = this.booking_slot_data[index].price;
					this.booking_price_with_tax = this.booking_slot_data[index].price_with_tax;
					this.OnlineSchedulingForm.get('price').setValue(this.booking_price);
					this.OnlineSchedulingForm.get('book_number').setValue(this.booking_slot_data[index].book_number);

					if (this.OnlineSchedulingForm.get('booking_type').value == 4) {
						let seat_label = this.booking_slot_data[index].seat_label;
						this.OnlineSchedulingForm.get('seat_label').setValue(seat_label);

						let time_options = this.booking_slot_data[index].time_options;
						this.OnlineSchedulingForm.get('time_options').setValue(time_options);
					}

				} else {
					this.OnlineSchedulingForm.get('price').setValue(0);

					if (this.OnlineSchedulingForm.get('booking_type').value == 5) {
						if (typeof this.booking_slot_data[index].requires_visitors_details != undefined && this.booking_slot_data[index].requires_visitors_details) {
							if (this.booking_slot_data[0].requires_visitors_details && this.booking_slot_data[0].requires_visitors_details.length > 0) {
								this.requires_visitors_details = [];
								for (let i = 0; i < this.selected_people; i++) {
									const person = {
										label: `person ${i + 1}`,
										details: this.booking_slot_data[0].requires_visitors_details.map(key => ({ key, value: '', err: null }))
									};
									this.requires_visitors_details.push(person);
								}
							}
						}
					}
				}

			} else {
				this.booking_price = 0;
				this.booking_price_with_tax = 0;
			}
		}
		this.validateBookNowButton();
	}

	tiqets_input(identify, event, data: any = {}) {
		let dynamic_option_object = {};
		const $this = this;
		let hasPresentOn = this.requires_visitors_details[identify]?.details.find(
			function (el) {
				if (event == 'date_of_birth' || event == 'phone') {
					if (el.key == event) {
						$this.index = $this.requires_visitors_details[identify]?.details.findIndex(index_id => index_id.key == event);
						return true;
					} else {
						return false;
					}
				} else {
					if (el.key == event.target.name) {
						$this.index = $this.requires_visitors_details[identify]?.details.findIndex(index_id => index_id.key == event.target.name);
						return true;
					} else {
						return false;
					}
				}
			}
		);
		if (!hasPresentOn) {
			if (event == 'date_of_birth') {
				dynamic_option_object['key'] = event;
				dynamic_option_object['value'] = this.createDateFromNGB(data);
			} else {
				dynamic_option_object['key'] = event == 'phone' ? event : event.target.name;
				dynamic_option_object['value'] = event == 'phone' ? '+' + (data?.selectedCountry?.dialCode + data?.phoneNumber) : event.target.value;
			}
			this.requires_visitors_details[identify]?.details.push(dynamic_option_object);
		}
		else {
			if (event == 'date_of_birth') {
				this.requires_visitors_details[identify].details[this.index].key = event;
				this.requires_visitors_details[identify].details[this.index].value = this.createDateFromNGB(data);
			} else {
				this.requires_visitors_details[identify].details[this.index].key = event == 'phone' ? event : event.target.name;
				this.requires_visitors_details[identify].details[this.index].value = event == 'phone' ? ('+' + data?.selectedCountry?.dialCode + data?.phoneNumber) : event.target.value;
			}
			this.requires_visitors_details[identify].details[this.index].err = null;
		}
		this.validateBookNowButton();
	}


	showPartialPurchase(exp_id) {
		this.additionalImages = this.experienceDetails.additional_images;
		this.remainingUnits = this.experienceDetails.partial_purchase_max - this.experienceDetails.partial_purchase_qty;
		this.generatePartialUnits();
		this.partialPurchasePopup.show();
	}

	generatePartialUnits() {
		this.units = [];
		var counter = 1;
		var unitLength = this.experienceDetails.partial_purchase_max - this.experienceDetails.partial_purchase_qty;
		for (var j = 1; j <= unitLength; j++) {
			var classType = 'remaingPartialPurchaseUnits';
			this.units.push({ 'name': counter, 'className': classType });
			counter++;
		}
		if (this.experienceDetails.partial_purchase_qty > 0) {
			for (var k = 1; k <= this.experienceDetails.partial_purchase_qty; k++) {
				var classType = 'PartialPurchasedUnits';
				this.units.push({ 'name': counter, 'className': classType });
				counter++;
			}
		}
	}

	close() {
		if (this.isBrowser) {
			var element = document.querySelector("body")
			var htmlelement = document.querySelector("html")
			if (element)
				element.classList.remove('overflow');
			if (htmlelement)
				htmlelement.classList.remove('overflow');
		}
		this.addedtocart = false
		this.experieneDetailPopupClose()
		this.avail_child_exp = false;
		this.showRedeemNowCancel = false;
		this.showRedeemNowConfirm = false;
		this.selected_people = 0;
		this.want_to_refund_cancel = false
		this.show_refund_button = true
		this.want_to_refund_confirm = false
		this.isModalOpen = false;
		this.enableBookNowButton = false;
		this.selected_hotel = 0;
		this.booking_slot_data = [];
		this.hotel_data = [];
		this.requires_visitors_details = [];
		this.booking_slot_index = '';
		this.rezdy_fields_data = [];
		this.rezdy_custom_fields = [];
		this.rezdy_custom_user_fields = [];
		this.fare_harbor_custom_data = [];
		this.fare_harbor_custom_user_data = [];
		this.hornBlowerCustomFields = [];
		this.linkTwistCustomFields = [];
		this.bokunFieldsPerBookingData = [];
		this.bokunFieldsPerPersonData = [];
		this.availableDatesArr = [];
		this.cachedDates.clear();
		this.additionalImages = [];
		if (this.dropdownElement2 != undefined) {
			this.dropdownElement2.nativeElement = undefined;
			this.dropdownElement2.nativeElement = null;
		}
		this.firstNameValue = '';
		this.lastNameValue = '';
		this.closeModal();
		this.isRenderingDates = false;
	}

	addToRegistry_group(exp_id, type, is_suggestion = 0, registry_for = "") {

		this.isLoading = true;
		this.type_identity = type;
		this.showRegChkmark = true;
		this.avail_child_exp = false;
		for (let i = 0; i < this.resultExp.length; i++) {
			if (this.resultExp[i].id == exp_id) {
				this.resultExp[i].is_show_ckbx = 1;
				break;
			}
		}
		this.addexperience.addExperienceRegistry(exp_id, type, this.tokenkey).subscribe(res => {

			if (res.response == 'success') {
				if (registry_for == 'suggested') {
					for (let i = 0; i < this.suggestionData.length; i++) {
						if (this.suggestionData[i].id == exp_id) {
							this.suggestionData[i].is_show_ckbx = 0;
							if (type == "experiences_join_us") {
								if (this.suggestionData[i].is_added_join_us == 1) {
									this.suggestionData[i].is_added_join_us == 0
									this.suggestionData[i].is_registry_status = 3;
								} else {
									this.suggestionData[i].is_added_join_us == 1
									this.suggestionData[i].is_registry_status = 4;
								}
							} else {
								if (this.suggestionData[i].is_added_registry == 1) {
									this.suggestionData[i].is_added_registry = 0;
									this.suggestionData[i].is_registry_status = 2;
								} else {
									this.suggestionData[i].is_added_registry = 1;
									this.suggestionData[i].is_registry_status = 1;
								}
							}
							break;
						}
					}
				} else {
					for (let i = 0; i < this.resultExp.length; i++) {
						if (this.resultExp[i].id == exp_id) {

							this.resultExp[i].is_show_ckbx = 0;
							if (type == "experiences_join_us") {
								if (this.resultExp[i].is_added_join_us == 1) {
									this.resultExp[i].is_added_join_us = 0;
									this.resultExp[i].is_added_registry = 0;
									this.resultExp[i].is_registry_status = 3;
								} else {
									this.resultExp[i].is_added_join_us = 1;
									this.resultExp[i].is_added_registry = 1;
									this.resultExp[i].is_registry_status = 4;
								}
							} else {
								if (this.resultExp[i].is_added_registry == 1) {
									this.resultExp[i].is_added_registry = 0;
									this.resultExp[i].is_added_join_us = 0;
									this.resultExp[i].is_registry_status = 2;
								} else {
									this.resultExp[i].is_added_registry = 1;
									this.resultExp[i].is_added_join_us = 1;
									this.resultExp[i].is_registry_status = 1;
								}
							}
							if (Object.keys(this.experienceDetails).length > 0) {
								if (this.experienceDetails.id == exp_id) {
									this.experienceDetails.experience_status_msg = res.data.experience_status_msg;
									this.experienceDetails.status = (this.experienceDetails.status == 1) ? 0 : 1;
								}
							}
							break;
						}
					}
				}
				this.messageService.sendExpStatusChangedToMainComponent({ 'exp_id': exp_id, 'type': type, 'is_suggestion': is_suggestion, 'registry_for': registry_for, 'is_registry_status': res.data.is_registry_status, 'experience_status': res.data.is_registry_status, 'experience_status_msg': res.data.experience_status_msg, 'added_registry': 1, 'added_registry_type': res.data.added_registry_type, 'exp_data': this.experienceDetails });

				this.isLoading = false;
				this.experieneDetailPopupClose();
			} else if (res.response == 'error') {
				this.isLoading = false;
			}
		});

		if (is_suggestion > 0) {
			var requestbody = { 'experience_id': exp_id };
			this.addexperience.getExperienceSuggestionData(requestbody, this.tokenkey).subscribe(res => {
				if (res.response == 'success' && res.data.length > 0) {
					for (let i = 0; i < res.data.length; i++) {
						res.data[i].is_show_ckbx = 0;
						res.data[i].is_added_join_us = 0;
					}
					this.suggestionData = res.data;
					this.suggestedExperiencePopup.show();
				}
			});
		}
	}

	selected_child_exp(event) {
		this.isLoading = true;
		if (event.target.value == '') {
			this.avail_child_exp = false;
			this.exp_data_in_popup(this.main_exp_id);
		} else {
			this.exp_data_in_popup(event.target.value);
			this.avail_child_exp = true;
		}
	}

	exp_data_in_popup(id) {
		var requestbody = { 'experience_id': id, 'request_page': this.other_page_data };
		this.addexperience.getExperienceDetails(requestbody, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				var responseData = res.data;
				if (responseData.variations_data.length > 0) {
					for (let k = 0; k < responseData.variations_data.length; k++) {
						if (responseData.variations_data[k].slug == 'buy-for-yourself') {
							responseData.is_buy_for_yourself = 1;
							responseData.buy_for_yourself_veriation_id = responseData.variations_data[k].id;
							break;
						} else {
							responseData.is_buy_for_yourself = 0;
							responseData.buy_for_yourself_veriation_id = 0;
						}
					}
				} else {
					responseData.is_buy_for_yourself = 0;
					responseData.buy_for_yourself_veriation_id = 0;
				}
				this.experienceDetails = responseData;
				if (new Date(this.experienceDetails?.redeem_date) <= new Date()) {
					this.is_gratuity = true
				}
				this.additionalImages = this.experienceDetails.additional_images;
				this.isLoading = false;
			} else if (res.response == 'error') {
				this.isLoading = false;
			}
			this.isLoading = false;
		});
		this.reviewClick()
	}

	proceedToLogin() {
		this.isLoading = true;
		this.router.navigate(['/login']);
		this.isLoading = false;
		this.modalRef.hide();
	}

	decline(): void {
		this.modalRef.hide();
	}

	uploadProfile() {
		this.congratulationPopuphide();
		this.upload_profile.show();
		this.is_profile_edit = false;
		this.is_cover_edit = false;
	}

	closePhoto() {
		this.upload_profile.hide()
	}

	uploadProfileImage($event) {
		this.images = []
		if (($event.target.files).length === 0) {
			return;
		}
		this.fileFormat = $event?.target?.value?.split('.')[1]
		if (this.fileFormat == "jpg" || this.fileFormat == "JPG" || this.fileFormat == "JPEG" || this.fileFormat == "jpeg" || this.fileFormat == "png" || this.fileFormat == "PNG") {
			var mimeType = $event.target.files[0].type;
			if (mimeType.match(/image\/*/) != null) {
				let reader = new FileReader();
				reader.readAsDataURL($event.target.files[0]);
				reader.onload = (e: any) => {
					this.images.push(e.target.result)
					this.upload_profile.hide()
					setTimeout(() => {
						this.large.show();
					}, 500);
					setTimeout(() => {
						if (this.isBrowser) {
							this.croppieDirective.croppie.bind({ url: e.target.result });
						}
					}, 1000);

				}
			}
		} else {
			this.toastr.errorToastr("Invalid file format.", 'Error!');
			return;
		}
	}

	upload() {
		if (this.isBrowser) {
			document.getElementById('upload').click();
		}
	}

	uploadCoverImage() {
		this.img_type = 'cover_image';
		this.upload_profile.hide()
		this.upload_cover_profile_image.show()
	}

	showCropper() {
		this.fbAlbumPopup.hide();
		this.upload_cover_profile_image.hide();
		this.largecoverimage.show();
	}

	imageCropped(event: ImageCroppedEvent) {
		this.croppedImage = event.base64;
	}

	imageLoaded() {
		this.showCoverImageCropper = true;
	}

	rotateLeftCropper() {
		this.canvasRotation = this.canvasRotation - 0.5;
		this.flipAfterRotate();
	}

	rotateRightCropper() {
		this.canvasRotation = this.canvasRotation + 0.5;
		this.flipAfterRotate();
	}

	private flipAfterRotate() {
		const flippedH = this.transform.flipH;
		const flippedV = this.transform.flipV;
		this.transform = {
			...this.transform,
			flipH: flippedV,
			flipV: flippedH
		};
	}

	updateRotation() {
		this.transform = {
			...this.transform,
			rotate: this.rotation
		};
	}

	resetImage() {
		this.scale = 1;
		this.rotation = 0;
		this.canvasRotation = 0;
		this.transform = {};
	}

	zoomOut() {
		this.scale -= .1;
		this.transform = {
			...this.transform,
			scale: this.scale
		};
	}

	zoomIn() {
		this.scale += .1;
		this.transform = {
			...this.transform,
			scale: this.scale
		};
	}

	saveCroppieCoverImage() {
		const $this = this;
		$this.isLoading = true;
		if (this.isBrowser) {
			let requestBody = { 'image': $this.croppedImage }
			$this.registerService.upload_cover_image(requestBody, $this.tokenkey).subscribe(res => {
				if (res.response == "success") {
					if (this.isBrowser) {
						var updateAuthUser = JSON.parse(localStorage.getItem("authUser"));
						updateAuthUser.cover_image = res.data;
						$this.isLoading = false;
						localStorage.setItem("authUser", JSON.stringify(updateAuthUser));
						localStorage.setItem("cover_image_url", res.base_url + res.data);
						$this.cover_image_url = res.base_url + res.data;
						$this.largecoverimage.hide()
						$this.is_cover_image_edit = 1;

						document.getElementById('cover_image_url').setAttribute("data-bg", res.base_url + res.data);
						document.getElementById('cover_image_url').style.background = "url('" + res.base_url + res.data + "')";
						document.getElementById('cover_image_url').style.backgroundSize = "cover";

						$this.upload_cover_profile_image.show();
					}

				} else {
					$this.isLoading = false;
				}
			});
		}
	}

	fileChangeEvent(event: any): void {
		const $this = this;
		$this.upload_cover_profile_image.hide();
		var files = event.target.files;
		var file = files[0];
		var reader = new FileReader();
		reader.onloadend = function () {
			$this.choosedCoverPhotoUrl = reader.result;
		};
		reader.readAsDataURL(file);

		this.imageChangedEvent = event;
		this.largecoverimage.show();
	}

	checkTAB(tabdetail) {
		this.isActiveTab = tabdetail
	}

	close_certificate_popup() {
		this.pop_first_content = true;
		this.pop_second_content = false;
		this.pop_third_content = false;
		this.buymodal.hide();
		this.show_couple = false;
		this.submitted = false;
		this.no_couple_data_found = false;
		this.search_string = '';
	}

	couple_searching(search_key) {
		this.Loading = true;
		this.data1 = '';
		if (search_key != '') {
			this.findCoupleService.find_couples(this.page, search_key, this.tokenkey).subscribe(res => {
				if (res.response == 'success') {
					this.data1 = res.data.data.data;
					this.couple_image_url = res.base_url;
					this.show_couple = true;
					this.Loading = false;
					this.no_couple_data_found = false;
				}
				else {
					this.show_couple = true;
					this.no_couple_data_found = true;
					this.Loading = false;
				}
			});
		} else {
			this.show_couple = false;
			this.no_couple_data_found = false;
			setTimeout(() => {
				this.Loading = false;
			}, 1000);
		}
	}

	clean_search() {
		this.couple_searching('');
		this.search_string = '';
	}

	open_amount_section(couple_id, couple_full_name = '', wedding_date = '') {
		if (couple_full_name == '') {
			if (this.authUser) {
				if (this.authUser.role_id == 5 || this.authUser.role_id == 1) {
					this.gift_certificate_couple_full_name = this.authUser.first_name + ' ' + this.authUser.last_name + ' & ' + this.authUser.partner_first_name + ' ' + this.authUser.partner_last_name;
				} else {
					this.gift_certificate_couple_full_name = this.authUser.first_name + ' ' + this.authUser.last_name
				}
			} else {
				this.gift_certificate_couple_full_name = '';
			}
		} else {
			this.gift_certificate_couple_full_name = couple_full_name;
		}
		this.Loading = true;
		if (couple_id == 0) {
			if (this.authUser) {
				this.selected_couple = this.authUser.id;
				this.wedding_date = this.authUser.wedding_date;
			} else {
				this.selected_couple = 0;
			}
		} else {
			this.selected_couple = couple_id;
			this.wedding_date = wedding_date;
		}

		setTimeout(() => {
			this.pop_first_content = false;
			this.pop_second_content = false;
			this.pop_third_content = true;
			this.Loading = false;
		}, 1000);
	}

	search_for_registered() {
		this.Loading = true;
		setTimeout(() => {
			this.pop_first_content = false;
			this.pop_second_content = true;
			this.Loading = false;
		}, 1000);
	}

	selected_amount(amount) {
		this.amount = amount;
	}

	gratuity_amount(amount) {
		this.gratuityAmount = ((amount / 100) * this.experienceDetails?.exp_price).toFixed(2)
	}

	redeem_confirmation() {
		this.showRedeemNowBtn = false;
		this.showRedeemScheduleBtn = false;
		this.showViewPrintBtn = false;
		this.onlineBookingMsgBlock = false;
		this.showRedeemNowConfirm = true;
		this.showRedeemNowCancel = true;
		this.showExchangeBtn = false;
		this.priceBlock = false;
		this.showSeasonHeadline = false;
		this.backfromRedemmeScheduleBtn = false;
		this.show_refund_button = false
	}

	refundDetail() {
		this.isLoading = true;
		this.showDetailsTab = true;
		this.showExchangeTab = false;
		this.showGiftedByTab = false;
		this.showPhotosVideosTab = false;
		this.showSummeryTab = false;
		this.showHowToRedeemTab = false;
		this.showPartialPurchTab = false;
		this.showReviewTab = false;
		this.showJoinUsTab = false;
		this.show_refund_button = false
		this.showAddRegBtn = false;
		this.showRemoveRegBtn = false;
		this.showBuyYourSelfBtn = false;
		this.showBuyAsGiftBtn = false;
		this.showCloseBtn = false;
		this.showReviewExpBtn = false;
		this.showAddPhotoVideoBtn = false;
		this.showSendThankYouBtn = false;
		this.showAddPhotoDeviceBtn = false;
		this.showAddVideoDeviceBtn = false;
		this.showRedeemScheduleBtn = false;
		this.showExchangeBtn = false;
		this.showViewPrintBtn = false;
		this.showScheduleExpBtn = false;
		this.showRedeemNowBtn = false;
		this.showExcConfirmBtn = false;
		this.showExcCancelBtn = false;
		this.showCompletePurchBtn = false;
		this.showBackBtn = false;
		this.showCheckoutBtn = false;
		this.showContinueShopBtn = false;
		this.priceBlock = false;
		this.exchangeBlock = false;
		this.redeemScheduleBlock = false;
		this.showSeasonHeadline = false;
		this.isActiveTab = 'exchange';
		this.isLoading = false;
		this.want_to_refund_confirm = true
		this.want_to_refund_cancel = true
	}

	addRefundInfo(order_id, order_item_id, voucher_code) {
		this.isLoading = true;
		let requestBody = {
			'order_id': order_id,
			'order_item_id': order_item_id,
			'voucher_code': voucher_code
		}
		this.PromotionalService.refundData(requestBody, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.experienceDetails.experience_status = res.data.experience_status;
				this.experienceDetails.experience_status_msg = res.data.experience_status_msg;

				this.messageService.sendExpStatusChangedToMainComponent({ 'exp_id': this.experienceDetails.id, 'experience_status': this.experienceDetails.experience_status, 'experience_status_msg': this.experienceDetails.experience_status_msg, 'exp_data': this.experienceDetails }); // send data to add Experience component.
			} else {

			}
			this.refundDetailPopupClose()

			this.isLoading = false;
		});
	}

	loadImage(imageUrl) {
		this.addPhotoVideoFromDevice('photo');
		const self = this;
		this.images = [];
		const xhr = new XMLHttpRequest()
		xhr.open("GET", imageUrl);
		xhr.responseType = "blob";
		xhr.send();
		xhr.addEventListener("load", function () {
			var reader = new FileReader();
			reader.readAsDataURL(xhr.response);
			reader.addEventListener("loadend", function () {
				self.images.push(reader.result);
				self.choosedSharePhotoUrl = reader.result;
				self.isLoading = true;
				setTimeout(() => {
					self.photoVideoNextStep('image', 1);
					self.hide_back_button = false;
					self.isLoading = false;
				}, 1000);
			});
		});
	}

	showCountDownTimer() {
		if (this.authUser.created_at != "") {
			if (this.authUser.gift_voucher_received == 0) {
				const $this = this;
				var timeRemaining = this.authUser.time_remaining;
				var startTimestamp = new Date().getTime();
				var endTimestamp = Number(startTimestamp) + Number(timeRemaining);
				var diffTimestamp = Number(endTimestamp) - Number(startTimestamp);
				if (diffTimestamp > 0) {
					$this.showCountDownText = true;
					$this.timerString = "";
					$this.generateCountTimer(diffTimestamp);

				} else {
					$this.showCountDownText = false;
					$this.timerEndDate = "";
				}
			} else {
				this.showCountDownText = false;
			}
		}
	}

	minTwoDigits(n) {
		return (n < 10 ? '0' : '') + n;
	}

	generateCountTimer(diffTimestamp) {
		const $this = this;
		this.timerString = '';
		clearInterval(this.timerIntervalFunc);
		this.timerIntervalFunc = setInterval(() => {
			if (Number(diffTimestamp) > 0) {

				var seconds = Math.floor((diffTimestamp) / (1000) % 60);
				var minutes = Math.floor((diffTimestamp) / (1000 * 60) % 60);
				var hours = Math.floor((diffTimestamp) / (1000 * 60 * 60) % 60);

				$this.timerString = $this.minTwoDigits(hours) + " : " + $this.minTwoDigits(minutes) + " : " + $this.minTwoDigits(seconds);

			}
			diffTimestamp -= Number(1000);
		}, 1000);
	}

	chooseFacebookAlbum(index) {
		if (this.facebookAlbums[index]) {

			if (typeof this.facebookAlbums[index].photos != "undefined" && typeof this.facebookAlbums[index].photos.data != "undefined" && this.facebookAlbums[index].photos.data.length > 0)
				this.choosedFacebookAlbums = this.facebookAlbums[index].photos.data;
		} else {
			this.choosedFacebookAlbums = [];
		}

		this.albumStep2 = true;
		this.albumStep1 = false;
	}

	backToFacebookAlbum() {
		this.albumStep2 = false;
		this.albumStep1 = true;
	}

	chooseProfilePhotoFromFacebookAlbum(imageUrl) {
		const self = this;
		this.images = [];
		const xhr = new XMLHttpRequest()
		xhr.open("GET", imageUrl);
		xhr.responseType = "blob";
		xhr.send();
		xhr.addEventListener("load", function () {
			var reader = new FileReader();
			reader.readAsDataURL(xhr.response);
			reader.addEventListener("loadend", function () {
				self.choosedFacebookPhotoUrl = reader.result;
				self.choosedCoverPhotoUrl = reader.result;
				if (self.fbImageType == 'profile_image') {
					self.initializeCropieOnProfilePhoto();
				} else if (self.fbImageType == 'cover_image') {
					self.showCropper();
				}
			});
		});
	}

	initializeCropieOnProfilePhoto() {
		this.large.show();
		this.fbAlbumPopup.hide();
		setTimeout(() => {
			if (this.isBrowser) {
				this.croppieDirective.croppie.bind({ url: this.choosedFacebookPhotoUrl });
			}
		}, 1000);

	}

	uploadFromFacebook(data) {
		var imageType = data.image_type;
		const $this = this;
		if (typeof data.user_type != "undefined" && data.user_type == 'charity') {
			$this.cropyUserType = data.user_type;
		} else {
			$this.cropyUserType = '';
		}
		$this.fbService.getFacebookAlbums().then((res: any) => {

			$this.facebookAlbums = [];
			$this.choosedFacebookAlbums = [];
			$this.albumStep2 = false;
			$this.albumStep1 = true;
			$this.fbImageType = imageType;

			if (res) {
				if (typeof res.albums != "undefined") {
					if (typeof res.albums.data != "undefined") {
						$this.facebookAlbums = res.albums.data;
					}
				}
			}
			$this.fbAlbumPopup.show();
		});

	}

	congratulationPopuphide(): void {
		this.congratulationPopup.hide();
		if (this.show_congratulation) {
			this.showCountDownText = false;
		}
	}

	experieneDetailPopupClose() {
		if (this.isBrowser) {
			var element = document.querySelector("body")
			var htmlelement = document.querySelector("html")
			if (element)
				element.classList.remove('overflow');
			if (htmlelement) {
				htmlelement.classList.remove('overflow');
			}
		}
		var video;
		if (this.isBrowser) {
			if (document.getElementById('main-video11')) {
				video = document.getElementById('main-video11')
				video.pause();
			}
		}
		this.experienceDetailsPopup.hide();

	}

	refundDetailPopupClose() {
		if (this.isBrowser) {
			var element = document.querySelector("body")
			var htmlelement = document.querySelector("html")
			if (element)
				element.classList.remove('overflow');
			if (htmlelement) {
				htmlelement.classList.remove('overflow');
			}
		}
		var video;
		if (this.isBrowser) {
			if (document.getElementById('main-video11')) {
				video = document.getElementById('main-video11')
				video.pause();
			}
		}
		this.want_to_refund_confirm = false
		this.want_to_refund_cancel = false
		this.experienceDetailsPopup.hide();
	}

	onSwiper(event) {
		this.thumbsSwiper = event;
	}

	reviewClick() {
		if (this.isBrowser) {
			let reviewEle = document.querySelector('#reviews');
			let modalEle = document.querySelector('#experienceDetailsPopup .modal-content');
			if (!reviewEle?.classList.contains('show')) {
				let el: HTMLElement = this.review_accordion_element.nativeElement;
				el.click();
			}
			$("#modal-content").scrollTop(0);
			modalEle.scrollTo(0, 1650);
		}
	}

	autocompleteLocationSearch(event) {
		let requestBody = { 'search': event.query };
		this.locationService.locationAutocomplete(requestBody).subscribe(res => {
			if (res.response == 'success') {
				this.locationAutocompleteList = res.data;
			} else {
				this.locationAutocompleteList = [];
			}
		});
	}

	onSelectAutocompleteLocation(event) {
		switch (event?.value?.type) {
			case "location":
				if (event?.value?.value) {
					if (event?.value?.country_slug == null && event?.value?.state_slug == null) {
						this.router.navigate(['/continents/' + event?.value?.value]);
					} else if (event?.value?.country_slug == null && event?.value?.state_slug != null) {
						this.router.navigate(['/location-region/' + event?.value?.value]);
					} else if (event?.value?.country_slug != null && event?.value?.state_slug != null) {
						this.router.navigate(['/location-region/' + event?.value?.state_slug + '/' + event?.value?.value]);
					}
				}
				break;
		}
		this.autocomplete_location_search = '';
	}

	onLocationClick() {
		this.visitorService.getCurrent_location().then((res: any) => {
			if (typeof res?.address != 'undefined' && typeof res?.address?.address_components != 'undefined' && typeof res?.address?.address_components[6] != 'undefined' && typeof res?.address?.address_components[6]?.long_name != 'undefined') {
				let loc_region = res.address.address_components[6].long_name;
				loc_region = loc_region.toLowerCase();

				this.experience.getLocationPageContent(loc_region).subscribe(res => {
					if (res.response == 'success') {
						this.router.navigate(['/location-region/' + loc_region]);
					} else {
						this.router.navigate(['/location-region/united-states']);
					}
				});
			} else {
				this.router.navigate(['/location-region/united-states']);
			}
		});
	}

	getMobileDeviceName() {
		if (this.isBrowser) {
			var userAgent = window.navigator.userAgent || window.navigator.vendor;
			if (/windows phone/i.test(userAgent)) {
				this.mobileDeviceName = "Windows Phone";
			} else if (/android/i.test(userAgent)) {
				this.mobileDeviceName = "android";
			} else if (/iPad|iPhone|iPod/.test(userAgent)) {
				this.mobileDeviceName = "ios";
			} else {
				this.mobileDeviceName = "unknown";
			}
		}
	}

	name_error_msg() {
		this.name_error = false;
	}

	convertDateToUTC(date) {
		return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
	}

	expDetalPopupClose(event) {
		if (this.backfromRedemmeScheduleBtn) {
			this.backfromRedemmeSchedule();
		}
	}

	checkDateIsFutureDate(date) {
		let startDate = new Date(date);
		let currDate = new Date();

		if (startDate > currDate) {
			return true;
		}
		return false;
	}

	getPromotionalDetails() {
		this.isLoading = true;
		let requestBody = {
			"exp_id": this.main_exp_id,
		}
		this.PromotionalService.getPromotionalData(requestBody, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.calendarOptions = res.data;
				if (res.data.length > 0) {
					this.showPromoCalendar = true;
				} else {
					this.showPromoCalendar = false;
				}
			} else {
				this.calendarOptions = [];
				this.showPromoCalendar = false;
			}
			this.isLoading = false;
		});
	}

	parseDateToObject(dateStr) {
		let date = new Date(dateStr)
		return new Date(date.toISOString().slice(0, -1));
	}

	parseDateString(dateStr) {
		let d = new Date(dateStr)
		var mm = "" + (d.getMonth() + 1); if (mm.length == 1) { mm = "0" + mm; };
		var dd = "" + d.getDate(); if (dd.length == 1) { dd = "0" + dd; };
		var yy = "" + d.getFullYear();
		let date = yy + "-" + mm + "-" + dd;
		return date;
	}

	getExpQuantity(data) {
		let allow_book_quantity = data.allow_book_quantity;
		let seats = this.max_quantity_count;
		let book_denominator = data.book_denominator;
		let individual_price = data.for_individual_price;
		let individual_activity = this.experienceDetails?.individual_activity;
		let people_options = [];
		if (allow_book_quantity == 1) {
			if (Number(seats) > 0) {
				for (let i = 1; i <= Number(seats); i++) {
					if (individual_activity === 'no') {
						if (i == 1) {
							i++;
						}
					}
					let personName = i === 1 ? 'Person' : 'People';

					if (Number(book_denominator) > 1) {
						if (i % Number(book_denominator) === 0) {
							people_options.push({ 'key': i, 'value': i + ' ' + personName });
						}
					} else if (Number(individual_price) == 0) {
						if (i % 2 === 0) {
							people_options.push({ 'key': i, 'value': i + ' ' + personName });
						}
					} else {
						people_options.push({ 'key': i, 'value': i + ' ' + personName });
					}

					if (i == 10) {
						break;
					}
				}
			}
		} else {
			this.selected_people = 1;
		}
		this.book_quantity_options = people_options;
		if (this.experienceDetails?.price_label_dropdown?.length > 0) {
			this.book_quantity_options = this.experienceDetails?.price_label_dropdown
		}
	}

	selectQuantity(event) {
		let exp_id = this.experienceDetails.id;
		let people_count = JSON.parse(event.target.value).key;
		let name_label = JSON.parse(event.target.value).name;
		let quantity = JSON.parse(event.target.value).qty;
		this.selected_qty = quantity > 0 ? quantity : 1
		this.selected_name = name_label ? name_label : ''
		this.selected_people = people_count;
		if ((this.selected_qty && this.selected_qty == 0) || (this.selected_people && this.selected_people == 0)) {
			this.displayRequiredMessageForPeopleCount = true;
		} else {
			this.displayRequiredMessageForPeopleCount = false;
		}
		let requestBody = { 'exp_id': exp_id, 'people_count': people_count };
		this.requestedDate = "";
		this.booking_date_selected = ''
		var inputElement: any = document.getElementById('ngbDate');
		if (inputElement) {
			inputElement.value = '';
		}
		this.selected_hotel = 0;
		this.booking_slot_data = [];
		this.hotel_data = [];
		this.requires_visitors_details = [];
		this.booking_slot_index = '';
		this.rezdy_fields_data = [];
		this.fare_harbor_custom_data = [];
		this.fare_harbor_custom_user_data = [];
		this.rezdy_custom_fields = [];
		this.rezdy_custom_user_fields = [];
		this.hornBlowerCustomFields = [];
		this.linkTwistCustomFields = [];
		this.bokunFieldsPerBookingData = [];
		this.bokun_main_contact_fields = [];
		this.mainContactDetails = [];
		this.bokunFieldsPerPersonData = [];
		this.ventrata_custom_fields = [];
		this.ventrata_custom_user_data = [];
		this.validateBookNowButton(); // calls function or enable/disable Book Now button.

	}

	hideBanner(): void {
		this.isBannerHidden = false;
		if (this.isBrowser) {
			localStorage.setItem('isBannerHidden', this.isBannerHidden)
		}
	}

	loadScript(url) {
		return new Promise((resolve, reject) => {

			if (document.getElementById('tiktok-script')) {
				resolve("loaded");
			}
			const script = document.createElement("script");
			script.async = true;
			script.src = url;
			script.setAttribute('id', 'tiktok-script');

			script.onload = () => {
				resolve("loaded");
			};

			script.onerror = () => {
				reject("error");
			};

			document.head.appendChild(script);
		});
	}

	tiktokOpen(template: TemplateRef<any>) {
		this.loadScript('https://www.tiktok.com/embed.js').then(status => {
			if (status === 'loaded') {
				this.isTiktokShow = true;
			}
		})
		if (this.experienceDetails?.tiktok && this.experienceDetails?.tiktok.length > 0) {
			this.modalRef = this.modalService.show(template, { class: "modal-dialog tiktok_modal modal-dialog-centered" });
			this.experienceDetails?.tiktok.forEach(element => {
				element.filteredData = JSON.parse(element?.video_data)
			});
		}
	}

	openDropdownModal(template, expData) {
		this.buyVoucherPeople = 0
		var cartitems: any = [];
		this.voucher_select_data = {}
		if (this.isBrowser) {
			if (localStorage.getItem('cart_details')) {
				cartitems = JSON.parse(localStorage.getItem('cart_details'));
			}
		}
		let hasPresentOn = cartitems.find(
			function (el) {
				if (el.product_id === expData?.id) {
					return true;
				} else {
					return false;
				}
			}
		);
		if (!hasPresentOn) {
			this.dropdownRef = this.modalService.show(template, { class: "modal-dialog tiktok_modal modal-dialog-centered" });
		} else {
			this.toastr.errorToastr("Already added in your cart.", 'Error!');
		}
	}

	checkInstantDatesAvailable(date) {
		let formatDate = this.createDateFromNGB(date);
		if (this.experienceDetails.experience_booking_type != 7) {
			if (this.availableDatesArr.length > 0) {
				if (!this.availableDatesArr.includes(formatDate.toString())) {
					return true;
				}
				if (this.experienceDetails?.experience_booking_type == 1) {
					if (this.experienceDetails.block_dates?.length > 0) {
						let formatDate = this.createDateFromNGB(date);
						if (this.experienceDetails.block_dates.includes(formatDate)) {
							return true;
						}
						return true
					}
				}
				return false;
			} else {
				if (this.experienceDetails.block_dates?.length > 0 && this.experienceDetails?.experience_booking_type == 1) {
					let formatDate = this.createDateFromNGB(date);
					if (this.experienceDetails.block_dates.includes(formatDate)) {
						return true;
					}
					return false
				}
				return true;
			}
		}
	}

	getDateObject(dateObj) {
		return { "day": dateObj.getUTCDate(), "month": dateObj.getUTCMonth() + 1, "year": dateObj.getUTCFullYear() }
	}

	getMaxDateObj(dateObj) {
		return { "day": dateObj.getUTCDate(), "month": dateObj.getUTCMonth() + 1, "year": dateObj.getUTCFullYear() + 1 }
	}

	formatDate(date: NgbDateStruct): string {
		if (!date) return '';
		return `${date.year}-${date.month < 10 ? '0' + date.month : date.month}-${date.day < 10 ? '0' + date.day : date.day}`;
	}

	checkMaxAndMinDates() {
		let max = this.maximumDate['year'] + '-' + this.maximumDate['month'] + '-' + this.maximumDate['day'];
		let min = this.minimumDate['year'] + '-' + this.minimumDate['month'] + '-' + this.minimumDate['day'];
		if (new Date(max) < new Date(min)) {
			this.maximumDate = this.getMaxDateObj(new Date(max));
		}
	}

	formatBookingDate(date: NgbDateStruct): string {
		if (!date) return '';
		return `${date.year}-${date.month < 10 ? '0' + date.month : date.month}-${date.day < 10 ? '0' + date.day : date.day}`;
	}

	gratuityCheckout(value) {
		if (value) {
			this.gratuityAmount = value
		}
		if (this.gratuityAmount) {
			this.gratuityModal.hide()
			this.close()
			this.experienceDetails.gratuityPrice = this.gratuityAmount
			if (this.isBrowser) {
				localStorage.setItem('tip_data', JSON.stringify(this.experienceDetails))
			}
			this.router.navigateByUrl('gratuity-checkout')
		}
	}

	openGratuityModal() {
		this.gratuityAmount = ''
		this.gratuityModal.show()
	}

	scrollAndOpenDropdown() {
		if (this.dropdownElement && this.dropdownElement.nativeElement) {
			let el: HTMLElement = this.dropdownElement.nativeElement;

			if (el.offsetParent !== null) {
				el.focus();
				if (this.isBrowser) {

					const yOffset = el.getBoundingClientRect().top + window.scrollY;
					const offset = window.innerHeight / 4;
					setTimeout(() => {
						window.scrollTo({ top: (yOffset - offset), behavior: 'smooth' });
					}, 100);
				}
			}
		}
	}

	select_hotel(event) {
		if (this.OnlineSchedulingForm.get('hotel_pk').value) {
			this.selected_hotel = this.OnlineSchedulingForm.get('hotel_pk').value;
		} else {
			this.selected_hotel = event?.target?.value;
		}
		this.validateBookNowButton();
	}

	validateEmailTiquets(index: number, event: FocusEvent): void {
		const input = (event.target as HTMLInputElement).value.trim();
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email validation regex

		const emailField = this.requires_visitors_details[index]?.details.find(
			(field) => field?.key === 'email'
		);

		if (emailField) {
			if (!emailRegex.test(input)) {
				emailField.showError = true; // Show the error message
				this.emailErrorTiquets = true;
			} else {
				emailField.showError = false; // Hide the error message
				this.emailErrorTiquets = false;
			}
		}
		this.validateBookNowButton();
	}

	validatePerBookingEmaiCustomField(custom_data: any): void {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		const trimmedValue = (custom_data.value || '').trim();
		if (trimmedValue && !emailRegex.test(trimmedValue)) {
			custom_data.emailError = 'Please enter a valid email address.';
			this.emailErrorCustomField = true;
		} else {
			custom_data.emailError = null;
			this.emailErrorCustomField = false;
		}
		this.validateBookNowButton();
	}

	validatePerUserEmail(user_custom_field: any): void {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		const trimmedValue = (user_custom_field.value || '').trim();
		if (trimmedValue) {
			if (!emailRegex.test(trimmedValue)) {
				user_custom_field.emailError = 'Please enter a valid email address.';
				this.emailErrorCustomField = true;
			} else {
				user_custom_field.emailError = null;
				this.emailErrorCustomField = false;
			}
		} else {
			user_custom_field.emailError = null;
			this.emailErrorCustomField = false;
		}
		this.validateBookNowButton();
	}

	onMultiSelectChange(event: any, customField: any) {
		customField.value = event.value || []; // Ensure it remains an array
		this.validateBookNowButton(); // Revalidate button status
	}


	validateBasicFields() {
		let fieldError = 0;
		if (this.requestedDate == "") {
			fieldError++;
		}

		return fieldError;
	}

	validateBookNowButton(event?: any) {
		if (this.experienceDetails.instant_book == 1) {
			// validate basic fields like booking date and time except goCity because timeslot is not available for gocity.
			let basicFieldError = this.validateBasicFields();

			this.booking_type = this.OnlineSchedulingForm.get('booking_type').value;

			if (this.booking_type) {
				if (this.booking_slot_data?.length > 0 && (this.booking_slot_index == '' || this.booking_slot_index == undefined || this.booking_slot_index == null)) {
					basicFieldError++;
				}
			}

			switch (this.booking_type) {
				case 2:
					let fieldFareharborError = 0;
					// If user custom fields valid or not.
					if (this.fare_harbor_custom_user_data?.length > 0) {
						for (let userOptions of this.fare_harbor_custom_user_data) {
							for (let customField of userOptions.custom_field_values) {
								if (customField.is_required) {
									if (customField.value.trim() == '' || customField.value == null) {
										fieldFareharborError++;
									}
								}
							}
						}
					}

					// If user Time Slot custom fields valid or not.
					if (this.fare_harbor_custom_data?.length > 0) {
						for (let customField of this.fare_harbor_custom_data) {
							if (customField.is_required) {
								if (customField.field_type2 != 'checkbox' && customField.value.trim() == '' || customField.value == null) {
									fieldFareharborError++;
								} else if (customField.field_type2 == 'checkbox' && (customField.value == null || customField.value == false)) {
									fieldFareharborError++;
								}
							}
						}
					}

					// if hotel information is valid or not.
					if (this.hotel_data && this.hotel_data.length > 0) {
						if (this.selected_hotel == 0) {
							fieldFareharborError++;
						}
					}

					if (basicFieldError == 0 && fieldFareharborError == 0) {
						this.enableBookNowButton = true;
					} else {
						this.enableBookNowButton = false;
					}
					break;
				case 3:
					// If HornBlower user custom fields are valid or not.
					let fieldHornBlowerError = 0;
					if (this.hornBlowerCustomFields?.length > 0) {
						for (let userCustomFields of this.hornBlowerCustomFields) {
							for (let customField of userCustomFields) {
								if (customField?.is_required) {
									if (customField.field_type === 'Input' && (customField.value == null || customField.value.trim() === '')) {
										fieldHornBlowerError++;
									} else if (customField.field_type === 'Phone') {
										if (!customField.value || !customField.value.number || customField.value.number.trim() === '') {
											fieldHornBlowerError++;
										}
									} else if (customField.field_type === 'Email') {
										if (customField.value == null || customField.value.trim() === '') {
											fieldHornBlowerError++;
										}
									} else if (customField.field_type === 'Number') {
										if (customField.value == null) {
											fieldHornBlowerError++;
										}
									}
								}
							}
						}
					}
					if (basicFieldError == 0 && fieldHornBlowerError == 0 && this.emailErrorCustomField == false) {
						this.enableBookNowButton = true;
					} else {
						this.enableBookNowButton = false;
					}
					break;
				case 4:
					let fieldRezdyError = 0;
					// If Rezdy custom fields are valid or not.
					if (this.rezdy_custom_fields?.length > 0) {
						for (let customField of this.rezdy_custom_fields) {
							if (customField.requiredPerBooking) {
								if (customField.fieldType === 'String' && (customField.value == null || customField.value.trim() === '')) {
									fieldRezdyError++;
								} else if (customField.fieldType === 'Phone') {
									if (!customField.value || !customField.value.number || customField.value.number.trim() === '') {
										fieldRezdyError++;
									}
								} else if (customField.fieldType !== 'String' && customField.fieldType !== 'Phone' && customField.value == null) {
									fieldRezdyError++;
								} else if (customField.fieldType === 'List' && (customField.value == undefined || customField.value == null || customField.value == '')) {
									fieldRezdyError++;
								}
							}

							if (customField?.fieldType === 'String' && customField?.label == "First Name") {
								this.firstNameValue = customField?.value;
							}

							if (customField?.fieldType === 'String' && customField?.label == "Last Name") {
								this.lastNameValue = customField?.value;
							}

							let fullname = `${this.firstNameValue != undefined ? this.firstNameValue : ''} ${this.lastNameValue != undefined ? this.lastNameValue : ''}`;
							if (this.show_user_name_input == true) {
								this.OnlineSchedulingForm.get('name').setValue(fullname);
							}
						}
					}

					// If Rezdy user custom fields are valid or not.
					if (this.rezdy_custom_user_fields?.length > 0) {
						for (let userCustomFields of this.rezdy_custom_user_fields) {
							for (let customField of userCustomFields) {
								if (customField.requiredPerParticipant) {
									if (customField.fieldType === 'String' && (customField.value == null || customField.value.trim() === '')) {
										fieldRezdyError++;
									} else if (customField.fieldType === 'Phone') {
										if (!customField.value || !customField.value.number || customField.value.number.trim() === '') {
											fieldRezdyError++;
										}
									} else if (customField.fieldType !== 'String' && customField.fieldType !== 'Phone' && customField.value == null) {
										fieldRezdyError++;
									} else if (customField.fieldType === 'List' && (customField.value == undefined || customField.value == null || customField.value == '')) {
										fieldRezdyError++;
									}
								}
							}
						}
					}


					if (basicFieldError == 0 && this.emailErrorCustomField == false) {
						if (this.pickupLocationList.length > 0 && this.selectedLocation !== ''
							&& this.selectedLocation >= 0 && fieldRezdyError == 0) {
							this.enableBookNowButton = true;
						} else if (basicFieldError == 0 && this.pickupLocationList.length == 0 && fieldRezdyError == 0) {
							this.enableBookNowButton = true;
						} else {
							this.enableBookNowButton = false;
						}
					} else {
						this.enableBookNowButton = false;
					}
					break;
				case 5:
					let fieldTiqetsError = 0;
					const minPhoneLength = 5;
					if (this.requires_visitors_details && this.requires_visitors_details.length > 0) {
						for (let visitor of this.requires_visitors_details) {
							if (visitor.details && visitor.details.length > 0) {
								for (let field of visitor.details) {
									if (field && field.key !== 'phone' && (field.value == "" || field.value == null)) {
										fieldTiqetsError++;
									} else if (field && field.key === 'phone') {
										const phoneValue = field.value ? field.value.trim() : '';
										if (!phoneValue || phoneValue.length < minPhoneLength) {
											fieldTiqetsError++;
										}
									}
								}
							}
						}
					}
					if (basicFieldError == 0 && fieldTiqetsError == 0 && this.emailErrorTiquets == false) {
						this.enableBookNowButton = true;
					} else {
						this.enableBookNowButton = false;
					}
					break;
				case 6:
					if (basicFieldError == 0) {
						this.enableBookNowButton = true;
					} else {
						this.enableBookNowButton = false;
					}
					break;
				case 7:
					if (basicFieldError == 0) {
						this.enableBookNowButton = true;
					} else {
						this.enableBookNowButton = false;
					}
					break;
				case 9:
					if (basicFieldError == 0) {
						this.enableBookNowButton = true;
					} else {
						this.enableBookNowButton = false;
					}
					break;
				case 10:
					if (basicFieldError == 0) {
						this.enableBookNowButton = true;
					} else {
						this.enableBookNowButton = false;
					}
					break;
				case 11:
					let fieldVentrataError = 0;
					if (this.ventrata_custom_user_data?.length > 0) {
						for (let userOptions of this.ventrata_custom_user_data) {
							for (let customField of userOptions.custom_field_values) {
								if (customField.is_required) {
									if (customField.value.trim() == '' || customField.value == null) {
										fieldVentrataError++;
									}
								}
							}
						}
					}
					if (fieldVentrataError == 0 && basicFieldError == 0) {
						this.enableBookNowButton = true;
					} else {
						this.enableBookNowButton = false;
					}
					break;
				case 12:
					if (basicFieldError == 0) {
						this.enableBookNowButton = true;
					} else {
						this.enableBookNowButton = false;
					}
					break;
				case 13:
					let fieldLinkTwistError = 0;
					if (this.linkTwistCustomFields?.length > 0) {
						for (let userCustomFields of this.linkTwistCustomFields) {
							for (let customField of userCustomFields) {
								if (customField?.is_required) {
									if (customField.field_type === 'test' && (customField.value == null || customField.value.trim() === '')) {
										fieldLinkTwistError++;
									} else if (customField.field_type === 'phone') {
										if (!customField.value || !customField.value.number || customField.value.number.trim() === '') {
											fieldLinkTwistError++;
										}
									} else if (customField.field_type === 'email') {
										if (customField.value == null || customField.value.trim() === '') {
											fieldLinkTwistError++;
										}
									}
								}
							}
						}
					}
					if (basicFieldError == 0 && fieldLinkTwistError == 0 && this.emailErrorCustomField == false) {
						this.enableBookNowButton = true;
					} else {
						this.enableBookNowButton = false;
					}
					break;
				case 14:
					let fieldBokunError = 0;

					// Validate Per Booking Fields
					if (this.bokunFieldsPerBookingData?.length > 0) {
						for (let customField of this.bokunFieldsPerBookingData) {
							if (customField.required) {
								if (customField.dataType === 'SHORT_TEXT' || customField.dataType === 'LONG_TEXT') {
									if (!customField.value || customField.value.trim() === '') {
										fieldBokunError++;
									}
								} else if (customField.dataType === 'INT' || customField.dataType === 'DOUBLE') {
									if (!customField.value || isNaN(customField.value)) {
										fieldBokunError++;
									}
								} else if (customField.dataType === 'DATE' || customField.dataType === 'DATE_AND_TIME') {
									if (!customField.value) {
										fieldBokunError++;
									}
								} else if (customField.dataType === 'BOOLEAN') {
									if (customField?.value == undefined || customField?.value == null || customField?.value == false) {
										fieldBokunError++;
									}
								}
							}
						}
					}

					if (this.bokun_main_contact_fields?.length > 0) {
						for (let customField of this.bokun_main_contact_fields) {
							if (customField.required) {
								if (customField.dataType === 'SHORT_TEXT' || customField.dataType === 'LONG_TEXT') {
									if (!customField.value || customField.value.trim() === '') {
										fieldBokunError++;
									}
								} else if (customField.dataType === 'INT' || customField.dataType === 'DOUBLE') {
									if (!customField.value || isNaN(customField.value)) {
										fieldBokunError++;
									}
								} else if (customField.dataType === 'DATE' || customField.dataType === 'DATE_AND_TIME') {
									if (!customField.value) {
										fieldBokunError++;
									}
								}
							}
						}
					}

					// Validate Per Passenger Fields
					if (this.bokunFieldsPerPersonData?.length > 0) {
						for (let passenger of this.bokunFieldsPerPersonData) {
							for (let customField of passenger) {
								if (customField.required) {
									if (customField.dataType === 'SHORT_TEXT' || customField.dataType === 'LONG_TEXT') {
										if (!customField.value || customField.value.trim() === '') {
											fieldBokunError++;
										}
									} else if (customField.dataType === 'INT' || customField.dataType === 'DOUBLE') {
										if (!customField.value || isNaN(customField.value)) {
											fieldBokunError++;
										}
									} else if (customField.dataType === 'DATE' || customField.dataType === 'DATE_AND_TIME') {
										if (!customField.value) {
											fieldBokunError++;
										}
									} else if (customField.dataType === 'BOOLEAN') {
										if (customField.value == undefined || customField.value == null || customField.value == false) {
											fieldBokunError++;
										}
									}
								}
							}
						}
					}

					// Enable or disable the button based on validation
					if (basicFieldError == 0 && fieldBokunError === 0) {
						this.enableBookNowButton = true;
					} else {
						this.enableBookNowButton = false;
					}
					break;
			}
		}
	}

	scrollAndOpenDropdown2() {
		if (this.dropdownElement2 && this.dropdownElement2.nativeElement) {
			let el: HTMLElement = this.dropdownElement2.nativeElement;

			if (el.offsetParent !== null) {
				el.focus();
				if (this.isBrowser) {
					const yOffset = el.getBoundingClientRect().top + window.scrollY;
					const offset = window.innerHeight / 4;
					const targetScrollY = yOffset - offset;

					const startScrollY = window.scrollY;
					const distance = targetScrollY - startScrollY;
					const duration = 2000; // Duration of the scroll animation (e.g., 500ms)

					let start: number;

					// Function to animate the scroll incrementally
					function step(timestamp: number) {
						if (!start) start = timestamp; // Initialize the start time

						const elapsed = timestamp - start; // Calculate elapsed time
						const progress = Math.min(elapsed / duration, 1); // Normalize progress (between 0 and 1)

						// Calculate how much to scroll based on progress
						const shift = startScrollY + distance * progress;

						// Apply the scroll position
						window.scrollTo(0, shift);

						// If the animation hasn't reached the end, continue the animation
						if (progress < 1) {
							requestAnimationFrame(step);
						}
					}

					// Start the animation
					requestAnimationFrame(step);
					// el.click();
				}
			} else {
				console.log("Element is not visible or in the DOM.");
			}
		}
	}

	onCountryChange(event: any) {
		this.selectedCountry = event?.iso2;
	}

	formatPhoneNumber(event: any): void {
		if (this.selectedCountry === 'us') {
			const input = event?.target?.value.replace(/\D/g, '');
			if (input.length > 0) {
				let formatted = '';
				if (input.length <= 3) {
					formatted = `(${input}`;
				} else if (input.length <= 6) {
					formatted = `(${input.slice(0, 3)}) ${input.slice(3)}`;
				} else {
					formatted = `(${input.slice(0, 3)}) ${input.slice(3, 6)}-${input.slice(6, 10)}`;
				}
				this.OnlineSchedulingForm.controls['phone'].setValue(formatted, { emitEvent: false });
			}
		}
	}


	openModal() {
		if (this.isBrowser) {
			let cancelModal = document?.getElementById('cancelModal');
			if (cancelModal) {
				(cancelModal as any).style.display = 'none';
				cancelModal.classList?.remove('show');
				document.body.classList?.remove('modal-open');
				document.querySelector('.modal-backdrop')?.remove();
			}
		}
	}

	closeModal() {
		if (this.isBrowser) {
			let confirmCancelModal = document?.getElementById('confirmCancelModal');
			if (confirmCancelModal) {
				(confirmCancelModal as any).style.display = 'none';
				confirmCancelModal.classList?.remove('show');
				document.body.classList?.remove('modal-open');
				document.querySelector('.modal-backdrop')?.remove();
			}
		}
	}

	confirmCancel() {
		if (!this.selectedReason) {
			this.toastr.errorToastr("Please select a reason for cancellation.", 'Error!');
			return;
		}

		if (this.selectedReason === 'other' && !this.otherReason) {
			this.toastr.errorToastr("Please specify the other reason.", 'Error!');
			return;
		}

		if (this.selectedReason === 'other') {
			if (this.otherReason) {
				this.selectedReason = this.otherReason;
			}
		}
		// close modal
		this.cancelBooking();
	}

	toggleText(event: Event): void {
		event.preventDefault();
		this.isPolicyTextTruncated = !this.isPolicyTextTruncated;
	}

	select_location_bokun(event) {
	}

	redirectToNotifications() {
		// if(this.authUser?.role_id == 2) {
		// 	this.router.navigate(['/experience-settings'], { queryParams: { tab: 'notifications' } });
		// } else if (this.authUser?.role_id == 4) {
		// 	this.router.navigate(['/my-settings'], { queryParams: { tab: 'notifications' } });
		// } else  {
		// 	this.router.navigate(['/news-feeds'], { queryParams: { tab: 'notifications' } });
		// }
		this.router.navigate(['/news-feeds']);
	}

	getFieldLabel(fieldName: string): string {
		return fieldName
			.replace(/([A-Z])/g, ' $1')
			.replace(/^./, str => str.toUpperCase());
	}

	initializeVentrataCustomUserData() {
		this.ventrata_custom_user_data = [];

		for (let i = 0; i < this.selected_people; i++) {
			const customUserData = {
				custom_field_values: [] as any[]
			};

			// Create custom field values for each field
			this.ventrata_custom_fields.forEach((field, index) => {
				customUserData.custom_field_values.push({
					custom_field: field,
					label_title: this.getFieldLabel(field),
					field_type: 'text_input',
					is_required: true,
					value: ''
				});
			});

			this.ventrata_custom_user_data.push(customUserData);
		}

		this.initializeBookingExtra();
	}

	initializeBookingExtra() {
		this.booking_extra.ventrata_vistors = [];
		for (let i = 0; i < this.selected_people; i++) {
			const visitor: any = {};
			this.ventrata_custom_fields.forEach(field => {
				visitor[field] = '';
			});
			this.booking_extra.ventrata_vistors.push(visitor);
		}
	}

	onFieldChange(personIndex: number, fieldName: string, value: string) {
		// Update the booking_extra structure
		this.booking_extra.ventrata_vistors[personIndex][fieldName] = value;
		this.validateBookNowButton(value);
	}

	trim(value: string): string {
		return value ? value.trim() : '';
	}

	transformVentrataData() {
		const transformedVisitors = this.ventrata_custom_user_data.map(visitor => {
			const visitorObj: any = {};
			visitor?.custom_field_values.forEach(field => {
				visitorObj[field.custom_field] = field.value;
			});
			return visitorObj;
		});

		return transformedVisitors;
	}

}
